import ServerMode from './ServerENV'
import xlsicon from '../assets/images/xlsicon.svg'
import pngicon from '../assets/images/pngicon.svg'
import jpgicon from '../assets/images/jpgicon.svg'
import pdficon from '../assets/images/pdficon.svg'
import docicon from '../assets/images/docicon.svg'

export default class Config {
	constructor() {

		this.recurringfrequencyonce = '6255474d6a72c7009ac04046'
		this.recurringfrequencydaily = '625547776a72c7009ac04047'
		this.recurringfrequencyweekly = '625547d46a72c7009ac04048'
		this.recurringfrequencyhalfmonthly = '625547ee6a72c7009ac04049'
		this.recurringfrequencymonthly = '625547fc6a72c7009ac0404a'
		this.recurringfrequencybimonthly = '6255481b6a72c7009ac0404b'
		this.recurringfrequencyquaterly = '625548326a72c7009ac0404c'
		this.recurringfrequencyhalfyearly = '625548b86a72c7009ac0404d'
		this.recurringfrequencyyearly = '625548c66a72c7009ac0404e'
		this.recurringfrequencycustom = '63c92875288b2dea49e75459'
		//aman singh
		this.recurringfrequencyspecific = '685555af708b6f8292dee3fa'

		this.remoteattendancewebid = '621632cd6e7429b80322da0d'

		/********************************** Training and developement end ****************************************/

		this.s3_file_upload_region = 'ap-south-1'
		this.cognito_user_pool_region = "us-east-1"
		// this.cognito_user_pool_region = "ap-south-1" // hemang jani 29/5/25
		this.taskdetailModalSize = 1650 //Ami 22/05

		this.protocol = 'http://'  // http:// or https://
		this.servermode = ServerMode
		this.docroot = __dirname + '/'

		// color for my log
		this.Changed_Log = "#ff0a7d";

		this.Leave_Approve_Color = "#A4E0A3"
		this.Leave_Reject_Color = "#F7D0D0"
		this.Leave_Cancel_Color = "#f2f1fd"
		this.Leave_Pending_Color = "#fff3e0"
		this.Log_Total_Color = "#E6F7FB"

		this.Dark_Leave_Approve_Color = "#a4e0a326"
		this.Dark_Leave_Reject_Color = "#f7d0d026"
		this.Dark_Leave_Cancel_Color = "#424156"
		this.Dark_Leave_Pending_Color = "#fff3e026"
		this.Dark_Log_Total_Color = "#e6f7fb26"

		this.LogCalendar_Log_Ok_Color = "#1dab4526";
		this.LogCalendar_Leave_Color = "#0092c226";
		this.LogCalendar_Log_Error = "#ffb74d40";
		this.LogCalendar_Deleted_Log = "#d3080826";
		this.LogCalendar_RestrictedDay = "#8f050526";
		this.LogCalendar_Holiday = "#ffa60026";
		this.LogCalendar_Week_Off = "#5956e326";
		this.LogCalendar_Not_PA = "#b1b1b126";
		this.LogCalendar_Changed_Log = "#976af826";
		this.LogCalendar_CompanyOutSideLeave = '#ff0a7d26';
		this.LogCalender_LogReqPending = '#ffa60059';
		this.LogCalender_ShowLogReqPending = '#ffa600a6'

		this.Dark_LogCalendar_Log_Ok_Color = "#1dab4526";
		this.Dark_LogCalendar_Leave_Color = "#0092c226";
		this.Dark_LogCalendar_Deleted_Log = "#d3080826";
		this.Dark_LogCalendar_RestrictedDay = "#8f050526";
		this.Dark_LogCalendar_Holiday = "#ffa60026";
		this.Dark_LogCalendar_Week_Off = "#5956e326";
		this.Dark_LogCalendar_Not_PA = "#b1b1b126";
		this.Dark_LogCalendar_CompanyOutSideLeave = '#ff0a7d26';

		this.LogCalendar_Break = '#2f919126';
		this.WorkFromHome_Color = '#558DCA26'; // smit
		this.PartialDay_Color = '#880E8133'; // smit

		this.HomeLogs_Break = '#2f9191';

		//rohit-
		this.Allocated_Color = "#ffa60026"
		this.Availabel_Color = '#1dab4526'
		this.Broker_Color = '#ffb74d40'
		this.Retired_Color = '#d3080826'
		this.Occupied_Color = '#976af826'
		// -------JATIN Special Shift Calender Start ---------
		this.SpecialShiftCalendar_Log_Ok_Color = "#1dab4526";
		this.SpecialShiftCalendar_Deleted_Log = "#d3080826";
		this.SpecialShiftCalendar_Holiday = "#ffa60026";
		this.SpecialShiftCalendar_Week_Off = "#5956e326";
		this.SpecialShiftCalendar_Not_PA = "#e1e1e126";
		this.SpecialShiftCalendar_Changed_Log = "#976af826";
		this.Dark_SpecialShiftCalendar_Log_Ok_Color = "#1dab4526";
		this.Dark_SpecialShiftCalendar_Deleted_Log = "#d3080826";
		this.Dark_SpecialShiftCalendar_Holiday = "#ffa60026";
		this.Dark_SpecialShiftCalendar_Week_Off = "#5956e326";
		this.Dark_SpecialShiftCalendar_Not_PA = "#e1e1e126";
		// -------JATIN Special Shift Calender End ---------

		//color for mytotal hour priyanshi
		this.companyworkedhour = "#a4e0a326"
		this.overtime = "#ffcc8026"
		this.workedhour = "#f1a7a726"
		this.totalhour = "#c3c2f926"

		this.companyworkedhourdark = "#a4e0a326"
		this.overtimedark = "#ffcc8026"
		this.workedhourdark = "#f1a7a726"
		this.totalhourdark = "#c3c2f926"

		//Ami
		this.eventfirstlightcolor = "#ffcc8026"
		this.eventsecondlightcolor = "#b1b1b126"
		this.eventthirdlightcolor = "#f1a7a726"
		this.eventfourlightcolor = "#ffcc8026"
		this.eventfivelightcolor = "#b8b8b826"
		this.eventfirstcolordark = "#ffcc8026"

		//priyanshi Task sTATUS
		this.taskcompleteontime = "#ADB5BD"
		this.taskcompleteonearly = "#7AD47B"
		this.taskcompleteonlate = "#EC7F7F"

		//rohit-29/5/25
		this.homeCalendar_Log_Error = "#fb8c00";
		this.homeCalendar_Leave = "#0092C2";
		this.homeCalendar_Week_off = "#5956E3";
		this.homeCalendar_Holiday = "#FFA600";
		this.homeCalendar_Holiday_Present = "#976AF8";
		this.homeCalendar_NotP_A = "#D30808";
		this.homeCalendar_Log_ok = "#1DAB45";
		this.homeCalendar_Rejected_Log = "#D30808";
		this.homeCalendar_NotAvailable = '#cccccc';
		this.homeCalendar_Casual_Leave = '#2F9191';
		this.homeCalendar_Sick_Leave = '#FF0A7D';
		this.homeCalendar_Compensatory_Leave = '#E65100';
		this.homeCalendar_WFH = '#99B0FC';

		//  software level configuration 
		this.sessionname = 'polycafe_27102021'
		this.adminutype = '622ed36cbe213c85a88da9a0'

		// Expiry for S3 presigned url ~ Utsav
		this.presignedurlexpiration = 300


		this.subdomainname = 'instanceit'

		this.encryptdata = false
		this.encryptSocketData = false

		this.yesbutton = 'Yes'
		this.nobutton = 'No'
		this.copysidebar = 'Copy'
		this.savesidebar = 'Create' // button name
		this.createandaddmore = 'Create & Add More'
		this.addsidebar = 'Add'
		this.savesidebarname = 'Create'
		this.adddatabuttonname = 'Create'
		this.createtaskbutton = 'Create Task'
		this.downloadbuttonname = 'Download'
		this.resetsidebar = 'Reset'
		this.closesidebar = 'Close'
		this.cancelsidebar = 'Cancel'
		this.updatesidebar = 'Update' // button name
		this.updatesidebarname = 'Update'
		this.applyfiltersidebar = 'Apply'
		this.cancelfiltersidebar = 'Close'
		this.approveSidebar = 'Approve'
		this.deleteimage = 'deleteImage'
		this.done = 'Done'
		// harsh 2-2-2023
		this.applytoallsidebar = 'Apply To All'
		// harsh 23-2-2023
		this.clearsidebar = 'Clear'

		this.updatemyprofile = 'Update Profile'
		this.changepassword = 'Change Password'

		this.submitbutton = 'Submit'
		this.generatereport = 'Generate Report'
		this.generatelink = 'Generate Link'
		this.generateletter = 'Generate Letter'	//  | Deep Dungarani  ~ 2025-10-09
		this.nextbutton = 'Next'
		this.backbutton = 'Back'
		this.previousbutton = 'Previous'
		this.previewbutton = 'Preview'
		this.stylebutton = 'Style'
		//pravin 21-03-2025
		this.generatebutton = 'Generate'
		this.recalculatebutton = 'Recalculate'
		this.proceedbutton = 'Proceed'

		// for disconnect modal		// Deep Dungarani  ~ 2025-04-23 ~ 04:06 PM
		this.canceldisconnect = 'Close'
		this.confirmdisconnect = 'Confirm'

		this.assignasset = 'Assign Asset(s)'	//  | Deep Dungarani  ~ 2025-06-16 ~ 11:22 AM

		// Resource Request | Deep Dungarani ~ 2025-05-07 ~ 017:16 PM
		this.closeresourcebutton = 'Close Resource Request'
		this.rejectresourcebutton = 'Reject Resource Request'
		this.rejecthandoverbutton = 'Reject Handover Request'	//  | Deep Dungarani  ~ 2025-09-05 ~ 12:19 PM
		this.rejectholdsalarybutton = 'Reject Hold Salary Request'	//  | Deep Dungarani  ~ 2025-09-05 ~ 12:19 PM
		this.approveholdsalarybutton = 'Approve Hold Salary Request'	//  | smit surani  ~ 2025-09-05 ~ 12:19 PM
		this.holdsalaryreason = 'Add Hold Salary Reason'	// smit surani
		this.voidsalaryreason = 'Add Void Salary Reason'	// smit surani
		this.fetchmsgtemplate = 'Fetch Message Template'
		// for delete modal
		this.canceldelete = 'Close'
		this.cancelreset = 'Close'
		// for delete modal
		this.confirmdelete = 'Confirm'
		this.nextstage = 'Next Stage'
		this.confirmreset = 'Reset'
		this.retakebutton = 'Re Take'

		this.completebtn = 'Complete'	//  | Deep Dungarani  ~ 2025-12-27
		this.savebutton = 'Save'
		this.closebutton = 'Close'
		this.cancelbutton = 'Cancel'
		this.printbutton = 'Print'
		this.commentbutton = 'Comment'
		this.completeinterviewstage = 'Complete Interview'
		this.saveorderbutton = 'Save Order'
		this.savecommentbutton = 'Save Comment'
		this.addcommentbutton = 'Add Comment'
		this.nobutton = 'No'
		this.okgotitbutton = 'Ok Got It'
		this.reviewbutton = 'Review'
		this.deletebutton = 'Delete'
		this.appname = 'BIZCOMPASS'
		// not a bug button
		this.closeissue = 'Close'
		this.reopenissue = 'Reopen'

		// form loading text
		this.formloadingtext = 'Loading ....'

		this.send = "Send"
		this.crop = "Crop" //  | Om Z  🌝🌝🌝 ~ 2024-11-07 ~ 04:06 PM
		this.sending = "Sending..."
		this.otp = "Send OTP"
		this.signin = "Sign In"
		this.signup = "Sign Up"
		this.loginwithOTP = "Login With OTP"
		this.generateslip = "Generate Slip"
		this.notes = "View Notes"
		this.dismiss = "Dismiss"
		this.logout = "Log Out"
		this.proceed = "Proceed"
		this.calculatepart = "Calculating Part(s)"
		this.updatedecription = "Update Description"
		this.adddecription = "Add Description"
		this.assign = "Assign"
		this.repair = "Repair"
		this.replace = "Replace"
		this.allocate = "Allocate"
		this.deallocated = "Deallocated"
		this.deallocate = "Deallocate"
		this.verify = "Verify"
		this.managerreview = "Manager Review"
		this.performancereview = "Performace Review"
		this.krakpireview = "KRAs / KPIs Review"
		this.reviewperformance = "Review Performance"
		this.reviewrecived = "Review Received"
		this.reviewgiven = "Review Given"
		this.allread = "Mark All As Read"
		this.withdrawresignation = "Withdraw Resignation"
		this.addrequest = "Add Request"
		this.notnowbutton = "Not now"
		this.assignshifts = "Assign Shifts"
		this.override = "Override"
		this.assignpolicy = "Assign Policy"
		this.assignproject = "Assign Project"
		this.dots = "Dots"
		this.lines = "Lines"
		this.cross = "Cross"
		this.continuebutton = "Continue"
		this.overviewbutton = "Overview"
		this.analyticsbutton = "Analytics"
		this.addfromtemplate = "Add From Template"
		this.history = "History"
		this.logs = "Log(s)"
		this.merge = "Merge"
		this.renewbutton = "Renew Now"
		this.assignelicense = "Assigned License"
		this.completebutton = "Complete"
		this.completemeetingbutton = "Complete Meeting"
		this.schedulebutton = "Schedule Forcefully"
		this.selectbutton = "Select"
		this.startnow = "Yes, Start Now"
		this.stopbutton = "Stop"
		this.resendbutton = "Resend"
		this.bulkactionbutton = "Bulk Action"
		this.verifyuploadeddocuments = "Verify Uploaded Document(s)"
		this.calculateemi = "Calculate EMI"
		this.recordpayment = "Record Repayment"
		this.pauseinstallment = "Pause Installment"
		this.editbutton = "edit"
		this.senctionbutton = "Sanction" // | ~ Changed By Pranav Rangunwala | Senction => Sanction
		this.acceptbutton = "Accept"
		this.approvebutton = "Approve" //  | Utsav ~  2025-01-17 ~ 04:34 PM
		this.rejectbutton = "Reject"
		this.notifyrejection = "Notify Rejection"	//  | Deep Dungarani  ~ 2025-08-14
		this.pendingbutton = "Pending"	//  | Deep Dungarani  ~ 2025-07-10 ~ 09:56 AM
		this.allowbutton = "Allow"  //  | Pravin ~  18-04-2025 ~ 03:26 PM
		this.viewrequestowner = "View Recruiter(s)" //  | Deep Dungarani  ~ 2025-08-19
		this.notallowbutton = "Not Allow"
		this.sendmailbutton = "Send Mail"
		this.pausebutton = "Pause"
		this.playbutton = "Play"
		this.savewithsettlement = "Save with Settlement"
		this.inbutton = "In"
		this.outbutton = "Out"
		this.okbutton = "Ok"
		this.exportdatabutton = "Export Data"
		this.neverbutton = "Never"
		this.uploadbutton = "Upload"
		this.uploadallbutton = "Upload All"
		this.probationexitbutton = "Probation Exit"
		this.addcandidatebutton = "Add Candidate"
		this.addrowbutton = "Add Row"
		this.lockproject = "Lock Project"
		this.generatehistorybutton = "View Generate History"
		this.addremarkbutton = "Add Remark"
		this.duplicatecopy = "Duplicate Copy"
		this.yescompletebutton = "Yes, Complete"
		this.findbutton = "Find"
		this.assignforcefully = "Assign Forcefully"
		this.readlessbutton = "Read Less"
		this.readmorebutton = "Read More"
		this.addreminderbutton = "Add Reminder"
		this.showrecurrencetask = "Recurrence Task(s)" // smit surani
		this.showremainderandrecurrenceviwe = "Reminder and Recurrence" // smit surani
		this.addrecurrencebutton = "Add Recurrence" 
		this.recurrencebutton = "Recurrence"
		this.testcasebutton = "Testcase"
		this.testbutton = "Test"
		this.addmorebutton = "Add More"
		this.loginbutton = "Log In"
		this.submittestbutton = "Submit Test"
		this.viewviolationsbutton = "View Violation(s)"	//  | Deep Dungarani  ~ 2025-08-13
		this.finishbutton = "Finish"
		this.starttestbutton = "Start Test"
		this.clearansbutton = "clear answers"
		this.getdatabutton = "Get Data"
		this.fetchdatabutton = "Fetch Data"
		this.resetdatabutton = "Reset Data"
		this.transferfollowupbutton = "Transfer FollowUp"
		this.addandaddmorebutton = "Add and Add More"
		this.comparecandidatebutton = "Compare Candidate"
		this.recollectbutton = "Re-collect"
		this.pointtablebutton = "Points Table"
		this.addpersonbutton = "ADD PERSON"
		this.sendrecognitionbutton = "Send Recognition"
		this.allbutton = "All"
		this.postbutton = "Post"
		this.addratingbutton = "Add Rating"
		this.resolveticketbutton = "Resolve Ticket"
		this.createstagebutton = "Create Stage"
		this.snoozebutton = "Snooze"
		this.redirectnowbutton = "Yes, Redirect Now"
		this.attendancebutton = "Attendance"
		this.startnowbutton = "Start Now"
		this.forgetpasswordbutton = "Forget Password"
		this.availableassetsbutton = "Available Asset(s)"
		this.seattransferbutton = "Seat Transfer"
		this.mergeassest = "Merge Asset"
		this.swapassest = "Swap Asset" // JATIN 2/04/2025
		this.replaceassest = "Replace Asset"
		this.viewmoredetailsbutton = "View More Details"
		this.viewmoreprojectbutton = "View More Projects"
		this.viewmoresprintbutton = "View More Sprints"
		this.fetchspend = "Fetch Spend"
		this.adddeclaration = "Add Declaration"
		this.bookroom = 'Book A Room'
		this.copylink = 'Copy Link'
		this.rename = 'Rename'
		this.aggrementLetterLabel = 'Agreement Letter'
		this.appoinmentLetterLabel = 'Appointment letter'
		this.offerLetterLabel = 'Offer Letter'
		this.otherLetterLabel = 'Other Letter'
		this.experienceLetterLabel = 'Experience Letter'
		this.terminationLetterLabel = 'Termination Letter'
		this.relievingLetterLabel = 'Relieving Letter'
		this.copyherebutton = 'Copy Here'
		this.moveherebutton = 'Move Here'
		this.addnew = 'Add New'
		this.foldername = 'Folder'
		this.uploadfolder = 'Upload Folder'
		this.uploadfile = 'Upload File'
		this.linkbtn = 'Link'
		this.createhierarchy = 'Create Hierarchy'
		this.downloadFile = 'Download File'
		this.tryagain = 'Try Again'
		this.fullday = 'Full Day' //ROHIT-03/06/25
		this.importbtn = "Import"
		this.assignbutton = "Assign"
		this.unassignbutton = "Un-Assign"
		this.resendotp = "Resend OTP "
		this.reloadpagebtn = 'Reload Page'
		this.saveasdraft = 'Save as Draft'
		this.fileExtensionPattern = /\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/gmi

		this.textFileTypes = ['txt', 'csv', 'json', 'html', 'xml']
		this.officeFileTypes = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx']
		this.videoFileTypes = ['mp4', 'webm', 'ogg']
		this.imageFileTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp']

		// form loading text
		this.completeconfigurationtext = 'Please complete this configurations : '

		this.dummyid = '625d5ed5220ccd5a20904f79'
		this.crmgeneralid = 'General' //  | Deep Dungarani  ~ 2025-07-28
		this.commonflowid = '673c36dd2ad34591c4623852' // joining procedure flow --> common flow id | Nirzar Gabani 💀 ~  2024-11-19 ~ 12:29 PM
		this.allcompanyid = '679afe5380f4a525528f008e'

		// used in image / file type input's preview 
		this.defaultimageupload = 'https://bizcompass.s3.ap-south-1.amazonaws.com/defaultImageUpload.svg%2Bxml'
		this.defaultCanidateimgupload = 'https://bizcompass.s3.ap-south-1.amazonaws.com/IIS/defaultCandidateimgupload.png'

		// bizcompass Url
		this.bizcompassurl = 'https://www.bizcompass.in/'
		this.bizcompassprivacypolicyurl = 'https://www.bizcompass.in/privacy-policy'              // Pravin ~ 20-05-2025 ~ 11:34 AM
		this.bizcompasstermsofuseusrl = 'https://www.bizcompass.in/terms-of-use'
		//company Type configuration

// Approvals Hierarchy tab id's
		this.defaultapprovalsid = "680b0568a63e86e414d750a5"
		this.leaveapprovalsid = "680b0621a63e86e414d750a6"
		this.logapprovalsid = "680b06daa63e86e414d750a7"
		this.latearrivalapprovalsid = "680b06e6a63e86e414d750a8"
		this.overtimeapprovalsid = "680b06eda63e86e414d750a9"
		this.timelogapprovalsid = "680b0701a63e86e414d750aa"
		this.employeeupdateapprovalsid = "680b070aa63e86e414d750ab"
		this.declarationapprovalsid = "680b0710a63e86e414d750ac"
		this.lettersapprovalid = "684f91e68b719d1e0fa0f2f2"
		this.resourcerequestapprovalsid = "6851769260f861adf6d0a9a5"
		this.approvalsreportingpersonid = "684be39ffba9a02e989cf9b3"
		this.wfhapplicationapprovalsid = "6881e3223e991ec10d8d4885"
		this.partialdayapplicationid = "6889efd6e047b55daf1fd969" // smit
this.exitapplicationid = "68afd23c12c12b6f3ac0a3a8" // smit
		this.handoverapprovalsid = "68b5946ae6e8d7035c506844" //  | Deep Dungarani  ~ 2025-09-02
		this.krakpiapprovalsid  = "68c123a3f9a0fbd44e8c3248" //  Renish Salakhana ~ 2025-09-10 ~ 12:32 PM
		this.payrollprocessapprovalsid  = "69202f67d15efcd00baf0f78" //  smit surani ~ 2025-11-21 ~ 12:32 PM
		this.holdsalaryapprovalsid  = "6926d1bd3cb2fa041650f663" //  smit surani ~ 2025-11-26 ~ 12:32 PM

		this.NODE_TYPES = { // Utsav - 20-06-25 ~ Approvals Hierarchy
			ROOT: 0,
			DEPARTMENT: 1,
			DESIGNATION: 2,
			EMPLOYEE: 3,
			SUB_DEPARTMENT: 4,
			REPORTING_PERSON: 5,
			COMPANY_HEAD: 6,
			BRANCH_HEAD: 7,
			USER_ROLE: 8,
			DEPARTMENT_HEAD: 13,	//  | Deep Dungarani  ~ 2025-09-08 ~ 11:34 AM
		}

		// static data for send mail option in email template for cs and bcc | Nirzar Gabani 💀 ~  2025-10-07 ~ 06:14 PM
		this.sendMailPerosn = [
			{
				label: "Company Head",
				value: this.NODE_TYPES.COMPANY_HEAD // 6
			},
			{
				label: "Branch Head",
				value: this.NODE_TYPES.BRANCH_HEAD // 7
			},
			{
				label: "Reporting Person",
				value: this.NODE_TYPES.REPORTING_PERSON // 5
			},
			// {
			// 	label: "Employee",
			// 	value: this.NODE_TYPES.EMPLOYEE // 3
			// }
		]

		//series
		this.supportticketSeries = '64e6e36763ed014467a6474d'
		this.todoSeries = '65b1e523021715d382222ef7'

		this.elementtypebranchid = '623bee87278a8e4326f1adec' // don't remove

		this.applicationseriestypeid = '623bee13278a8e4326f1ade7'
		this.salaryseriestypeid = '62f9d6fe7e085df56275a840'
		this.advancesalaryseriestypeid = '62fb330fa62402f26acaba0b'
		this.paymentseriestypeid = '62fb7d24a62402f26acaba12'

		// For API Authorizarion - Method Pending
		this.noauth = '6262536b1a6be3afecd81d19'
		this.inheritauthfromparent = '6262532e1a6be3afecd81d18'
		this.apikey = '626253891a6be3afecd81d1a'
		this.bearertoken = '6262539b1a6be3afecd81d1b'
		this.basictoken = '626253a41a6be3afecd81d1c'
		this.digest = '626253b61a6be3afecd81d1d'
		this.oauth1 = '626253c11a6be3afecd81d1e'
		this.oauth2 = '626253cb1a6be3afecd81d1f'
		this.hawkauthentication = '626253d31a6be3afecd81d20'
		this.awssignature = '626253db1a6be3afecd81d21'
		this.ntlmauthentication = '626253e81a6be3afecd81d22'
		this.akamaiedgergrid = '626253f91a6be3afecd81d23'
		// followupmode types
		this.followupemail = "637331709e5dd7ef7f96736b"
		this.followupmessage = "637336009e5dd7ef7f96736d"
		this.followupcall = "63733a439e5dd7ef7f96736e"
		this.oneononetype = "637335c69e5dd7ef7f96736c"
		this.percentageid = "6232f8225abdc570017dd004"

		// project
		this.unassignedcolumnid = "63bfce31ddbfb755cf714ec0"
		this.crmstatuskanbancompletecolumn = "66614c49867ade3c97fe0e8b"
		this.crmstatuskanbanopencolumn = "66614c36079add42e01e7168"
		// sprint
		this.taskwithoutstartdate = "Task Without Start Date"
		// task
		this.remindertypeweeklyid = '625531b96a72c7009ac04041'

		// project
		this.billingmethod = "Hour Basis"
		this.billingmethodid = "6241ab54b99df1ba673d9e0a"
		//aman
		this.fixedbillingmethod = "Fixed"
		this.fixedbillingmethodid = "6241ab88b99df1ba673d9e0b"

		// default projects _id
		this.defaulttrainingprojectid = '658cfcc05971254ced172131'

		// default projects module _id
		this.defaulttrainingprojectmoduleid = '658d04565971254ced178e1a'

		// employeeperformancereview 
		this.employeeperformancereview = '65cb3ac60ec639480c62aa94'
		this.employeemanagerreview = '6458c72014ff4e92c8883b68'

		// document copy original id
		this.documentcopyoriginalid = '62301c5621ab273db1c1d1c8'

		//default insuranceid
		this.insuranceid = '666973507ee5c258604c565d'

		this.bizsupportunassignedcoulmnid = "6776458b2770d4614557ed3c"

		// static agreement type id

		this.employeeagreementtypeid = '626f8250ee571a2feb7f4d87'
		this.vendoragreementtypeid = '626f826eee571a2feb7f4d88'
		this.customeragreementtypeid = '626f8278ee571a2feb7f4d89'
		this.employeeloanagreementtypeid = '64991865b309a574c46cd5db'

		this.specialweekoffshiftid = "66f15d30328d0a67d0418b70"
		this.customweekoffshiftid = "64ae7799534c70aced1dbd82"

		//priyanshi --> payroll 
		this.allowancepayrollheader = '6231bb1da7f4d06428c30433'
		this.basicpayrollheader = '6231b1b7a7f4d06428c30417'
		this.bonuspayrollheader = '67750f3ff8bd99d5b48a7ea1'

		//payroll array for all deductions priyanshi 
		this.pfkeys = ['deductionemployeeedli', 'deductionemployeeepf', 'deductionemployeeepfadmin', 'deductionemployeeeps', 'deductionemployeredli', 'deductionemployerepf', 'deductionemployerepfadmin', 'deductionemployereps']
		this.tdskeys = ['incometds', 'deductiontds']
		this.esickeys = ['deductionemployeeesic', 'deductionemployeresic', 'deductionemployeresicadmin']
		this.lwfkeys = ['dedelwf', 'dederlwf']
		this.ptkeys = ['deductionprofessionaltax']

		this.overridepfkeys = ['overridedeductionemployeeedli', 'overridedeductionemployeeepf', 'overridedeductionemployeeepfadmin', 'overridedeductionemployeeeps', 'overridedeductionemployeredli', 'overridedeductionemployerepf', 'overridedeductionemployerepfadmin', 'overridedeductionemployereps']
		this.overridetdskeys = ['overrideincometds', 'overridedeductiontds']
		this.overrideesickeys = ['overridedeductionemployeeesic', 'overridedeductionemployeresic', 'overridedeductionemployeresicadmin']
		this.overrideptkeys = ['overridedeductionprofessionaltax']
		this.overridelwfkeys = ['overridededelwf', 'overridedederlwf']

		// UnAssigned Lead
		this.unAssignedLeadStatus = {
			id: '676262170b7aeedbd12fcca2',
			name: 'UnAssigned'
		}

		// bizcompass configuration
		this.mandatoryconfigurationsalias = 'mainconfig'

		//epf valurtype id
		this.valueinrupee = '6232f8185abdc570017dd003'
		this.valueinpercentage = '6232f8225abdc570017dd004'


		//csv configuration
		this.csvendrow = 1000

		// google map common keys
		this.defaultLocation = { lat: 20.5937, lng: 78.9629 }
		this.getGeocodeUrl = 'https://maps.googleapis.com/maps/api/geocode/json?latlng'
		this.mapFields = ["latitude", "longitude", "fulladdress", "address", "country", "state", "city", "zipcode"]

		// google font url
		this.googlefonturl = 'https://www.googleapis.com/webfonts/v1/webfonts?key='

		// for show meta data - url | Nirzar Gabani 💀 ~  2025-05-28 ~ 03:30 PM
		this.metadataurl = 'https://api.microlink.io/?url='

		//priyanshi --> socket 
		this.callSocketApi = false
		this.encryptSocketData = false
		this.useSocketForAPI = false

		// ********************************************************************************************* Menu Alias Start **********************************************************************

		this.openingalias = 'openingmaster'
		this.shiftcalendaralias = 'specialshiftcalendar' //  | Om Z  🌝🌝🌝 ~ 2024-08-13 ~ 03:45 PM
		this.quotesalias = [
			'“If you’re the smartest person in the room, for sure you’re in the wrong room.”',
			'“If you talk about it, it’s a dream, if you envision it, it’s possible, but if you schedule it, it’s real.”',
			'“The best way to predict the future is to create it.”',
			'“Life is not about waiting for the storm to pass; it is about learning to dance in the rain.”',
			'“The pessimist sees difficulty in every opportunity. The optimist sees opportunity in every difficulty.”',
			'“Code is like humor. When you have to explain it, it’s bad.”',
			'“I would love to change the world, but they won’t give me the source code.”',
			'“The code works on my machine." Famous last words of a developer”',
			'“Programmers never die; they just go offline.”',
			'“Why do Java developers wear glasses? Because they can’t C#!”',
			'“HR: The only department that still believes in the power of PowerPoint presentations.”',
			'“HR: Where "confidential" is just another word for "office gossip".”',
			'“Software Developer: My code is bug-free. HR: Hold my coffee.”',
			'“Debugging: The art of fixing something until it’s broken in a completely new way.”',
			'“Developers: We make software run smoothly, but our own lives? Well, that’s another story.”',
			'“Developers: We create bugs just to fix them later. Job security, you know.”',
			'“A developer’s code is like a fine wine - it takes time to mature, and sometimes it turns into vinegar.”',
			'“Testers: The only people who can find a bug in a perfectly blank screen.”',
			'“Testing is like being a detective, except the evidence is in the code, and the suspects are the developers.”',
			'“Graphic designers: The only people who can spend hours debating between 50 shades of blue.”',
			'“Being a graphic designer is so easy. Just make things look pretty and call it art.”',
			'“Marketing team: We can make even the most boring product sound like the next big thing!”',
			'“Backend developers: Because life is too short to worry about making things look pretty.”',
			'“Who needs a stable website when you can have a fancy, animated loading spinner? Thanks, frontend development!”',
			'“CSS is like a box of chocolates. You never know what you’re going to get... or how it will break your layout.”',
		] // quotes used for Reward and recognization | Om Z  🌝🌝🌝 ~ 2024-08-12 ~ 10:26 AM

		// ********************************************************************************************* Menu Alias End **********************************************************************
		this.employeemanagement = 'employee'
		this.personrunningtimeralias = 'personrunningtimer'

		//for replace weburl with pmsweburl in some api which include in this arr
		this.reqUrlArr = [
			'/task',
			'/taskkanban',
			'/taskpersonkanban',
			'/task/add',
			'/task/update',
			'/task/bulkassign',
			'/taskemployee',
			'/task/delete',
			'/tasknotabug',
			'/globaltimer',
			'/taskstopreminder',
			'/taskdocumentadd',
			'/taskdocumentdelete',
			'/workhourotvalid',
			'/reopentask/add',
			'/taskimportcsv',
			'/taskplannigofday',
			'/projectdeletevalidation',
			'/sprintpersontask',
			'/sprint',
			'/sprint/add',
			'/sprint/update',
			'/sprinttaskassign',
			'/sprintanalytics',
			'/sprintdetailview',
			'/sprintcomplete',
			'/taskaddinnewsprint',
			'/project',
			'/reportproject',
			'/projectaverage',
			'/project/add',
			'/project/update',
			'/project/delete',
			'/checkremoveperson',
			'/projectemployees',
			'/projectflowstatustasks',
			'/changeprojectdata',
			'/timelogrequest',
			'/timelogrequest/add',
			'/timelogrequest/update',
			'/timelogrequest/delete',
			'/timelog',
			'/timelog/add',
			'/timelog/update',
			'/timelog/delete',
			'/personrunningtimer',
			'/projectpersonrunningtimer',
			'/timerunningstatus',
			'/menualtimelog/update',
			'/menualtimelog/delete',
			'/approvemenualtimelog',
			'/reviewtimelogrequest',
			'/updatetimeloghistory',
			'/myissuedetailgraph',
			'/mytaskdetailgraph',
			'/myissuewidget'
		]

		//import alias
		this.importleadurl = 'crm/importlead'
		this.importasseturl = 'assetscsv'
		this.importprojecturl = 'projectimportcsv'
		this.importtestcaseurl = 'testcase/import'
		this.importquestionurl = 'questionimportcsv'
		this.importcandidateinquiryurl = 'candidateinquiryimportcsv'
		this.importopeningurl = 'openingcsvimport'   // Pravin ~ 14-05-2025 ~ 2:35 PM
		this.importresourcerequesturl = 'resourcerequestcsvimport' //  Aniket Bhesaniya 🛠️  ~ 2025-06-30 ~ 10:36 AM
		this.importcontacturl = 'crm/importleadcontact'   // Pravin ~ 05-06-2025 ~ 12:59 PM 
		this.importleadaccount = 'crm/importleadaccount'   // smit ~ 20-08-2025 ~ 12:59 PM 
		this.importkpiurl = 'kpicsvimport' //  Renish Salakhana ~ 2025-09-10 ~ 015:10 PM
		this.importkraurl = 'kracsvimport' //  Renish Salakhana ~ 2025-09-10 ~ 015:10 PM
		this.importpersoninvestment = 'personinvestment/bulkadd' //  Renish Salakhana ~ 2025-09-10 ~ 016:45 PM

		// ********************************************************************************************* Menu PageName Start ******************************************************************
		this.masterTitleName = {
			[this.openingalias]: 'Opening(s)'
		}

		// ********************************************************************************************* Menu PageName End ********************************************************************

		this.FNFSettlementStageId = {
			"Salary_Leave_Encashment" : "68b825a234a7997154ef16af",
			"Asset_Recovery_Damage" : "68b825b734a7997154ef16b0",
			"Reimbursement_Expense" : "68b825d234a7997154ef16b1",
			"Other_Settlement" : "68b825e534a7997154ef16b2",
			"Final_FNF" : "68b825fc34a7997154ef16b3"
		}

		// seriesPrefix & seriesElementArray for series master | Pravin 23-04-2025 ~ 10:00 AM 
		this.seriesPrefix = {
			'Application': 'APP',
			'Employee': 'EMP',
			'Opening': 'OPN',
			'Task': 'TSK',
			'Loan': 'LAN',
			'Salary': 'SLY',
			'Advance Salary': 'ASLY',
			'Payment': 'PMT',
			'Asset': 'AST',
			'Item': 'ITM',
			'Support Ticket': 'SPT',
			'Purchase': 'PRH',
			'Sale Invoice': 'SCE',
			'Purchase Return Invoice': 'PRI',
			'Sale Return Invoice': 'SRI',
			'Todo Task': 'TDT',
			'Intern': 'INT',
			'Lead': 'LED',
			'Lead Quotation': 'LDQ',
			'Consultant': 'CST',
			'BizCompass Support Ticket': 'BST',
			'Travel': 'TVL',
			'Apprentice': 'APT',
			'Trainee': 'TR',
			'Consultation Booking': 'CNB',
		}

		this.seriesElementIds = {
			companyprefix: '623bee66278a8e4326f1adea',
			branchprefix: '623bee87278a8e4326f1adec',
			currentfySlash: '623beeda278a8e4326f1aded',
			currentfyDash: '623beee7278a8e4326f1adee',
			currentmonth: '623beefe278a8e4326f1adef',
			currentyearYY: '628f1bd20af5f3828824f8c0',
			currentyearFull: '623bef1d278a8e4326f1adf0',
			separatorDash: '623bef49278a8e4326f1adf1',
			separatorSlash: '623bef65278a8e4326f1adf2',
			seriesnumber: '623bef78278a8e4326f1adf3',
			seriesprefix: '623bef98278a8e4326f1adf4',
			resetcount: '673b2cccda473c788ebaaac7',
			projectprefix: '673b3c13da473c788ebaaacf',
employeecode: '68dfa9371ec938b94e622deb', // smit 10-15-2025
		}
		// smit surani ~ 15-10-2025 ~ add employee code
		this.seriesElementArray = {		//  | Deep Dungarani  ~ 2025-05-29 ~ 04:14 PM
			'Application': [this.seriesElementIds.companyprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.branchprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Employee': [this.seriesElementIds.companyprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Opening': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Resource Request': [this.seriesElementIds.companyprefix, this.seriesElementIds.separatorDash,this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Task': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.currentyearYY, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Loan': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Salary': [this.seriesElementIds.companyprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.branchprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.currentyearYY, this.seriesElementIds.separatorDash, this.seriesElementIds.currentmonth, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Advance Salary': [this.seriesElementIds.companyprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.branchprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.currentyearYY, this.seriesElementIds.separatorDash, this.seriesElementIds.currentmonth, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Payment': [this.seriesElementIds.companyprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.branchprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.currentyearYY, this.seriesElementIds.separatorDash, this.seriesElementIds.currentmonth, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Asset': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Item': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Support Ticket': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Purchase': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.currentyearYY, this.seriesElementIds.separatorDash, this.seriesElementIds.currentmonth, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Sale Invoice': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Purchase Return Invoice': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Sale Return Invoice': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Todo Task': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Intern': [this.seriesElementIds.companyprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Lead': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Lead Quotation': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Consultant': [this.seriesElementIds.companyprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'BizCompass Support Ticket': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Travel': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Apprentice': [this.seriesElementIds.companyprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Trainee': [this.seriesElementIds.companyprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Consultation Booking': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Experience Letter': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Agreement Letter': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Appointment Letter': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Offer Letter': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Other Letter': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Relieving Letter': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Termination Letter': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
		}

		this.seriesElementArrayWithBranch = {		//  | Deep Dungarani  ~ 2025-05-29 ~ 04:14 PM
			'Employee': [this.seriesElementIds.companyprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesprefix, this.seriesElementIds.branchprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Intern': [this.seriesElementIds.companyprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesprefix, this.seriesElementIds.branchprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Consultant': [this.seriesElementIds.companyprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesprefix, this.seriesElementIds.branchprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Apprentice': [this.seriesElementIds.companyprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesprefix, this.seriesElementIds.branchprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Trainee': [this.seriesElementIds.companyprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesprefix, this.seriesElementIds.branchprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
			'Task': [this.seriesElementIds.companyprefix, this.seriesElementIds.seriesprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.currentyearYY, this.seriesElementIds.projectprefix, this.seriesElementIds.separatorDash, this.seriesElementIds.seriesnumber],
		}

		//aset status id
		this.availablestatus = "64dddfff3684059ffa63c680"
		this.allocatedstatus = "64dddf943684059ffa63c67f"
		this.inrepairstatus = "64dde0473684059ffa63c683"
		this.missingstatus = "64dde0243684059ffa63c681"
		this.retiredstatus = "64dde03c3684059ffa63c682"
		this.occupiedstatus = "64dde0523684059ffa63c684"
		this.inreplacestatus = "64e33f22dcbd5da2ffe4a1c3"

		this.defaultseatno = '625d5ed5220ccd5a20904f79'

		//employee payfor types id
		this.payforweekoff = "Week-off"
		this.payforholidays = "Holiday"

		// Intelinput

		this.defaultGridListTitle = 'Default'
		this.countryid = 'in'
		this.countryname = 'India'
		this.codecontact = '91'

		//language
		this.languageid = '669b9fa59c653c8e12a70642'
		this.language = 'English'
		this.languagecode = 'en'

		//opening id
		this.openingquestiontype = '622f0238aefd465e33c53c60'

		// survey Type ID
		this.surveytypeclientfeedback = '654b4a191eea59c64d0fcfbc'
		this.surveytypebackgroundverification = '65e6b9bb0e81e72e33825424'

		//add candidate primary souce

		this.directPrimarySource = '62454a320329c39c7b073d24'
		this.placementDriveSource = '62454a550329c39c7b073d26'

		//workreport
		this.employeeWorkReportsFilterType1 = '6294a43aecad4a1d874c6de5'

		// Om Z  🌝🌝🌝 ~ 2024-11-29 ~ 11:55 AM
		this.branchprefixid = '623bee87278a8e4326f1adec'
		this.projectprefixid = '673b3c13da473c788ebaaacf'
		this.tasktypeid = '6260f0f1d6347af2ac92bd5b'
		this.seriesnumberelementid = '623bef78278a8e4326f1adf3'
		this.branchprefix = 'Branch Prefix'
		this.projectprefix = 'Project Prefix'
		this.employeetypeid = '6243dec3c9907928dc654878'
		this.interntypeid = '65cc8a2854ca39150ce0159a'
		this.apprenticeid = '6778b74957642a93ce72f57d'
		this.traineeid = '682469439749e56801e2abc9'
		this.consultanttypeid = '67738a61d4613a1654a3eac4'

		//wfh application
		this.wfhmodaltitle = 'Remote Work Application'
		this.partialdaytitle = 'Partial Day(s) Application' // smit

		this.otherresonid = '68bfc24cb30ac271c99e61fb' // Use For Resource Request Replacement Reason | Deep Dungarani  ~ 2025-11-21 ~ 02:34 PM

		// for Notification Type smit surani  ~ 2025-04-17 ~ 017:18 PM
		this.openingMasterNotificationTypes = [8, 9, 10, 11, 12, 13, 202, 154]

		// camera images prefix
		this.cameraimagesprefix = 'camera-images-'

		// link expired status recruitment | Nirzar Gabani 💀 ~  2025-11-05 ~ 04:23 PM
		this.linkExpiredStatus = [
			{
				label: "Link Active",
				value: 0
			},
			{
				label: "Link Expire",
				value: 1
			}
		]

		// progree measure type data for KRA/KPI | Nirzar Gabani 💀 ~  2025-09-05 ~ 12:30 PM
		this.progressMeasureTypeData = [
			{ 'label': 'Percentage Complete', 'value': 1 }, 
			{ 'label': 'Number', 'value': 2 }, 
			{ 'label': 'Completed / Not Complete', 'value': 3 }
		]

		// target type data for KRA/KPI | Nirzar Gabani 💀 ~  2025-09-05 ~ 12:30 PM
		this.targetTypeData = [
			{ 'label': 'Increase From to', 'value': 1 }, 
			{ 'label': 'Decrease From to', 'value': 2 }, 
			{ 'label': 'Reach', 'value': 3 },
			{ 'label': 'Stay Above', 'value': 4 },
			{ 'label': 'Stay Below', 'value': 5 }
		]

		// progress calculatedData data for KRA/KPI | Nirzar Gabani 💀 ~  2025-09-05 ~ 12:50 PM
		this.progressCalculatedData = [
			{ 'label': 'Average Of Child KPIs', 'value': 1 }, 
			{ 'label': 'Sum Of Child KPIs', 'value': 2 }, 
		]

		//Used in general setting > people setting for KRAs / KPIs setting  | Renish Salakhana ~ 2025-09-08 ~ 015:59 PM  
		this.kraTypeData = [
			{ label: "Employee", value: 1 }, // Individual to Employee as  Requested
			{ label: "Department", value: 2 },
			{ label: "Company", value: 3 },
		]

		//Used in KRAs / KPIs Review "Add Progress" from Employee360 Search "managerialmarkstatus" | Renish Salakhana ~ 2025-09-19 ~ 018:48 PM
		this.krakpiProgressStatus = [
			{ label: 'Not Started', value: 1 },
			{ label: 'On Track', value: 2 },
			{ label: 'Needs Attention', value: 3 },
			{ label: 'At Risk', value: 4 },
			{ label: 'Closed', value: 5 },
		]

		this.krakpireviewerperson = [
			{ label: "Self", value: 1 },
			{ label: "Reporting Person", value: 2 },
			{ label: "Reporting Person-2", value: 3 },
			{ label: "Department Head", value: 4 },
			{ label: "Branch Head", value: 5 },
			{ label: "Company Head", value: 6 },
		]

		//kra kpi progress type used when progress measure type is 3 for new value |  Renish Salakhana ~ 2025-09-23 ~ 11:23 AM
		this.krakpiProgressNewValue = [
			{ label: 'Complete', value: 1 },
			{ label: 'Not Complete', value: 0 }
		]

		//kra kpi review view - Radio button configuration array | Renish Salakhana ~ 2025-10-01 ~ 12:26 PM
		this.accordionKRAKPIInputsControls = [
			{ id: 'expandAllKRAKPI', value: 'expand', label: 'Expand All' },
			{ id: 'collapseAllKRAKPI', value: 'collapse', label: 'Collapse All' }
		];

		// employee type masterdata array //  | Nirzar Gabani 💀 ~  2025-01-03
		this.employeetypedata = [
			{
				'label': 'Employee',
				'value': 0
			},
			{
				'label': 'Intern',
				'value': 1
			},
			{
				'label': 'Apprentice',
				'value': 3
			},
			// New Trainee Type Change | Shubham ➡ ~  2025-05-15 ~ 03:49 PM
			{
				'label': 'Trainee',
				'value': 4
			},
			{
				'label': 'Consultant',
				'value': 2
			},
		]

		// task owner data for joining procedure | Nirzar Gabani 💀 ~  2025-06-02 ~ 02:12 PM
		this.taskownerdata = [
			{
				'label': 'Candidate',
				'value': 1
			},
			{
				'label': 'User Role',
				'value': 2
			},
			{
				'label': 'Employee',
				'value': 3
			},
			{
				'label': 'Application Assignee',
				'value': 4
			},
			{
				'label': 'Department',
				'value': 5
			},
			{
				'label': 'Sub Department',
				'value': 6
			},
		]

		// task owner data for exit procedure | Deep Dungarani  ~ 2025-09-18
		this.exitproceduretaskownerdata = [
			{
				'label': 'Employee',
				'value': 1
			},
			{
				'label': 'User Role',
				'value': 2
			},
			{
				'label': 'Department',
				'value': 3
			},
			{
				'label': 'Sub Department',
				'value': 4
			},
			{
				'label': 'Designation ',   //task owner designation | kailas - 11-19-2025
				'value': 5
			}
		]

		// time data for after due and before due for joining procedure | Nirzar Gabani 💀 ~  2025-06-03 ~ 10:50 AM
		this.timedueData = [
			{ label: '12:00 AM', value: '1970-01-01T18:30:00.000Z' }, // 12:00 AM IST = 18:30 UTC
			{ label: '12:30 AM', value: '1970-01-01T19:00:00.000Z' }, // 12:30 AM IST = 19:00 UTC
			{ label: '01:00 AM', value: '1970-01-01T19:30:00.000Z' }, // 01:00 AM IST = 19:30 UTC
			{ label: '01:30 AM', value: '1970-01-01T20:00:00.000Z' }, // 01:30 AM IST = 20:00 UTC
			{ label: '02:00 AM', value: '1970-01-01T20:30:00.000Z' }, // 02:00 AM IST = 20:30 UTC
			{ label: '02:30 AM', value: '1970-01-01T21:00:00.000Z' }, // 02:30 AM IST = 21:00 UTC
			{ label: '03:00 AM', value: '1970-01-01T21:30:00.000Z' }, // 03:00 AM IST = 21:30 UTC
			{ label: '03:30 AM', value: '1970-01-01T22:00:00.000Z' }, // 03:30 AM IST = 22:00 UTC
			{ label: '04:00 AM', value: '1970-01-01T22:30:00.000Z' }, // 04:00 AM IST = 22:30 UTC
			{ label: '04:30 AM', value: '1970-01-01T23:00:00.000Z' }, // 04:30 AM IST = 23:00 UTC
			{ label: '05:00 AM', value: '1970-01-01T23:30:00.000Z' }, // 05:00 AM IST = 23:30 UTC
			{ label: '05:30 AM', value: '1970-01-02T00:00:00.000Z' }, // 05:30 AM IST = 00:00 UTC (next day)
			{ label: '06:00 AM', value: '1970-01-02T00:30:00.000Z' }, // 06:00 AM IST = 00:30 UTC
			{ label: '06:30 AM', value: '1970-01-02T01:00:00.000Z' }, // 06:30 AM IST = 01:00 UTC
			{ label: '07:00 AM', value: '1970-01-02T01:30:00.000Z' }, // 07:00 AM IST = 01:30 UTC
			{ label: '07:30 AM', value: '1970-01-02T02:00:00.000Z' }, // 07:30 AM IST = 02:00 UTC
			{ label: '08:00 AM', value: '1970-01-02T02:30:00.000Z' }, // 08:00 AM IST = 02:30 UTC
			{ label: '08:30 AM', value: '1970-01-02T03:00:00.000Z' }, // 08:30 AM IST = 03:00 UTC
			{ label: '09:00 AM', value: '1970-01-02T03:30:00.000Z' }, // 09:00 AM IST = 03:30 UTC
			{ label: '09:30 AM', value: '1970-01-02T04:00:00.000Z' }, // 09:30 AM IST = 04:00 UTC
			{ label: '10:00 AM', value: '1970-01-02T04:30:00.000Z' }, // 10:00 AM IST = 04:30 UTC
			{ label: '10:30 AM', value: '1970-01-02T05:00:00.000Z' }, // 10:30 AM IST = 05:00 UTC
			{ label: '11:00 AM', value: '1970-01-02T05:30:00.000Z' }, // 11:00 AM IST = 05:30 UTC
			{ label: '11:30 AM', value: '1970-01-02T06:00:00.000Z' }, // 11:30 AM IST = 06:00 UTC
			{ label: '12:00 PM', value: '1970-01-02T06:30:00.000Z' }, // 12:00 PM IST = 06:30 UTC
			{ label: '12:30 PM', value: '1970-01-02T07:00:00.000Z' }, // 12:30 PM IST = 07:00 UTC
			{ label: '01:00 PM', value: '1970-01-02T07:30:00.000Z' }, // 01:00 PM IST = 07:30 UTC
			{ label: '01:30 PM', value: '1970-01-02T08:00:00.000Z' }, // 01:30 PM IST = 08:00 UTC
			{ label: '02:00 PM', value: '1970-01-02T08:30:00.000Z' }, // 02:00 PM IST = 08:30 UTC
			{ label: '02:30 PM', value: '1970-01-02T09:00:00.000Z' }, // 02:30 PM IST = 09:00 UTC
			{ label: '03:00 PM', value: '1970-01-02T09:30:00.000Z' }, // 03:00 PM IST = 09:30 UTC
			{ label: '03:30 PM', value: '1970-01-02T10:00:00.000Z' }, // 03:30 PM IST = 10:00 UTC
			{ label: '04:00 PM', value: '1970-01-02T10:30:00.000Z' }, // 04:00 PM IST = 10:30 UTC
			{ label: '04:30 PM', value: '1970-01-02T11:00:00.000Z' }, // 04:30 PM IST = 11:00 UTC
			{ label: '05:00 PM', value: '1970-01-02T11:30:00.000Z' }, // 05:00 PM IST = 11:30 UTC
			{ label: '05:30 PM', value: '1970-01-02T12:00:00.000Z' }, // 05:30 PM IST = 12:00 UTC
			{ label: '06:00 PM', value: '1970-01-02T12:30:00.000Z' }, // 06:00 PM IST = 12:30 UTC
			{ label: '06:30 PM', value: '1970-01-02T13:00:00.000Z' }, // 06:30 PM IST = 13:00 UTC
			{ label: '07:00 PM', value: '1970-01-02T13:30:00.000Z' }, // 07:00 PM IST = 13:30 UTC
			{ label: '07:30 PM', value: '1970-01-02T14:00:00.000Z' }, // 07:30 PM IST = 14:00 UTC
			{ label: '08:00 PM', value: '1970-01-02T14:30:00.000Z' }, // 08:00 PM IST = 14:30 UTC
			{ label: '08:30 PM', value: '1970-01-02T15:00:00.000Z' }, // 08:30 PM IST = 15:00 UTC
			{ label: '09:00 PM', value: '1970-01-02T15:30:00.000Z' }, // 09:00 PM IST = 15:30 UTC
			{ label: '09:30 PM', value: '1970-01-02T16:00:00.000Z' }, // 09:30 PM IST = 16:00 UTC
			{ label: '10:00 PM', value: '1970-01-02T16:30:00.000Z' }, // 10:00 PM IST = 16:30 UTC
			{ label: '10:30 PM', value: '1970-01-02T17:00:00.000Z' }, // 10:30 PM IST = 17:00 UTC
			{ label: '11:00 PM', value: '1970-01-02T17:30:00.000Z' }, // 11:00 PM IST = 17:30 UTC
			{ label: '11:30 PM', value: '1970-01-02T18:00:00.000Z' }  // 11:30 PM IST = 18:00 UTC
		];

		// tags will leave space for physical signature | Nirzar Gabani 💀 ~  2025-07-15 ~ 09:44 AM
		this.physicalSignatureTags = [
			{ tag: '#stamp?', key: 'stamp' },
			{ tag: '#signature?', key: 'signature' },
			{ tag: '#stampwithsignature?', key: 'stampwithsignature' }
		]

		// array for show which configuration is added in letter | Nirzar Gabani 💀 ~  2025-07-15 ~ 10:56 AM
		this.letterConfigurationArray = [
			{
				'field': 'showinprofile',
				'text': 'Show In My Profile',
			},
			{
				'field': 'sendinmail',
				'text': 'Send Mail',
			},
			{
				'field': 'sendacknowledgement',
				'text': 'Send Acknowledgement Mail',
			},
			{
				'field': 'hasphysicalsignature',
				'text': 'Physical Signature',
			},
			{
				'field': 'approvalrequired',
				'text': 'Approval Required',
			},
		]

		// used in incrment letter
		this.salaryDetails = {
			income: [
				{
					'field': 'basicsalary',
					'text': 'Basic Salary',
				},
				{
					'field': 'incomeemployeeepf',
					'text': 'Employee EPF',
				},
				{
					'field': 'incomeemployeeeps',
					'text': 'Employee EPS',
				},
				{
					'field': 'incomeemployeeedli',
					'text': 'Employee EDLI',
				},
				{
					'field': 'incomeemployeeepfadmin',
					'text': 'Employee EPF Admin',
				},
				{
					'field': 'incomeemployerepf',
					'text': 'Employer EPF',
				},
				{
					'field': 'incomeemployereps',
					'text': 'Employer EPS',
				},
				{
					'field': 'incomeemployeredli',
					'text': 'Employer EDLI',
				},
				{
					'field': 'incomeemployerepfadmin',
					'text': 'Employer EPF Admin',
				},
				{
					'field': 'incomeemployeeesic',
					'text': 'Employee ESIC',
				},
				{
					'field': 'incomeemployeresic',
					'text': 'Employer ESIC',
				},
				{
					'field': 'incomeemployeresicadmin',
					'text': 'Employer ESIC Admin',
				},
				{
					'field': 'incometds',
					'text': 'TDS',
				},
				{
					'field': 'incomeprofessionaltax',
					'text': 'Professional Tax',
				},
				{
					'field': 'deductionemployerepf',
					'text': 'Employer EPF',
				},
				{
					'field': 'deductionemployereps',
					'text': 'Employer EPS',
				},
				{
					'field': 'deductionemployeredli',
					'text': 'Employer EDLI',
				},
				{
					'field': 'deductionemployerepfadmin',
					'text': 'Employer EPF Admin',
				},
				{
					'field': 'deductionemployeresic',
					'text': 'Employer ESIC',
				},
				{
					'field': 'deductionemployeresicadmin',
					'text': 'Employer ESIC Admin',
				},
			],
			deduction: [
				{
					'field': 'deductionemployeeepf',
					'text': 'Employee EPF',
				},
				{
					'field': 'deductionemployeeeps',
					'text': 'Employee EPS',
				},
				{
					'field': 'deductionemployeeedli',
					'text': 'Employee EDLI',
				},
				{
					'field': 'deductionemployeeepfadmin',
					'text': 'Employee EPF Admin',
				},

				{
					'field': 'deductionemployeeesic',
					'text': 'Employee ESIC',
				},

				{
					'field': 'deductiontds',
					'text': 'TDS',
				},
				{
					'field': 'deductionprofessionaltax',
					'text': 'Professional Tax',
				}
			],
			basicincome: [
				{
					'field': 'netamount',
					'text': 'Net Salary Pay',
				},
			]
		}
		
		// used for salary details ~ start | Nirzar Gabani 💀 ~  2025-09-04 ~ 11:08 AM
		this.avgSalaryDetails = {
			income: [
				{
					'field': 'avgbasicsalary',
					'text': 'Basic Salary',
				},
				// this fields static condition added in preview modal & while generate
				// allowance, headerbonustobepaid
			],
			// JATIN 14/05/2025
			contribution: [
				// deduction Employer fields
				//PF
				{
					'field': 'avgdeductionemployerepf',
					'text': 'Employer EPF',
				},
				{
					'field': 'avgdeductionemployereps',
					'text': 'Employer EPS',
				},
				{
					'field': 'avgdeductionemployeredli',
					'text': 'Employer EDLI',
				},
				{
					'field': 'avgdeductionemployerepfadmin',
					'text': 'Employer EPF Admin',
				},
				//ESIC
				{
					'field': 'avgdeductionemployeresic',
					'text': 'Employer ESIC',
				},
				{
					'field': 'avgdeductionemployeresicadmin',
					'text': 'Employer ESIC Admin',
				},
				//headerbonuses --> this fields static condition added in preview modal & while generate
				// averagevariablectc --> this fields static condition added in preview modal & while generate
			],
			deduction: [
				//PT
				{
					'field': 'avgdeductionprofessionaltax',
					'text': 'Professional Tax',
				},
				//PF
				{
					'field': 'avgdeductionemployeeepf',
					'text': 'Employee EPF',
				},
				{
					'field': 'avgdeductionemployeeeps',
					'text': 'Employee EPS',
				},
				{
					'field': 'avgdeductionemployeeedli',
					'text': 'Employee EDLI',
				},
				{
					'field': 'avgdeductionemployeeepfadmin',
					'text': 'Employee EPF Admin',
				},
				//ESIC
				{
					'field': 'avgdeductionemployeeesic',
					'text': 'Employee ESIC',
				},
			],
			basicincome: [
				{
					'field': 'avgnetamount',
					'text': 'Net Salary Pay',
				},
			]
		}

		this.annualSalaryDetails = {
			income: [
				{
					'field': 'annualavgbasicsalary',
					'text': 'Basic Salary',
				},
			],
			// JATIN 14/05/2025
			contribution: [
				// deduction Employer fields
				//PF
				{
					'field': 'annualavgdeductionemployerepf',
					'text': 'Employer EPF',
				},
				{
					'field': 'annualavgdeductionemployereps',
					'text': 'Employer EPS',
				},
				{
					'field': 'annualavgdeductionemployeredli',
					'text': 'Employer EDLI',
				},
				{
					'field': 'annualavgdeductionemployerepfadmin',
					'text': 'Employer EPF Admin',
				},
				//ESIC
				{
					'field': 'annualavgdeductionemployeresic',
					'text': 'Employer ESIC',
				},
				{
					'field': 'annualavgdeductionemployeresicadmin',
					'text': 'Employer ESIC Admin',
				},
				// this fields static condition added in preview modal & while generate
				// headerbonuses & averagevariablectc (annualavg keys)
			],
			deduction: [
				//PT
				{
					'field': 'annualavgdeductionprofessionaltax',
					'text': 'Professional Tax',
				},
				//PF
				{
					'field': 'annualavgdeductionemployeeepf',
					'text': 'Employee EPF',
				},
				{
					'field': 'annualavgdeductionemployeeeps',
					'text': 'Employee EPS',
				},
				{
					'field': 'annualavgdeductionemployeeedli',
					'text': 'Employee EDLI',
				},
				{
					'field': 'annualavgdeductionemployeeepfadmin',
					'text': 'Employee EPF Admin',
				},
				//ESIC
				{
					'field': 'annualavgdeductionemployeeesic',
					'text': 'Employee ESIC',
				},
			],
			basicincome: [
				{
					'field': 'annualavgnetamount',
					'text': 'Net Salary Pay',
				},
			]
		}
		// used for salary details ~ end | Nirzar Gabani 💀 ~  2025-09-04 ~ 11:08 AM

		// used for salary certificate ~ start | Nirzar Gabani 💀 ~  2025-09-04 ~ 11:27 AM
		this.avgSalaryCertificateDetails = {
			income: [
				{
					'field': 'avgbasicsalary',
					'text': 'Basic Salary',
				},
				{
					'field': 'avgincomeemployeeepf',
					'text': 'Employee EPF',
				},
				{
					'field': 'avgincomeemployeeeps',
					'text': 'Employee EPS',
				},
				{
					'field': 'avgincomeemployeeedli',
					'text': 'Employee EDLI',
				},
				{
					'field': 'avgincomeemployeeepfadmin',
					'text': 'Employee EPF Admin',
				},
				{
					'field': 'avgincomeemployerepf',
					'text': 'Employer EPF',
				},
				{
					'field': 'avgincomeemployereps',
					'text': 'Employer EPS',
				},
				{
					'field': 'avgincomeemployeredli',
					'text': 'Employer EDLI',
				},
				{
					'field': 'avgincomeemployerepfadmin',
					'text': 'Employer EPF Admin',
				},
				{
					'field': 'avgincomeemployeeesic',
					'text': 'Employee ESIC',
				},
				{
					'field': 'avgincomeemployeresic',
					'text': 'Employer ESIC',
				},
				{
					'field': 'avgincomeemployeresicadmin',
					'text': 'Employer ESIC Admin',
				},
				{
					'field': 'avgincometds',
					'text': 'TDS',
				},
				{
					'field': 'avgincomeprofessionaltax',
					'text': 'Professional Tax',
				},

				// {
				//     'field': 'variablectc',
				//     'text': 'Variable CTC',
				// },

			],
			// JATIN 14/05/2025 contribution for Show Seprated in Preview Modal  Same Changs in Application Modal Controller also used same key in Salary table 
			contribution: [
				// deduction Employer fields
				{
					'field': 'avgdeductionemployerepf',
					'text': 'Employer EPF',
				},
				{
					'field': 'avgdeductionemployereps',
					'text': 'Employer EPS',
				},
				{
					'field': 'avgdeductionemployeredli',
					'text': 'Employer EDLI',
				},
				{
					'field': 'avgdeductionemployerepfadmin',
					'text': 'Employer EPF Admin',
				},
				{
					'field': 'avgdeductionemployeresic',
					'text': 'Employer ESIC',
				},
				{
					'field': 'avgdeductionemployeresicadmin',
					'text': 'Employer ESIC Admin',
				},
			],
			deduction: [
				{
					'field': 'avgdeductionemployeeepf',
					'text': 'Employee EPF',
				},
				{
					'field': 'avgdeductionemployeeeps',
					'text': 'Employee EPS',
				},
				{
					'field': 'avgdeductionemployeeedli',
					'text': 'Employee EDLI',
				},
				{
					'field': 'avgdeductionemployeeepfadmin',
					'text': 'Employee EPF Admin',
				},

				{
					'field': 'avgdeductionemployeeesic',
					'text': 'Employee ESIC',
				},

				{
					'field': 'avgdeductiontds',
					'text': 'TDS',
				},
				{
					'field': 'avgdeductionprofessionaltax',
					'text': 'Professional Tax',
				},
			],
			basicincome: [
				{
					'field': 'avgnetamount',
					'text': 'Net Salary Pay',
				},
			]
		}

		this.annualSalaryCertificateDetails = {
			income: [
				{
					'field': 'annualbasicsalary',
					'text': 'Basic Salary',
				},
				{
					'field': 'annualincomeemployeeepf',
					'text': 'Employee EPF',
				},
				{
					'field': 'annualincomeemployeeeps',
					'text': 'Employee EPS',
				},
				{
					'field': 'annualincomeemployeeedli',
					'text': 'Employee EDLI',
				},
				{
					'field': 'annualincomeemployeeepfadmin',
					'text': 'Employee EPF Admin',
				},
				{
					'field': 'annualincomeemployerepf',
					'text': 'Employer EPF',
				},
				{
					'field': 'annualincomeemployereps',
					'text': 'Employer EPS',
				},
				{
					'field': 'annualincomeemployeredli',
					'text': 'Employer EDLI',
				},
				{
					'field': 'annualincomeemployerepfadmin',
					'text': 'Employer EPF Admin',
				},
				{
					'field': 'annualincomeemployeeesic',
					'text': 'Employee ESIC',
				},
				{
					'field': 'annualincomeemployeresic',
					'text': 'Employer ESIC',
				},
				{
					'field': 'annualincomeemployeresicadmin',
					'text': 'Employer ESIC Admin',
				},
				{
					'field': 'annualincometds',
					'text': 'TDS',
				},
				{
					'field': 'annualincomeprofessionaltax',
					'text': 'Professional Tax',
				},
				// deduction Employer fields
				{
					'field': 'annualdeductionemployerepf',
					'text': 'Employer EPF',
				},
				{
					'field': 'annualdeductionemployereps',
					'text': 'Employer EPS',
				},
				{
					'field': 'annualdeductionemployeredli',
					'text': 'Employer EDLI',
				},
				{
					'field': 'annualdeductionemployerepfadmin',
					'text': 'Employer EPF Admin',
				},
				{
					'field': 'annualdeductionemployeresic',
					'text': 'Employer ESIC',
				},
				{
					'field': 'annualdeductionemployeresicadmin',
					'text': 'Employer ESIC Admin',
				},

			],
			deduction: [
				{
					'field': 'annualdeductionemployeeepf',
					'text': 'Employee EPF',
				},
				{
					'field': 'annualdeductionemployeeeps',
					'text': 'Employee EPS',
				},
				{
					'field': 'annualdeductionemployeeedli',
					'text': 'Employee EDLI',
				},
				{
					'field': 'annualdeductionemployeeepfadmin',
					'text': 'Employee EPF Admin',
				},

				{
					'field': 'annualdeductionemployeeesic',
					'text': 'Employee ESIC',
				},

				{
					'field': 'annualdeductiontds',
					'text': 'TDS',
				},
				{
					'field': 'annualdeductionprofessionaltax',
					'text': 'Professional Tax',
				},
			],
			basicincome: [
				{
					'field': 'annualnetamount',
					'text': 'Net Salary Pay',
				},
			]
		}
		// used for salary certificate ~ end | Nirzar Gabani 💀 ~  2025-09-04 ~ 11:27 AM

		// Utsav
		this.errorConfig = {
			maxBatchSize: 20, // Maximum number of errors to batch before sending                                  				   
			retryAttempts: 2, // Number of retry attempts for failed API calls                                  				   
		}
		this.enableErrorTracking = true // for enabling the error tracing through out the website

		// letter type ~ identify - which letter will generated or acknowledge | Nirzar Gabani 💀 ~  2025-06-30 ~ 01:09 PM 
		this.letterKeyType = {
			offerlettertype: 'offerletter',
			appointmentlettertype: 'appointmentletter',
			agreementlettertype: 'agreement',
			otherlettertype: 'otherletter'
		}

		this.defColorsObj = {
			lightprimarycolor: '5956e3',
			lightsecondarycolor: 'e1e1e1',
			lighttertiarycolor: '222222',
			lightbgcolor: 'ffffff',
			darkprimarycolor: '5956e3',
			darksecondarycolor: 'e1e1e1',
			darktertiarycolor: '222222',
			darkbgcolor: '111111',
		}

		this.defFontObj = {
			fontfamily: 'Montserrat',
			fontvariant: 'regular',
			category: 'sans-serif'
		}

		//  | Aman - （︶^︶） ~  2025-07-17 ~ 11:51 AM 
		this.AADHAR_DOCUMENT_ID = '632181921f89ecd3d20972de'
		this.PAN_DOCUMENT_ID = '6321819e1f89ecd3d20972f9'

		// masterdata key for candidaterejectreason | Nirzar Gabani 💀 ~  2025-04-01 ~ 12:33 PM
		this.candidaterejectreason = 'candidaterejectreason'

		this.employeetypeConfiguration = [
			{
				'label': 'Configured',
				'value': 1
			},
			{
				'label': 'Non-Configured',
				'value': 2
			}
		]

		this.taskdetailstopwatchprefix = 'taskdetails'
		this.tododetailstopwatchprefix = 'tododetails'
		this.supportticketstopwatchprefix = 'sidebar'
		//aman added tab
		this.taskdetailmodaltabs = ['comments', 'subtask', 'timelog', 'documents', 'issue', 'testcase', 'notabug', 'reopen', 'note', 'reminderrecurrance', 'timeline', 'dependenttasks']
		this.taskdetailmodalmeetingtabs = ['comments', 'timelog', 'documents']

		// leave calendar message
		this.leavecalendarmessages = {
			'applyleavecancellation': "Applied for leave Cancellation",
			'leavecancelationreject': "Leave Cancellation Rejected",
			'requested': "Requested",
			'accepted': "Approved",
			'rejected': "Rejected",
			'leavecanceled': "Cancelled"
		}

		// Surevytypeid 
		// Jatin 12/08/2024
		this.surevytypemanagerialreview = '6458c72014ff4e92c8883b68'

		// static message for flow
		this.nointerviewflowavailable = 'Interview Procedure Flow not available'
		this.noonboardingflowavailable = 'Onboarding Procedure Flow not available'

		//os Platform array
		this.osPlatformArr = [
			{ 'label': 'Android', 'value': 2 },
			{ 'label': 'iOS', 'value': 3 },
			{ 'label': 'Windows', 'value': 4 },
			{ 'label': 'MacOs', 'value': 5 },
			{ 'label': 'Linux', 'value': 6 },
		]

		// default value for message template | Nirzar Gabani 💀 ~  2025-05-12 ~ 008:40 PM
		this.templatecategoryid = '669a4a1dbb5bdd4f295e766e'
		this.messagetemplateplatformid = '643a87c13c88a270cf072e13'

		// whatsapp user type dropdown | Nirzar Gabani 💀 ~  2025-05-13 ~ 06:14 PM
		this.userTypeDropdown = [
			{
				label: "Candidate",
				icontype: "person-outlined",
				type: 1
			},
			{
				label: "Employee",
				icontype: "person-outlined",
				type: 3
			},
			{
				label: "Lead",
				icontype: "person-outlined",
				type: 2
			},
			{
				label: "Customer",
				icontype: "person-outlined",
				type: 4
			},
		]
		// smit surani ~ 05-01-2025
		this.remoteworktypes = {
			1:'Work From Home',
			2:'Field Work',
			3:'On Duty'
		}

		// alerttypes | Pravin ~ 06-06-2025 ~ 5:05 PM
		this.alertTypes = [
			// { 'label': 'Notification', 'value': 1 },
			// { 'label': 'Mail', 'value': 2 },
			// { 'label': 'Chat', 'value': 3 },
			{ 'label': 'Whatsapp', 'value': 4 }]

		// whatsapppersontags | Nirzar Gabani 💀 ~  2025-02-14 ~ 04:22 PM
		this.whatsapppersontags = [	// type 1 - Candidate, 2 - Lead, 3- Employee, 4 - Customer
			//new tags and array type -kailas
			{ 'label': 'Candidate Name', 'value': 'candidatename', 'type': [1] },
			{ 'label': 'Candidate Address', 'value': 'candidateaddress', 'type': [1]},
			{ 'label': 'Mobile Number', 'value': 'phone','type': [1, 2, 3, 4] },
			{ 'label': 'Email', 'value': 'email' ,'type': [1, 2, 3, 4] },
			{ 'label': 'Company Name', 'value': 'companyname','type': [2, 3, 4] },
			{ 'label': 'Opening Name', 'value': 'openingname', 'type': [1]},
			{ 'label': 'Department Name', 'value': 'department', 'contact': 'input-text', 'type': [3] },
			{ 'label': 'Designation Name', 'value': 'designation', 'contact': 'input-text','type': [3] },
			{ 'label': 'Employee Name', 'value': 'employeename',  'type': [3] },
			{ 'label': 'Work Email ID', 'value': 'workemail', 'contact': 'input-text','type': [3] },
			{ 'label': 'Opening Company Name', 'value': 'openingcompanyname','type': [1]},
			{ 'label': 'Opening Branch Name', 'value': 'openingbranchname', 'type': [1]},
			{ 'label': 'Opening Department Name', 'value': 'openingdepartment',  'type': [1] },
			{ 'label': 'Opening Designation Name', 'value': 'openingdesignation', 'type': [1] },
			{ 'label': 'Applied Company Name', 'value': 'appliedcompanyname','type': [1]},
			{ 'label': 'Applied Branch Name', 'value': 'appliedbranchname', 'type': [1] },
			{ 'label': 'Applied Department Name', 'value': 'applieddepartment', 'type': [1] },
			{ 'label': 'Applied Designation Name', 'value': 'applieddesignation','type': [1]},
			{ 'label': 'Customer Name', 'value': 'customername', 'type': [4] },
			{ 'label': 'Lead Title', 'value': 'leadtitle', 'type': [2] },
			{ 'label': 'Organization ', 'value': 'account',  'type': [2] },
			{ 'label': 'Lead Owner', 'value': 'leadowner', 'contact': 'input-text',  'type': [2] },
			{ 'label': 'User Role', 'value': 'userrole', 'contact': 'input-text', 'type': [3] },
			{ 'label': 'Client Company Name', 'value': 'customercompanyname', 'contact': 'input-text', 'type': [4]},
			{ 'label': 'Contact ', 'value': 'leadowner',  'type': [2]},
			{ 'label': 'Joining Stage', 'value': 'joiningstage', 'type': [1] },	//  | Deep Dungarani  ~ 2025-07-17 ~ 04:53 PM
			{ 'label': 'Followup Date', 'value': 'followupdate', 'type': [1]},	//  | Deep Dungarani  ~ 2025-07-17 ~ 04:53 PM
			{ 'label': 'Employee or Intern', 'value': 'employeeorintern', 'type': [1] },	//  | Deep Dungarani  ~ 2025-07-17 ~ 04:53 PM
			{ 'label': 'Applied On (dd/mm/yyyy)', 'value': 'appliedon', 'type': [1] },
			{ 'label': 'Year(s) Of Experience', 'value': 'yearsofexperience', 'type': [1] },
			{ 'label': 'Current Date (dd/mm/yyyy)', 'value': 'currentdate','type': [1, 2, 3, 4]  },
			{ 'label': 'User Role', 'value': 'userrole', 'contact': 'input-text', 'type': [4] },
			{ 'label': 'Interview Stage', 'value': 'interviewstage',  'type': [1]},
			{ 'label': 'Interview Start Time', 'value': 'starttime',  'type': [1] },
			{ 'label': 'Interview End Time', 'value': 'endtime',  'type':  [1]},
			{ 'label': 'Interview Type', 'value': 'interviewtype',  'type': [1] },
	
		]

		this.violationtype = [ // use in useCheatingDetection.js || Deep Dungarani ~ 2025-07-24 ~ 05:00 PM
			{ 'label': 'Tab switch / Window switch', 'value': 1 },
			{ 'label': 'Tab/Window minimization', 'value': 2 },
			{ 'label': 'Right-click / Dev Tools (Inspect) opening', 'value': 3 },
			{ 'label': 'Copy operation', 'value': 4 },
			{ 'label': 'Paste operation', 'value': 5 },
		]

		this.chatURL = 'https://chat.bizcompass.app/main'
		// ************************************************************************************** static masterdataarray start  **************************************************************************************
		// Form Builder Variables starts | Om Z  🌝🌝🌝 ~ 2024-12-27 ~ 12:30 PM
		this.conditions = [
			{ label: 'is filled out', value: '1', symbol: null },
			{ label: 'is not filled out', value: '2', symbol: null },
			{ label: 'is', value: '3', symbol: null },
			{ label: 'is not', value: '4', symbol: null },
			{ label: 'contains', value: '5', symbol: null },
			{ label: 'does not contain', value: '6', symbol: null },
			{ label: 'ends with', value: '7', symbol: null },
			{ label: 'doest not end with', value: '8', symbol: null },
			{ label: 'starts with', value: '9', symbol: null },
			{ label: 'doest not start with', value: '10', symbol: null },
		]

		this.dateconditions = [
			{ label: 'is filled out', value: '1', symbol: null },
			{ label: 'is not filled out', value: '2', symbol: null },
			{ label: 'is', value: '3', symbol: null },
			{ label: 'is not', value: '4', symbol: null },
			{ label: 'is after', value: '15', symbol: null },
			{ label: 'is before', value: '16', symbol: null },
			{ label: 'on or after', value: '17', symbol: null },
			{ label: 'on or before', value: '18', symbol: null },
			{ label: 'is between', value: '19', symbol: null },
			{ label: 'is today', value: '20', symbol: null },
			{ label: 'is in future', value: '21', symbol: null },
			{ label: 'is in past', value: '22', symbol: null },
			{ label: 'day of month is', value: '23', symbol: null },
			{ label: 'day of week is', value: '24', symbol: null },
			{ label: 'month is', value: '25', symbol: null },
			{ label: 'year is', value: '26', symbol: null },
		]

		this.timeconditions = [
			{ label: 'is filled out', value: '1', symbol: null },
			{ label: 'is not filled out', value: '2', symbol: null },
			{ label: 'is', value: '3', symbol: null },
			{ label: 'is not', value: '4', symbol: null },
			{ label: 'is after', value: '35', symbol: null },
			{ label: 'is before', value: '36', symbol: null },
			{ label: 'on or after', value: '37', symbol: null },
			{ label: 'on or before', value: '38', symbol: null },
			{ label: 'hour is', value: '39', symbol: null },
			{ label: 'minute is', value: '40', symbol: null },
		]

		this.fieldsmasterdata = [
			{ label: 'Text', value: '0' },
			{ label: 'Choice', value: '1' }
		]
		// -----------------JATIN Start 7/1/25 Travel Master Data-----------

		this.mealpreference = [
			{ label: "Asian Vegetarian Meal", value: '67767597199eb67768798cb4' },
			{ label: "Diabetic Meal", value: '67767597199eb67768798cb5' },
			{ label: "Gluten-free Meal", value: '67767597199eb67768798cb6' },
			{ label: "Vegetarian Meal (non-dairy)", value: '67767597199eb67768798cb7' },
			{ label: "Vegetarian Jain Meal", value: '67767597199eb67768798cb8' },
			{ label: "Fruit Platter", value: '67767597199eb67768798cb9' },
			{ label: "Low cholesterol/ Low Fat Meal", value: '67767597199eb67768798cba' },
			{ label: "None", value: '67767597199eb67768798cbb' },
			{ label: "Bland Meal", value: '67767597199eb67768798cbc' },
			{ label: "Vegetarian Meal (lacto-ovo)", value: '67767597199eb67768798cbd' },
			{ label: "Hindu (Non-Vegetarian) Meal", value: '67767597199eb67768798cbe' },
			{ label: "Muslim Meal", value: '67767597199eb67768798cbf' },
			{ label: "Child Meal", value: '67767597199eb67768798cc0' },
			{ label: "Baby Meal", value: '67767597199eb67768798cc1' },
			{ label: "Kosher Meal", value: '67767597199eb67768798cc2' },
			{ label: "Low Calories Meal", value: '67767597199eb67768798cc3' },
			{ label: "Non Lactose Meal", value: '67767597199eb67768798cc4' },
		]
		// JATIN 13/1/2025
		this.cartype = [
			{ 'label': 'Small', 'value': 1 },
			{ 'label': 'Medium', 'value': 2 },
			{ 'label': 'Large Economy', 'value': 3 },
			{ 'label': 'Estate', 'value': 4 },
			{ 'label': 'premium', 'value': 5 },
			{ 'label': 'PeopleCarrier', 'value': 6 },
			{ 'label': 'Suv', 'value': 7 },
		]

		this.departuretime = [
			{ 'label': '12AM – 8AM', 'value': 1 },
			{ 'label': '8AM – 12PM', 'value': 2 },
			{ 'label': '12PM – 8PM', 'value': 3 },
			{ 'label': '8PM – 12PM', 'value': 4 },
		]

		this.seatprefrence = [
			{ 'label': 'None', 'value': 0 },
			{ 'label': 'Window', 'value': 1 },
			{ 'label': 'Middle', 'value': 2 },
			{ 'label': 'Aisle', 'value': 3 },
		]

		this.flightprefrence = [
			{ 'label': 'None', 'value': 0 },
			{ 'label': 'Economy', 'value': 1 },
			{ 'label': 'Premium Economy', 'value': 2 },
			{ 'label': 'Buisness', 'value': 3 },
			{ 'label': 'First', 'value': 4 },
		]

		// icon extension
		this.iconExtension = [{
			"extensionicon": pngicon,
			"extensioniconname": "png.png",
			"extensionname": ".png",
		},
		{
			"extensionicon": docicon,
			"extensioniconname": "doc.png",
			"extensionname": ".doc or .docx",
		},
		{
			"extensionicon": pdficon,
			"extensioniconname": "pdf.png",
			"extensionname": ".pdf",
		},
		{
			"extensionicon": xlsicon,
			"extensioniconname": "xls.png",
			"extensionname": ".xlr or .xls or.xlsx",

		},
		{
			"extensionicon": jpgicon,
			"extensioniconname": "jpg (1).png",
			"extensionname": ".jpeg or .jpg",

		}]

		// -----------------JATIN end 7/1/25 Travel Master Data-----------

		this.formtypeobj = {
			'choice': 'Choice',
			'textinput': 'Text',
			'rating': 'Rating',
			'dateinput': 'Date',
			'timeinput': 'Time',
			'uploadfile': 'Upload File',
			'signature': 'Signature',
			'likert': 'Likert',
			'array': 'Repeat Section',
			'notes': 'Notes',
			'section': 'Section',
			'selfie': 'Selfie',
			'table': 'table',
		}

		this.messageArray = [
			{ label: "Warning", value: 'warning-drop all-drop badges bg-warning-transparent text-warning-common w-100 p-8 text-wrap', class: 'warning-drop all-drop badges bg-warning-transparent text-warning-common w-100 p-8 text-wrap' },
			{ label: "Success", value: 'success-drop all-drop badges bg-success-transparent text-success-common w-100 p-8 text-wrap', class: 'success-drop all-drop badges bg-success-transparent text-success-common w-100 p-8 text-wrap' },
			{ label: "Danger", value: 'danger-drop all-drop badges bg-danger-transparent text-danger-common w-100 p-8 text-wrap', class: 'danger-drop all-drop badges bg-danger-transparent text-danger-common w-100 p-8 text-wrap' },
		]

		this.modalTitles = {
			'availableleavebalance': 'Available Leave Balance',
		}

		// aman - monthdata arr
		this.monthOptions = [
			{ label: 'Jan', value: 1 },
			{ label: 'Feb', value: 2 },
			{ label: 'Mar', value: 3 },
			{ label: 'Apr', value: 4 },
			{ label: 'May', value: 5 },
			{ label: 'Jun', value: 6 },
			{ label: 'Jul', value: 7 },
			{ label: 'Aug', value: 8 },
			{ label: 'Sep', value: 9 },
			{ label: 'Oct', value: 10 },
			{ label: 'Nov', value: 11 },
			{ label: 'Dec', value: 12 }
		]

		this.dataAray = [
			{
				"value": '^[A-Za-z0-9]+$',
				"label": "Number + String"
			},
			{
				"value": '^[0-9]+$',
				"label": "Number"
			},
			{
				"value": '^\\+?[1-9]\\d{0,2}[-.\\s]?\\(?\\d{1,4}\\)?[-.\\s]?\\d{1,4}[-.\\s]?\\d{1,4}[-.\\s]?\\d{1,9}$',
				"label": "Contact Number"
			},
			{
				"value": '^[a-zA-Z\\s]*$',
				"label": "String"
			},
			{
				"value": '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$',
				"label": "Email"
			}
		]

		this.ratingLevel = [
			{
				label: '1',
				value: '1'
			},
			{
				label: '2',
				value: '2'
			},
			{
				label: '3',
				value: '3'
			},
			{
				label: '4',
				value: '4'
			},
			{
				label: '5',
				value: '5'
			},
			{
				label: '6',
				value: '6'
			},
			{
				label: '7',
				value: '7'
			},
			{
				label: '8',
				value: '8'
			},
			{
				label: '9',
				value: '9'
			},
			{
				label: '10',
				value: '10'
			},
		]

		this.expiresAfterday = [
			{
				'label': '1 Days',
				'value': 1
			},
			{
				'label': '4 Days',
				'value': 4
			},
			{
				'label': '7 Days',
				'value': 7
			},
			{
				'label': '14 Days',
				'value': 14
			},
			{
				'label': '21 Days',
				'value': 21
			},
			{
				'label': '28 Days',
				'value': 28
			}
		];
		// Form Builder Variables starts | Om Z  🌝🌝🌝 ~ 2024-12-27 ~ 12:30 PM

		this.printpagetype = [
			{ 'label': 'A4', 'value': 'A4' },
			{ 'label': 'Legal', 'value': 'legal' },
			{ 'label': 'Letter', 'value': 'letter' },
			{ 'label': 'Ledger', 'value': 'ledger' },
			// { 'label': 'Landscape', 'value': 'landscape' },
			// { 'label': 'Portrait', 'value': 'portrait' },
			{ 'label': 'A3', 'value': 'A3' },
			{ 'label': 'A5', 'value': 'A5' },
			// { 'label': 'B4', 'value': 'B4' },
			// { 'label': 'B5', 'value': 'B5' },
		]

		// JATIN 19/11/2024 11:57 AM  Start For Recruitment Letters add overlay class letter wise

		this.lettertype = [
			{ 'label': 'Agreement Letter', 'value': 1 },
			{ 'label': 'Appointment letter', 'value': 2 },
			{ 'label': 'Offer Letter', 'value': 3 },
			{ 'label': 'Other Letter', 'value': 4 },
			{ 'label': 'Termination Letter', 'value': 5 },
			{ 'label': 'Relieving Letter', 'value': 6 },
			{ 'label': 'Experience Letter', 'value': 7 },
		]                                                    
		
		this.exitlettertype = [
			{
				"value": "65432801f754ad4302549f37",
				"label": "Experience Letter"
			},
			{
				"value": "6543280bf754ad4302549f39",
				"label": "Termination Letter"
			},
			{
				"value": "6543280ff754ad4302549f3b",
				"label": "Relieving Letter"
			}
		]

		// JATIN 19/11/2024 11:57 END AM For Recruitment Letters add overlay class letter wise

		this.questiondifficulty = [
			{ 'label': 'Easy', 'value': 1 },
			{ 'label': 'Moderate', 'value': 2 },
			{ 'label': 'Hard', 'value': 3 }
		]

		// hemang jani
		// question type 
		this.Multi_Select_Question = 'Multi Select(MS)'
		this.Radio_Button_Question = 'Only One (Radio Button)'
		this.Written_Response_Question = 'Written Response (WR)'

		this.leaveStatusDropdown = [
			{
				label: "Pending",
				value: 1,
			},
			{
				label: "Approved",
				value: 2,
			},
			{
				label: "Rejected",
				value: 3,
			},
			{
				label: "Cancelled",
				value: 4,
			}
		]

		this.expenseStatusDropdown = [
			{
				label: "Pending",
				value: 0,
			},
			{
				label: "Approved",
				value: 1,
			},
			{
				label: "Rejected",
				value: 2,
			}
		]

		this.LateArrivalStatusDropdown = [       //   |  Pravin ~  18-04-2025 ~ 04:22 PM                                             
			{
				label: "Allowed",
				value: 2,
			},
			{
				label: "Not Allowed",
				value: 1,
			}
		]

		this.travelStatusDropdown = [
			{
				label: "Pending",
				value: 0,
			},
			{
				label: "Approved",
				value: 1,
			},
			{
				label: "Rejected",
				value: 2,
			},
			{
				label: "Canceled",
				value: 3,
			}
		]

		this.daysName = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
		this.daysMasterData = [
			{
				label: "Sun",
				value: "Sun"
			},
			{
				label: "Mon",
				value: "Mon"
			},
			{
				label: "Tue",
				value: "Tue"
			},
			{
				label: "Wed",
				value: "Wed"
			},
			{
				label: "Thu",
				value: "Thu"
			},
			{
				label: "Fri",
				value: "Fri"
			},
			{
				label: "Sat",
				value: "Sat"
			},

		]

		this.taskDateFilterType = [
			{
				label: "Create Date",
				value: 1,
			},
			{
				label: "Start Date",
				value: 2,
			},
			{
				label: "Due Date",
				value: 3,
			},
		]
		// add pending option smit surani  ~ 2025-06-26 ~ 014:56 PM
		this.reportStatusDropdown = [
			{
				label: "Re-open",
				value: 1,
			},
			{
				label: "Verified",
				value: 2,
			},
			{
				label: "Reported",
				value: 3,
			},
			{
				label: "Solved",
				value: 4,
			},
			{
				label: "Pending",
				value: 5,
			}
		]

		this.filterMasterdata = [
			{
				label: "All Employee",
				value: 1
			},
			{
				label: "All Clock-in",
				value: 2
			},
			{
				label: "All Clock-out",
				value: 3
			},
			{
				label: "All Break-in",
				value: 4
			},
			{
				label: "All Break-out",
				value: 5
			}
		]

		// Resource Request | Deep Dungarani ~ 2025-05-06 ~ 015:08 PM
		this.urgencylevel = [
			{
				label: "Immediate / Critical",
				value: 1
			},
			{
				label: "High Priority",
				value: 2
			},
			{
				label: "Medium Priority",
				value: 3
			},
			{
				label: "Future Requirement",
				value: 4
			},
		]

		this.resourcestatus = [		//  | Deep Dungarani ~ 2025-05-07 ~ 12:49 PM
			{
				label: "Pending",
				value: 0,
			},
			{
				label: "In Progress",
				value: 1,
			},
			{
				label: "Rejected",
				value: 2,
			},
			{
				label: "Closed",
				value: 3,
			}
		]

		this.openingresourcerequeststatus = [	//  | Deep Dungarani  ~ 2025-09-17
			{
				label: "All Resource Request(s)",
				value: 1,
			},
			{
				label: "Pending Resource Request(s)",
				value: 2,
			},
			{
				label: "In Progress Resource Request(s)",
				value: 3,
			}
		]

		this.DocumentVerificationStatus = [	//  | Deep Dungarani  ~ 2025-07-31
			{
				label: "All",
				value: 1,
			},
			{
				label: "Pending",
				value: 2,
			},
			{
				label: "Verification Pending",
				value: 3,
			},
			{
				label: "Approved",
				value: 4,
			},
			{
				label: "Rejected",
				value: 5,
			}
		]

		this.employee360DocumentVerificationStatus = [	//  | Deep Dungarani  ~ 2025-07-31
			{
				label: "All",
				value: 1,
			},
			{
				label: "Pending",
				value: 2,
			},
			// {
			// 	label: "Verification Pending",
			// 	value: 3,
			// },
			{
				label: "Approved",
				value: 4,
			},
			{
				label: "Rejected",
				value: 5,
			}
		]

		this.assigneeroletypes = {  //  smit surani  ~ 2025-05-20 ~ 10:48 AM
			manager: 1,
			taskassignee: 2,
			watcher: 3,
			owner: 4,
			projectassignee: 5,
			reviewer: 6,
			anyone: 7
		}
		this.actiontype = {  //  smit surani  ~ 2025-05-20 ~ 10:48 AM
			create: 1,
			edit: 2,
			delete: 3,
			import: 4,
		}
		this.tasktype = {  //  smit surani  ~ 2025-05-20 ~ 10:48 AM
			task: 1,
			subtask: 2,
			issue: 3,
			suggestions: 4,
		}
		this.filetypes = {  //  smit surani  ~ 2025-05-20 ~ 10:48 AM
			estimation: 1,
			startdate: 2,
			duedate: 3,
			qaestimation: 4,
		}

		// smit surani 03-09-2025
		this.billingtypes = [
			{
				'label': "Billable",
				'value': 'Billable'
			},
			{
				'label': "Non Billable",
				'value': 'Non Billable'
			},
		]

		// smit surani 03-09-2025
		this.operatingtypes = [
			{
				'label': "SDK",
				'value': 1
			},
			{
				'label': "LogBased",
				'value': 2
			},
			{
				'label': "SQL",
				'value': 3
			},
	
		]
		// smit surani 03-09-2025
		this.devicesdktypes = [
			{
				'label': "None",
				'value': 1
			},
			{
				'label': "ZkemSDK",
				'value': 2
			},
			{
				'label': "CosecSDk",
				'value': 3
			},
			{
				'label': "FPClockSDK",
				'value': 4
			},
			{
				'label': "SBXPCSDK",
				'value': 5
			},
			{
				'label': "FKAttendSDK",
				'value': 6
			},
			{
				'label': "FK524PXNSDK",
				'value': 7
			},
			{
				'label': "SBXPCT11SDK",
				'value': 8
			},
			{
				'label': "SBXPCSecureEye",
				'value': 9
			},
			{
				'label': "FPClockWithSecond",
				'value': 10
			},
	
		]
		// smit surani 03-09-2025
		this.sqltypes = [
			{
				'label': "MSSQL",
				'value': 1
			},
			{
				'label': "PostGreSQL",
				'value': 2
			},
	
		]

		//Use for letter / generate letter when creating custom tag , This define custom tag type | Renish Salakhana ~ 2025-11-24 ~ 12:15 PM
		this.letterCustomTagTypes = [
			{ 'label': 'Text Box', 'value': 1 },
			{ 'label': 'Date Picker', 'value': 2 },
			{ 'label': 'Dropdown', 'value': 3 },
			{ 'label': 'Multiple Select Dropdown', 'value': 4 },
		]

		this.documentRegexTypes = [			//  | Deep Dungarani  ~ 2025-06-10 ~ 06:51 PM
			{
				label: "PAN Card (ABCDE1234F)",
				value: "pancard",
				regex: "^[A-Z]{5}[0-9]{4}[A-Z]{1}$",
				documentname: "PAN Card",
				minlength: 10,
				maxlength: 10,
				showstart: 0,
				showend: 0
			},
			{
				label: "Aadhaar Card (234567890123)",
				value: "aadhaar",
				regex: "^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$",
				documentname: "Aadhaar Card",
				minlength: 12,
				maxlength: 12,
				showstart: 0,
				showend: 4,
				spacemasktype: true
			},
			{
				label: "Passport - India (A1234567)",
				value: "passport_india",
				regex: "^[A-Z]{1}[0-9]{7}$",
				documentname: "Passport - India",
				minlength: 8,
				maxlength: 8,
				showstart: 0,
				showend: 2
			},
			{
				label: "Passport - International (P12345678)",
				value: "passport_international",
				regex: "^[A-Z0-9<]{6,9}$",
				documentname: "Passport - International",
				minlength: 6,
				maxlength: 9,
				showstart: 0,
				showend: 2
			},
			{
				label: "Voter ID (ABC1234567)",
				value: "voter_id",
				regex: "^[A-Z]{3}[0-9]{7}$",
				documentname: "Voter ID",
				minlength: 10,
				maxlength: 10,
				showstart: 0,
				showend: 3
			},
			{
				label: "Driving License (DL0420111234567)",
				value: "driving_license_india",
				regex: "^(([A-Z]{2}[0-9]{2})((19|20)[0-9][0-9])([0-9]{7}))$",
				documentname: "Driving License",
				minlength: 16,
				maxlength: 16,
				showstart: 0,
				showend: 4
			},
			{
				label: "EPF - India (MHABC1234567)",
				value: "epf",
				regex: "^[A-Z]{2}[A-Z]{3}[0-9]{7}$",
				documentname: "EPF",
				minlength: 12,
				maxlength: 12,
				showstart: 0,
				showend: 3
			},
			{
				label: "UAN - India (123456789012)",
				value: "uan",
				regex: "^[0-9]{12}$",
				documentname: "UAN",
				minlength: 12,
				maxlength: 12,
				showstart: 0,
				showend: 4
			},
			{
				label: "ESI - India (1234567890)",
				value: "esi",
				regex: "^[0-9]{10}$",
				documentname: "ESI",
				minlength: 10,
				maxlength: 10,
				showstart: 0,
				showend: 3
			},
			{
				label: "National ID (ID12345678)",
				value: "national_id",
				regex: "^[A-Z0-9]{8,12}$",
				documentname: "National ID",
				minlength: 8,
				maxlength: 12,
				showstart: 0,
				showend: 4
			},
			{
				label: "Work Permit (WP12345678)",
				value: "work_permit",
				regex: "^[A-Z0-9]{8,15}$",
				documentname: "Work Permit",
				minlength: 8,
				maxlength: 15,
				showstart: 0,
				showend: 3
			},
			{
				label: "Bank Account (SBIN00012341234567890)",
				value: "bank_account",
				regex: "^[A-Z]{4}0[A-Z0-9]{6}[0-9]{9,18}$",
				documentname: "Bank Account",
				minlength: 19,
				maxlength: 28,
				showstart: 0,
				showend: 4
			},
			{
				label: "Educational Certificate (UNIV12345)",
				value: "educational_certificate",
				regex: "^[A-Z0-9]{5,15}$",
				documentname: "Educational Certificate",
				minlength: 5,
				maxlength: 15,
				showstart: 0,
				showend: 4
			},
			{
				label: "Professional License (MED123456)",
				value: "professional_license",
				regex: "^[A-Z0-9]{6,12}$",
				documentname: "Professional License",
				minlength: 6,
				maxlength: 12,
				showstart: 0,
				showend: 4
			},
			{
				label: "Company ID (EMP12345)",
				value: "company_id",
				regex: "^[A-Z0-9]{5,10}$",
				documentname: "Company ID",
				minlength: 5,
				maxlength: 10,
				showstart: 0,
				showend: 3
			}
		]

		// For Filter Date Wise Data | Deep Dungarani  ~ 2025-06-12 ~ 12:22 PM
		this.DateTimerDropdownData = [
			{
				'label': "Today",
				"value": "Today"
			},
			{
				'label': "Yesterday",
				"value": "YesterDay"
			},
			{
				'label': "Weekly",
				"value": "Weekly"
			},
			{
				'label': "Last 30 Days",
				"value": "Last 30 Days"
			},
			{
				'label': "Current Month",
				"value": "Current Month"
			},
			{
				'label': "Last Month",
				"value": "Last Month"
			},
			{
				'label': "Last Year",
				"value": "Last Year"
			},
			{
				'label': "Custom",
				'value': "Custom",
			},
		]

		//status dropdown data | Deep Dungarani  ~ 2025-06-12 ~ 01:15 PM
		this.statusDropdown = [
			{
				label: "Pending",
				value: 1,
			},
			{
				label: "Approved",
				value: 2,
			},
			{
				label: "Rejected",
				value: 3,
			}
		]

		//status dropdown data | Deep Dungarani  ~ 2025-07-14 ~ 01:15 PM
		this.letterstatusDropdown = [
			{
				label: "Pending",
				value: 0,
			},
			{
				label: "Approved",
				value: 1,
			},
			{
				label: "Rejected",
				value: 2,
			}
		]

		//  smit surani  ~ 2025-07-03 ~ 014:41 PM
		this.downloadLinks = {
			Windows: 'https://bizcompass.s3.ap-south-1.amazonaws.com/Chatapplication/Windows/Bizcompass_Chat.zip',
			iOS: 'https://apps.apple.com/us/app/bizcompass/id6462398295',
			// Linux: 'https://bizcompass.s3.ap-south-1.amazonaws.com/Chatapplication/linux/bizcompass_chat.deb',
			Linux:'https://bizcompass.s3.ap-south-1.amazonaws.com/Chatapplication/linux/install.sh',
			Android: 'https://play.google.com/store/apps/details?id=com.bizcompass.chat',
			'Mac OS': 'https://apps.apple.com/us/app/bizcompass/id6462398295',
		}
		this.csvLeaveDataJSON = [ //  smit surani  ~ 2025-07-14 ~ 01:00 PM
			{
				'text': 'Employee Name',
				'field': 'personame'
			},
			{
				'text': 'Hour(s)',
				'field': 'hours'
			},
			{
				'text': 'From Date',
				'field': 'fromdate'
			},
			{
				'text': 'To Date',
				'field': 'todate'
			},
			{
				'text': 'From Time',
				'field': 'fromtime'
			},
			{
				'text': 'To Time',
				'field': 'totime'
			},
			{
				'text': 'Leave Type',
				'field': 'leavetype'
			},
			{
				'text': 'Leave Reason',
				'field': 'reason'
			},
		]

		// Date type dropdown data For Hr Dashboard in Candidate Status Chart | Deep Dungarani  ~ 2025-07-18 ~ 01:00 PM
		this.dateTypeDropdownData = [
			{ label: "Filter by Followup Date", value: 1 },
			{ label: "Filter by Entry Date", value: 2 }
		  ]

		this.reasonType = [ //  | Deep Dungarani  ~ 2025-08-21
			{ label: "Termination", value: 1 },
			{ label: "Layoff", value: 2 },
			{ label: "Internship Completion", value: 3 }
		]

		this.noticeperioddurationtype = [ // Deep Dungarani  ~ 2025-08-25 ~ 09:31 AM
			{ label: "Day(s)", value: 1 , days : 1},
			{ label: "Week(s)", value: 2 , days : 7},
			{ label: "Month(s)", value: 3 , days : 30 },
		]

		this.noticeperiodrecoverydata = [ // First Two Static Data For Notice Period Recovery | Deep Dungarani  ~ 2025-08-25 ~ 09:31 AM
			{ label: "CTC", value: '68ac46082af987a171d36ad4' },
			{ label: "Gross", value: '68ac46102af987a171d36ad5' },
		]

		this.handoverapprovaltype = [	// Use in HandoverApproval Tab | Deep Dungarani  ~ 2025-09-04 ~ 12:45 PM
			{ label: 'My Acknowledgement', value: 1 },
			{ label: 'My Approval(s)', value: 2 }
		]

		this.status = [		// Use in HandoverApproval Tab | Deep Dungarani  ~ 2025-09-04 ~ 12:45 PM
			{ label: 'Pending', value: 0 },
			{ label: 'Approved', value: 1 },
			{ label: 'Reject', value: 2 }
		]

		//  | Deep Dungarani  ~ 2025-10-31
		this.attendancerequirements = [
			{ label: "QR Code", value: "65488053a38bc57c5712c5d8" },
			{ label: "Face Recognition", value: "65488065a38bc57c5712c5d9" },
			{ label: "Two Factor Authentication", value: "6548b731a38bc57c5712c5e7" },
			{ label: "Attendance PIN", value: "6548b752a38bc57c5712c5e8" }
		]

		//  | Deep Dungarani  ~ 2025-10-31
		this.attendancebasedonsdevice = [
			{ label: "Attendance Hardware", value: "65487fc9a38bc57c5852c5d3" },
			{ label: "Sync Tool", value: "65487feca38bc57c5359c5d4" },
		]

		//  | Deep Dungarani  ~ 2025-11-03
		this.salarytype = [
			{
				'label': 'CTC',
				'value': 'CTC'
			},
			{
				'label': 'Monthly CTC',
				'value': 'Monthly CTC'
			},
			{
				'label': 'Yearly CTC',
				'value': 'Yearly CTC'
			},
		]

		// These Utils Use for the Performance Management | Renish Salakhana ~ 2025-12-19 ~ 014:40 PM
		this.performanceSingleMonthOption = [
			{
				label: 'January',
				value: ['2022-01-01T00:00:00.000Z']
			},
			{
				label: 'February',
				value: ['2022-02-01T00:00:00.000Z']
			},
			{
				label: 'March',
				value: ['2022-03-01T00:00:00.000Z']
			},
			{
				label: 'April',
				value: ['2022-04-01T00:00:00.000Z']
			},
			{
				label: 'May',
				value: ['2022-05-01T00:00:00.000Z']
			},
			{
				label: 'June',
				value: ['2022-06-01T00:00:00.000Z']
			},
			{
				label: 'July',
				value: ['2022-07-01T00:00:00.000Z']
			},
			{
				label: 'August',
				value: ['2022-08-01T00:00:00.000Z']
			},
			{
				label: 'September',
				value: ['2022-09-01T00:00:00.000Z']
			},
			{
				label: 'October',
				value: ['2022-10-01T00:00:00.000Z']
			},
			{
				label: 'November',
				value: ['2022-11-01T00:00:00.000Z']
			},
			{
				label: 'December',
				value: ['2022-12-01T00:00:00.000Z']
			}
		];

		this.performanceTwiceMonthOption = [
			{
				label: 'January - July',
				value: ['2022-01-01T00:00:00.000Z', '2022-07-01T00:00:00.000Z']
			},
			{
				label: 'February - August',
				value: ['2022-02-01T00:00:00.000Z', '2022-08-01T00:00:00.000Z']
			},
			{
				label: 'March - September',
				value: ['2022-03-01T00:00:00.000Z', '2022-09-01T00:00:00.000Z']
			},
			{
				label: 'April - October',
				value: ['2022-04-01T00:00:00.000Z', '2022-10-01T00:00:00.000Z']
			},
			{
				label: 'May - November',
				value: ['2022-05-01T00:00:00.000Z', '2022-11-01T00:00:00.000Z']
			},
			{
				label: 'June - December',
				value: ['2022-06-01T00:00:00.000Z', '2022-12-01T00:00:00.000Z']
			}
		];

		this.performanceQauterMonthOption = [
			{
				label: 'January - April - July - October',
				value: ['2022-01-01T00:00:00.000Z', '2022-04-01T00:00:00.000Z', '2022-07-01T00:00:00.000Z', '2022-10-01T00:00:00.000Z']
			},
			{
				label: 'February - May - August - November',
				value: ['2022-02-01T00:00:00.000Z', '2022-05-01T00:00:00.000Z', '2022-08-01T00:00:00.000Z', '2022-11-01T00:00:00.000Z']
			},
			{
				label: 'March - June - September - December',
				value: ['2022-03-01T00:00:00.000Z', '2022-06-01T00:00:00.000Z', '2022-09-01T00:00:00.000Z', '2022-12-01T00:00:00.000Z']
			}
		];

		this.performanceScoreAdjustPerson = [
			{ label: "Self", value: '6943b2ceffb0dba98bb15341', reviewertype : 0 },
			{ label: "Reporting Person", value: '6943b2eeffb0dba98bb15342' , reviewertype : 1 },
			{ label: "Reporting Person Level-2", value: '6943b310ffb0dba98bb15343', reviewertype : 2 },
			{ label: "Department Head", value: '6943c3a6ffb0dba98bb15345',  reviewertype : 4 },
			{ label: "Branch Head", value: '6943c398ffb0dba98bb15344' , reviewertype : 3 },
		]

		this.performanceScoreAdjust = [
			{ label: "Reporting Person", value: '6943b2eeffb0dba98bb15342' , reviewertype : 1 },
			{ label: "Reporting Person Level-2", value: '6943b310ffb0dba98bb15343', reviewertype : 2 },
			{ label: "Department Head", value: '6943c3a6ffb0dba98bb15345',  reviewertype : 4 },
			{ label: "Branch Head", value: '6943c398ffb0dba98bb15344' , reviewertype : 3 },
		]

		this.performanceReviewReminder = [
			{ label: "Self", value: '6943b2ceffb0dba98bb15341', reviewertype : 0 },
			{ label: "Reporting Person", value: '6943b2eeffb0dba98bb15342' , reviewertype : 1 },
			{ label: "Reporting Person Level-2", value: '6943b310ffb0dba98bb15343', reviewertype : 2 },
			{ label: "Department Head", value: '6943c3a6ffb0dba98bb15345',  reviewertype : 4 },
			{ label: "Branch Head", value: '6943c398ffb0dba98bb15344' , reviewertype : 3 },
			{ label: "Employee", value: "694e8550ba551ce8cd8840ea", reviewertype: 5}
		]

		this.meetingScheduleType = [
			{
				'label': 'Before Form-Filling',
				'value': 1
			},
			{
				'label': 'After Form-Filling',
				'value': 2
			},
		]

		this.weekOffDaysMasterData = [
			{
				label: "Sun",
				value: 0
			},
			{
				label: "Mon",
				value: 1
			},
			{
				label: "Tue",
				value: 2
			},
			{
				label: "Wed",
				value: 3
			},
			{
				label: "Thu",
				value: 4
			},
			{
				label: "Fri",
				value: 5
			},
			{
				label: "Sat",
				value: 6
			},

		]

		this.analyticstype = [		//  | Deep Dungarani ~ 2025-12-23 ~ 12:49 PM
			{
				label: "Department",
				value: 1,
			},
			{
				label: "Employee",
				value: 2,
			},
			{
				label: "Manager",
				value: 3,
			},
		]

		this.performancereviewstatuslist = [
			{ label: "Review Initialized", value: 1 },
			{ label: "Submitted Review Form (per reviewer)", value: 2 },
			{ label: "Feedback Flow Completed (when forms submitted by all reviewers)", value: 3 },
			{ label: "Review Edited", value: 4 },
			{ label: "Review Cancled", value: 5 },
			{ label: "Publish the Review to Employee", value: 6 },
			{ label: "Relaunched", value: 7 },
		]

		this.relaunchReviewTypeOptions = [
			{ value: 1, label: 'BackTrack Review' },
			{ value: 2, label: 'Clear Review' }
		]

		// End Utils Use for the Performance review | Renish Salakhana ~ 2025-12-19 ~ 014:40 PM
		// ************************************************************************************** static masterdataarray end  **************************************************************************************

		this.attendancebasedonsdevicehardwareid = '65487fc9a38bc57c5852c5d3'
		this.attendancebasedonsdevicesynctoolid = '65487feca38bc57c5359c5d4'
		this.attendancepinid = '6548b752a38bc57c5712c5e8'

		this.projectStatusPriorityid = '624132478f287a7ade43270f'
		this.projectStatusSeverityid = '624132628f287a7ade432710'


		//report

		this.projectMonthReportId = '6294a419ecad4a1d874c6de2'
		this.projectDateReportId = '6294a426ecad4a1d874c6de3'
		this.projectModuleReportId = '6294a42fecad4a1d874c6de4'
		this.projectHourReportId = '6824655abb2b48928cd9bb57'
		this.assigntaskReportId = '6294a43aecad4a1d874c6de5'
		this.assigntaskTimeReportId = '6294a444ecad4a1d874c6de6'
		this.prioritywiseissueReportId = '6294a44eecad4a1d874c6de7'
		this.modulewiseissuecountReportId = '6294a45aecad4a1d874c6de8'
		this.devloperwiseissueReportId = '6294a462ecad4a1d874c6de9'
		this.modulewiseissueReportId = '6294a46becad4a1d874c6dea'
		this.subTasksReportId = '6294a46becad4a1d874c6deb'
		this.esiSummaryReportId = '6854f99e708b6f8292dee3e3' //  smit surani  ~ 2025-06-23 ~ 10:10 AM
		this.esiStatementReportId = '6854f9a5708b6f8292dee3e4'  //  smit surani  ~ 2025-06-23 ~ 10:10 AM
		this.epfoReportId = '68551371708b6f8292dee3ee'
		this.pfSummaryReportId = '68551362708b6f8292dee3ed'
		this.ptSummaryReportId = '6855016c708b6f8292dee3e6'

		// static id of templatemode
		this.employeelayoffnoticeid = '65bb59057ad291fb5568a886'
		this.employeeterminationnoticeid = '65bb58f57ad291fb5568a885'
		this.resignationapprovalid = '65bb58d27ad291fb5568a884'
		this.internshipcompletiontemplateid = '68ec8bb514c2c1d7950eebad'

		// grid list scroll condition
		this.ScrollLimit = 100 // in px

		//max length limit in textarea
		this.maxLength = 200

		//for cp
		this.usertypes = {
			'partner': '63dcd2f43811fd853fac3f39',
			'adminuser': '63dcd2f43811fd853fac3f40',
			'customer': '63dcd2f43811fd853fac3f41'
		}

		// Exit Application Process - Bizcompass Default ID | Deep Dungarani  ~ 2025-08-20
		this.appintegrationid = '625d5ed5220ccd5a20904f79'

		//for Booking Deep Dungarai
		this.surveytypeConsultationid = '67af2216653e40b9c0e9e9da'

		//holiday type 
		this.nationalholidaytype = '6361fb29d0da1129f71ece35'
		this.otherholidaytype = '62625d2afd2d8646838a357f'
		this.holidaytypeid = '623d42d0eb3c098777fb4a73'

		// Deep Dungarani - Set Default Color For Color Picker
		this.colorPickerDefaultBGColor = { 'r': 102, 'g': 41, 'b': 238, 'a': 1 }
		this.colorPickerDefaultTextColor = { 'r': 255, 'g': 255, 'b': 255, 'a': 1 }

		// Utsav [color picker Coustom Created Colors]
		this.colorPickerColorsArray = [
			"#2cc8ba", "#fbc11e", "#f6a96d", "#4ed3e5", "#b99897", "#f56b62",
			"#74cb80", "#08aeea", "#ff7bd7", "#67a0ff", "#49e6cf", "#e6cb4c",
			"#a7bcee", "#a593ff", "#c5a070", "#8cbabb", "#98ca3c", "#558dca",
			"#db9aca", "#a9b2c0"
		]

		//  | Deep ~  2025-03-04 ~ 4:15 PM  [Color Picker Shade Colors]
		this.colorPaletteArray = [
			"#B1B1B1", "#EC7F7F", "#FFB74D", "#7AD47B", "#A0DCEC", "#A5A1F4", "#FFA6D0", "#CBA6FB",
			"#9E9E9E", "#E75757", "#FFA600", "#32BA3D", "#7DCEE5", "#8A8EF0", "#FF7BB9", "#B787F9",
			"#7E7E7E", "#D30808", "#FB8C00", "#17903C", "#0092C2", "#5956E3", "#FF4A9F", "#976AF8",
			"#626262", "#B10606", "#F57C00", "#115B32", "#287A90", "#4A49D1", "#FF0A7D", "#7D55D6",
			"#515151", "#8F0505", "#ef6c00", "#0E482C", "#185C6E", "#3B39BF", "#FF0076", "#6543B3",
		]

		this.bgColorsArray = ['#A8A6DA', '#8456CE', '#99B0FC', '#5552B6', '#F9D34D', '#9CEDFF', '#78FFFF', '#FF536C',
			'#4B167F', '#CC4F5C', '#6839DD', '#B109F9', '#24AF32', '#D6C335', '#1D2462', '#97A1D9',
			'#F94DC0', '#359DB2', '#E01FD3', '#BA6E27', '#F9A12E', '#9B4A97', '#5B84B1', '#FC766A',
			'#2E41BA', '#3F118E', '#B74312', '#2C6F77', '#07565F', '#FFA600']


		//  | Utsav ~  2024-12-25 ~ 10:15 AM
		this.surveyFormRightSideBarColorArray = ['#f7f7f7', '#ff7b89', '#ed9661', '#f9df18', '#44edd1', '#efb734', '#5ee569', '#fc71b4', '#9879ff', '#c6c6c6', '#2ab0d3', '#adb929', '#92c6f3', '#d8b9ff', '#fe3333']

		this.targetAnalysisColors = [
			"#1D2462", "#47418F", "#4A5596", "#6978CA", "#97A1D9", "#8692D3",
			"#1D2462", "#47418F", "#4A5596", "#6978CA", "#97A1D9", "#8692D3",
			"#1D2462", "#47418F", "#4A5596", "#6978CA", "#97A1D9", "#8692D3",
			"#1D2462", "#47418F", "#4A5596", "#6978CA", "#97A1D9", "#8692D3",
			"#1D2462", "#47418F", "#4A5596", "#6978CA", "#97A1D9", "#8692D3",
			"#1D2462", "#47418F", "#4A5596", "#6978CA", "#97A1D9", "#8692D3",
			"#1D2462", "#47418F", "#4A5596", "#6978CA", "#97A1D9", "#8692D3",
		]

		// Emp360 -> Document Tab -> Create Folder Colors : Utsav
		this.createFolderColorArray = [
			"#FFD25F", "#E53E3E", "#ED701B", "#38A169", "#2C7A7B", "#3182CE",
			"#805AD5", "#D53F8C", "#A0AEC0", "#FEB2B2", "#F6AD55", "#9AE6B4",
			"#81E6D9", "#90CDF4", "#D6BCFA", "#FBB6CE"
		]

		// For Char Below Array
		this.chartColorArray = [
			"#32D6C7", "#EBBA30", "#56D9EB", "#D29E9D", "#FA6157", "#59D96A", "#10BFFE", "#5F99F9",
			"#F4D232", "#9D89FC", "#E2A95F", "#7EB6B7", "#619AD9", "#D387BF", "#9FAEC7", "#A8A6DA",
			"#99B0FC", "#5552B6", "#9CEDFF", "#FF536C", "#CC4F5C", "#97A1D9", "#359DB2", "#BA6E27",
			"#9B4A97", "#5B84B1", "#FC766A", "#2E41BA", "#3F118E", "#2C6F77", "#FFA600", "#F48C9D",
			"#C893FD", "#A629FB", "#64CE9A", "#89B8FF", "#ED9661", "#DBF26A", "#0BB0E2", "#FC71B4",
			"#BA593B", "#646D01", "#36A5AA", "#AD312B", "#3484BA", "#DD35C7", "#F4A35D", "#09476B",
			"#772EF4", "#E5D349", "#ED4B66", "#32BC75", "#36B6C1", "#E2671B", "#3F8FBA", "#E2444C",
			"#7167E5", "#C1460D", "#BD63ED", "#ED6B34", "#DD3061", "#4649DD", "#E560A9", "#C46E4C",
			"#18DB7C", "#126B8C", "#1094A5", "#C10D4F", "#1C86DD", "#EF3B98", "#148AA8", "#4B82C1",
			"#D69711", "#5C89F9", "#6C48BA", "#E5505A", "#5AE8D5", "#C63B6A", "#8A38ED", "#F74716",
			"#245599", "#5496BF", "#D84841", "#1FDDB7", "#E8BB68", "#E04E53", "#66F47C", "#3567A5",
			"#C9507A", "#0E9E7C", "#DD635F", "#1164F4", "#F9830C", "#0CE1F4", "#33B52F", "#58C7EF",
			"#5B15F2", "#E5881D", "#4784AA", "#DBCF29", "#D1AB14", "#37EFAC", "#6B5CD1", "#2B3DC4",
			"#BF670F", "#C1121F", "#DDA15E", "#669BBC", "#A2D2FF", "#0582CA", "#3C6E71",
			"#B7410E", "#B23A48", "#2C6E49", "#7A4419", "#62B6CB", "#F85E00", "#0466C8", "#918450",
			"#2A3C24", "#9381FF", "#F8F4EC", "#F3E5AB", "#01BEFE", "#FF9E00", "#70161E", "#D6A2AD",
			"#69B578", "#F58CB7", "#05858A", "#E4D6A7", "#42A5F5", "#CBF7ED", "#BCBD8B", "#F2B5D4",
			"#FFC23D", "#DDA15E", "#52B69A", "#B6AD90", "#E4D9FF", "#EE6C4D", "#410445", "#AEEA94",
			"#16C47F", "#E9FF97", "#7C73C0", "#E384FF", "#612897", "#FBF46D", "#A799B7", "#B4AEE8",
			"#C0E218", "#17706E", "#B21F66", "#9818D6", "#FBCEB5", "#12CAD6", "#F1FA3C", "#204969",
			"#00D1CD", "#207DFF", "#F1FFAB", "#99DDCC", "#7E2553", "#E8FFE8", "#00AD7C", "#FF7A5A",
			"#7CDFFF", "#17B978", "#97866A", "#A89C29", "#8967B3", "#C5705D", "#36BA98", "#FFBF78",
			"#453F78", "#6D2932", "#FFA38F", "#A91079", "#A6CDC6", "#FF5403", "#49FF00", "#890596",
			"#0028FF", "#E41749", "#000000", "#BD4291", "#C15050", "#BC658D", "#0D4715", "#FBA834",
			"#A5158C", "#FF9A9A", "#00B4D8", "#755C1B", "#61F2C2", "#007EA7", "#72A4A8", "#9B6A6C",
			"#A63C06"
		]


		// this.filesTypeListArray = ['txt', 'csv', 'json', 'html', 'xml', 'pdf', 'doc', 'docx', 'xls', 'ppt', 'pptx', 'mp4', 'webm', 'jpg', 'jpeg', 'png']
		// this.filesTypeListArray = ['pdf','mp4','jpg', 'jpeg', 'png']
		this.allowedfiletypes = ['pdf', 'jpg', 'jpeg', 'png']

		// Utsav - 20-06-25 ~ Emp360 -> Document Feature
		this.filesTypeListArray = [
			'txt', 'csv', 'json', 'html', 'xml', 'pdf', 'doc', 'docx', 'xls', 'xlsx',
			'ppt', 'pptx', 'mp4', 'webm', 'jpg', 'jpeg', 'png', 'gif', 'svg', 'webp',
			'zip', 'js', 'css', 'php', 'rar', '7z', 'tar', 'gz', 'mp3', 'wav', 'ogg',
			'avi', 'mov', 'wmv', 'flv', 'mkv', 'bmp', 'tiff', 'ico', 'psd', 'ai',
			'eps', 'sketch', 'fig', 'py', 'java', 'cpp', 'c', 'cs', 'rb', 'go', 'rs',
			'swift', 'kt', 'ts', 'vue', 'jsx', 'tsx', 'sass', 'scss', 'less', 'styl'
		]

		// Updated file type colors
		this.fileTypeColors = { // Utsav - 20-06-25 ~ Emp360 -> Document Feature
			// Text and Data Files
			txt: '#5C6BC0',       // Indigo
			csv: '#00897B',       // Teal
			json: '#455A64',      // Blue Grey
			xml: '#6D4C41',       // Brown

			// Web Files
			html: '#E44D26',      // Orange-Red
			css: '#1572B6',       // Blue
			js: '#dec818',        // Yellow
			php: '#777BB4',       // Purple

			// Document Files
			pdf: '#D30808',       // Red
			doc: '#1565C0',       // Blue
			docx: '#1E88E5',      // Light Blue
			xls: '#2E7D32',       // Green
			xlsx: '#43A047',      // Light Green
			ppt: '#D84315',       // Deep Orange
			pptx: '#FB8C00',      // Orange

			// Archive Files
			zip: '#9C27B0',       // Purple
			rar: '#673AB7',       // Deep Purple
			'7z': '#3F51B5',      // Indigo
			tar: '#2196F3',       // Blue
			gz: '#03A9F4',        // Light Blue

			// Audio Files
			mp3: '#4CAF50',       // Green
			wav: '#8BC34A',       // Light Green
			ogg: '#CDDC39',       // Lime

			// Video Files
			mp4: '#6A1B9A',       // Purple
			webm: '#8E24AA',      // Light Purple
			avi: '#9C27B0',       // Purple
			mov: '#E91E63',       // Pink
			wmv: '#F44336',       // Red
			flv: '#FF5722',       // Deep Orange
			mkv: '#795548',       // Brown

			// Image Files
			jpg: '#F57C00',       // Orange
			jpeg: '#976AF8',      // Purple
			png: '#1DAB45',       // Green
			gif: '#EC407A',       // Pink
			svg: '#0092C2',       // Cyan
			webp: '#00ACC1',      // Light Cyan
			bmp: '#FF9800',       // Orange
			tiff: '#FFC107',      // Amber
			ico: '#FFEB3B',       // Yellow

			// Design Files
			psd: '#31A8FF',       // Photoshop Blue
			ai: '#FF9A00',        // Illustrator Orange
			eps: '#F79100',       // EPS Orange
			sketch: '#F5AF02',    // Sketch Yellow
			fig: '#F24E1E',       // Figma Red

			// Programming Languages
			py: '#3776AB',        // Python Blue
			java: '#ED8B00',      // Java Orange
			cpp: '#00599C',       // C++ Blue
			c: '#555555',         // C Gray
			cs: '#239120',        // C# Green
			rb: '#CC342D',        // Ruby Red
			go: '#00ADD8',        // Go Cyan
			rs: '#000000',        // Rust Black
			swift: '#FA7343',     // Swift Orange
			kt: '#7F52FF',        // Kotlin Purple

			// Web Technologies
			ts: '#3178C6',        // TypeScript Blue
			vue: '#4FC08D',       // Vue Green
			jsx: '#61DAFB',       // React Cyan
			tsx: '#61DAFB',       // React TypeScript Cyan
			sass: '#CF649A',      // Sass Pink
			scss: '#CF649A',      // SCSS Pink
			less: '#1D365D',      // Less Blue
			styl: '#FF6347',      // Stylus Tomato
		}

		this.fileTypesWithIcons = ['js', 'html', 'css', 'php']


		//survey theme color bydefault  --aniket
		this.surveyThemeColor = '#7DCEE5'
		//   star rating icons
		this.star_fill = <svg className='star star-curser' xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 64 61.335">
			<path id="star_13_" data-name="star (13)" d="M63.833,23.669A3.4,3.4,0,0,0,60.9,21.33L42.433,19.653l-7.3-17.1a3.4,3.4,0,0,0-6.256,0l-7.3,17.094L3.093,21.33a3.406,3.406,0,0,0-1.931,5.953L15.125,39.528,11.008,57.666a3.4,3.4,0,0,0,5.059,3.675L32,51.817l15.928,9.524a3.4,3.4,0,0,0,5.062-3.675L48.873,39.528,62.836,27.285a3.4,3.4,0,0,0,1-3.616Zm0,0" transform="translate(0 -0.491)" fill="#ffc107" />
		</svg>

		this.star_unfill = <svg className='star star-curser' xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 64 61.335">
			<path id="star_14_" data-name="star (14)" d="M14.325,61.827a3.407,3.407,0,0,1-3.315-4.16l4.117-18.137L1.165,27.284a3.4,3.4,0,0,1,1.928-5.953l18.475-1.677,7.3-17.094a3.4,3.4,0,0,1,6.256,0l7.3,17.1L60.9,21.331a3.405,3.405,0,0,1,1.934,5.953L48.875,39.527l4.117,18.137a3.4,3.4,0,0,1-5.061,3.675L32,51.818,16.069,61.344a3.409,3.409,0,0,1-1.744.483ZM32,47.717a3.41,3.41,0,0,1,1.744.482L48.78,57.192,44.894,40.074a3.4,3.4,0,0,1,1.078-3.315L59.156,25.2,41.712,23.612a3.4,3.4,0,0,1-2.827-2.062L32,5.418,25.107,21.552a3.388,3.388,0,0,1-2.818,2.054L4.842,25.19,18.026,36.753A3.4,3.4,0,0,1,19.1,40.071L15.221,57.189,30.256,48.2A3.408,3.408,0,0,1,32,47.717ZM21.427,19.984a.008.008,0,0,1,0,.005Zm21.142-.008,0,.005S42.571,19.979,42.568,19.976Zm0,0" transform="translate(0 -0.492)" fill="#ffe188" />
		</svg>

		//   HR & PayRoll
		this.directExpenceAccountGroup = '62eca83a384be1b8c428a740'

		/***************************************************************** 3rd Party Integration Start  *****************************************************************/

		// meta integration
		this.metaversion = '21.0'
		// ads_read removed
		this.metafields = 'name,email' //Aniket Bhesaniya
		this.metascope = 'email,public_profile,pages_show_list,pages_manage_metadata,pages_read_engagement,leads_retrieval,ads_management,pages_manage_ads,business_management,pages_read_user_content'
		this.fbgraphurl = 'https://graph.facebook.com'
		// meta integration

		// whatsapp integration ~ start | Nirzar Gabani 💀 ~  2025-04-03 ~ 11:07 AM
		this.whatsappversion = '21.0'
		this.whatsappscope = 'whatsapp_business_management,whatsapp_business_messaging,business_management'
		this.whatsappfields = 'name, email, picture'
		// whatsapp integration ~ end | Nirzar Gabani 💀 ~  2025-04-03 ~ 11:07 AM

		this.crmchannelids = {
			metachannelid: '670cbf5cae87f286e1393378',
		}


		this.campaignAttributeTypeIds = {
			'pricepackage': '6710abca370eb79fd4237c65',
			'purpose': '6710abbd370eb79fd4237c64',
			'lifeevent': '670e1ddf8fbd9eef8ccd674b',
			'agerange': '670e1bd78fbd9eef8ccd674a',
			'keyword': '670e059ed9838b8b6377820c',
			'adextension': '670e057fd9838b8b6377820b',
			'houseHoldincome': '670e0572d9838b8b6377820a',
			'color': '670e055ed9838b8b63778209',
			'similiaraudience': '670e0549d9838b8b63778208',
			'affinity': '670e0532d9838b8b63778207',
			'bidstratergydelivery': '670e045fd9838b8b63778203',
			'device': '670e0416d9838b8b63778202',
			'creativetype': '670df7dad9838b8b637781fb',
			'detaileddemographics': '670df7ced9838b8b637781fa',
			'financialoffer': '670df7c3d9838b8b637781f9',
			'inmarketaudience': '670df7a7d9838b8b637781f8',
			'language': '670df79cd9838b8b637781f7',
			'location': '670df78dd9838b8b637781f6',
			'parental': '670df781d9838b8b637781f5',
			'placement': '670df776d9838b8b637781f4',
			'tgearning': '670df759d9838b8b637781f3',
			'customaudience': '670df749d9838b8b637781f2',
			'interest': '670df6cb8fbd9eef8ccd6732',
			'gender': '670de504d9838b8b637781ef',
		}

		/***************************************************************** 3rd Party Integration End  *****************************************************************/

		/***************************************************************** Server Level Enviroment Configuration Start  *****************************************************************/
		if (this.servermode == "dev") // Development 
		{
			this.bizsupportProjectName = [{ 'label': 'Pixel', 'value': '64145e1f2acde693d6a84a48' }]
			this.bizsupportticketsubdomain = "iis"
			this.protocol = 'http://'
			this.maindirpath = '/'
			this.dirpath = this.maindirpath + ''

			if (localStorage.getItem('ip')) {
				this.host = "192.168.2." + localStorage.getItem('ip') + ':8080' + this.dirpath
			}
			else {
				// this.host = "192.168.2.146:8080" + this.dirpath  //darsh's ip
				// this.host = "192.168.2.74:8080" + this.dirpath //Priyanshi's ip
				// this.host = "192.168.2.149:8080" + this.dirpath //Jatin's ip
				// this.host = "192.168.2.78:8080" + this.dirpath //Ruchir's ip
				// this.host = "192.168.2.18:8080" + this.dirpath //darsh's ip
				// this.host = "192.168.2.17:8080" + this.dirpath  //Tilak's ip
				// this.host = "192.168.2.158:8080" + this.dirpath //aman's ip
				// this.host = "192.168.2.70:8080" + this.dirpath //nirzar's ip
				// this.host = "192.168.2.68:8080" + this.dirpath //hemang's ip
				this.host = "192.168.2.74:8080" + this.dirpath //shubham's ip
			}
			this.endpointverson = 'v1/'
			this.weburl = this.protocol + this.host + this.endpointverson
			this.pmsweburl = this.weburl
			this.docpath = this.docroot
			this.cdnurl = this.protocol + this.host
			this.regdomain = '.bizcompass.app'
			this.mailurl = "192.168.2.2/PolyCafe_Test/"
			this.endpointurl = this.protocol + "" + this.dirpath + 'api/' + this.endpointverson

			// this.socketurl = 'http://192.168.1.19:3001/socket.io/socket.io.js'

			if (localStorage.getItem('socketip')) {
				this.socketserver = "http://192.168.2." + localStorage.getItem('socketip') + ':8083'
				this.apisocketserver = "http://192.168.2." + localStorage.getItem('socketip') + ':8080'
			}
			else {
				this.socketserver = "http://192.168.2.74:8083"  //Ruchir's ip
				this.apisocketserver = "http://192.168.2.74:8080"  //Ruchir's ip
				// this.socketserver = "http://192.168.2.77:8083"  //Tilak's ip
				// this.socketserver = "http://192.168.2.176:8083"  //Priyanshi's ip
			}

			// if(localStorage.getItem('socket')){
			// this.encryptdata = true
			// }else{
			this.encryptdata = false
			// }
			// this.encryptSocketData = false
			this.encryptStorage = false
			if (localStorage.getItem('socket')) {
				// this.encryptdata = true
				this.callSocketApi = true
				this.encryptSocketData = false
				this.useSocketForAPI = true
			} else {
				this.callSocketApi = false
				this.encryptSocketData = false
				this.useSocketForAPI = false
			}
			this.version = 12
			this.POOL_NAME = 'uat_file_upload'
			this.POOL_PASS = 'Asd@123!@#'
			this.USER_POOL_ID = "us-east-1_SeuSlO9eP"
			this.POOL_CLIENT_ID = '3pulqd4j3vuund57cnpqi6qjkt'
			this.IDENTITY_POOL_ID = 'us-east-1:f8afd869-aa67-4b6c-917a-a82254e28fdb'
			this.S3_BUCKET_NAME = 'uat-bizcompass'

		}
		else if (this.servermode == "prod") // live 
		{
			this.protocol = 'https://'
			this.maindirpath = '/'
			this.dirpath = this.maindirpath + '' /* Directory Name */
			this.host = "api.bizcompass.io" + this.dirpath
			this.pmshost = "pms.bizcompass.io" + this.dirpath
			this.endpointverson = 'v1/'
			this.weburl = this.protocol + this.host + this.endpointverson
			this.pmsweburl = this.protocol + this.pmshost + this.endpointverson
			this.docpath = this.docroot
			this.cdnurl = this.protocol + this.host
			this.regdomain = '.bizcompass.app'
			this.mailurl = " "
			this.endpointurl = this.protocol + "" + this.dirpath + 'api/' + this.endpointverson

			// this.socketurl = 'http://192.168.1.26:3001/socket.io/socket.io.js'


			this.socketserver = 'https://socket.bizcompass.io/'
			this.apisocketserver = 'https://api.bizcompass.io/'

			this.encryptdata = true
			this.encryptSocketData = false
			this.version = 12
			this.encryptStorage = true
			// if (localStorage.getItem('socket')) {
			this.callSocketApi = localStorage.getItem('ENABLE_DEBUG') !== 'BizConfig@.$000'
			this.useSocketForAPI = true

			// }
			// else {
			// 	this.useSocketForAPI = false
			// 	this.callSocketApi = false
			// }
			this.encryptSocketData = false
			this.POOL_NAME = 'bizcompass_react'
			this.POOL_PASS = 'Asd@123!@#'
			this.USER_POOL_ID = "us-east-1_9wd50z9ge"
			this.POOL_CLIENT_ID = '2hptp1b8v23u956u07t7m8i167'
			this.IDENTITY_POOL_ID = 'us-east-1:137d1c33-8a04-41ac-b128-12625c37f357'
			this.S3_BUCKET_NAME = 'bizcompass'
			this.bizsupportProjectName = [{ 'label': 'Bizcompass', 'value': '638859f4ca22ffd4b10f1b12' }]
			this.bizsupportticketsubdomain = "instanceit"
		}
		else if (this.servermode == "uat") // test 
		{
			this.protocol = 'https://'
			this.maindirpath = ''
			this.dirpath = this.maindirpath + '' /* Directory Name */
			// this.host = "env-9935174.in1.cantechcloud.com/" + this.dirpath
			this.host = "api.bizcompassapp.com/" + this.dirpath
			this.endpointverson = 'v1/'
			this.weburl = this.protocol + this.host + this.endpointverson
			this.pmsweburl = this.weburl
			this.docpath = this.docroot
			this.cdnurl = this.protocol + this.host
			this.regdomain = '.bizcompass.app'
			this.mailurl = " "
			this.endpointurl = this.protocol + "" + this.dirpath + 'api/' + this.endpointverson

			// this.socketurl = 'http://192.168.1.26:3001/socket.io/socket.io.js'
			this.apisocketserver = 'https://api.bizcompassapp.com'
			this.socketserver = 'https://socket.bizcompassapp.com'
			// this.socketserver = 'https://api.bizcompassapp.com'
			this.encryptdata = false
			this.encryptSocketData = false
			this.version = 12
			this.encryptStorage = true
			// if (localStorage.getItem('nosocket')) {
			// 	this.useSocketForAPI = false
			// 	this.callSocketApi = false
			// }
			// else {
			this.callSocketApi = localStorage.getItem('ENABLE_DEBUG') !== 'BizConfig@.$000'
			this.useSocketForAPI = true
			// }
			this.encryptSocketData = false
			this.POOL_NAME = 'uat_file_upload'
			this.POOL_PASS = 'Asd@123!@#'
			this.USER_POOL_ID = "us-east-1_SeuSlO9eP"
			this.POOL_CLIENT_ID = '3pulqd4j3vuund57cnpqi6qjkt'
			this.IDENTITY_POOL_ID = 'us-east-1:f8afd869-aa67-4b6c-917a-a82254e28fdb'
			this.S3_BUCKET_NAME = 'uat-bizcompass'
			this.bizsupportProjectName = [{ 'label': 'BizSupport - 2025', 'value': '67e4f6fbd5cb37d26b6daa33' }]
			this.bizsupportticketsubdomain = "mohitgroup98"
		}
		/***************************************************************** Server Level Enviroment Configuration End  *****************************************************************/


		//priyanshi - for s3 url
		this.s3UrlWithRegion = `https://${this.S3_BUCKET_NAME}.s3.${this.s3_file_upload_region}.amazonaws.com/`
		this.s3UrlWithoutRegion = `https://${this.S3_BUCKET_NAME}.s3.amazonaws.com/`
		//for error message
		this.errmsg = {
			'networkerror': 'Network error. Please check your connection.',
			'noresreceived': 'No response received. Please check your network connection.',
			'reqsetiperror': 'Request setup error. Please check your configuration.',
			'reqtimeout': 'The request timed out. Please try again later.',
			'insert': 'Data inserted successfully.',
			'update': 'Data updated successfully.',
			'delete': 'Data deleted successfully.',
			'reqired': 'Please fill in all required fields.',
			'inuse': 'Data is already in use.',
			'isexist': 'Data already exist.',
			'dberror': 'Something went wrong, Error Code : ',
			'userright': "Sorry, You don't have enough permissions to perform this action",
			'success': "Data found",
			'error': "Error",
			'nodatafound': "No data found",
			'uservalidate': "User Validate.",
			'deactivate': "Your account is suspended, please contact administrator to activate account.",
			'invalidrequest': "Invalid request.",
			'sessiontimeout': "Session timeout",
			'dataduplicate': "Data Duplicated Succesfully",
			'tokenvalidate': "Token validated",
			'invalidtoken': "Invalid token.",
			'tokenisvalid': "Token Is Valid.",
			'usernotfound': "User not found",
			'invalidusername': "Invalid Username or Password.",
			'invalidpassword': "Invalid Username or Password..",
			'verifyemail': "Please verify your email addess",
			'filetype': "Invalid file extension",
			'loginright': "Sorry, You don't have enough permissions to login. Please contact admin",
			'somethingwrong': 'Sorry, something went wrong.',
			'loginsuccess': "Login Successfully",
			'logoutsuccess': "Logout Successfully",
			'appupdate': "We have released new version of Poly Cafe App. Download the update and install to continue use this App.",
			'profile-update': "Profile updated successfully",
			'passchanged': "Password changed successfully",
			'correctpass': "Please enter correct old password",
			'csvdownload': "CSV downloaded successfully",
			'invalidbarcode': "Invalid barcode",
			'itemalreadyassign': "Item already assigned",
			'itemassign': "Item assigned successfully",
			'itemreassign': "Item reassigned successfully",
			'newnodeadd': "New Nodes added successfully",
			'nodedelnot': "Can't delete super admin node",
			'nodedel': "Node deleted successfully",
			'noitemfound': "No item found",
			'cancelorditem': "Order item cancelled successfully",
			'reqorderseries': "Order series data is required",
			'nonotifound': "No notification found",
			'noorderfound': "No order found",
			'itemready': "Item has been ready successfully",
			'itemserved': "Item has been served successfully",
			'paycollectsuccess': "Payment collected successfully",
			'orderaccept': "Order accepted successfully",
			'ordpreparetime': "Order preparation time updated successfully",
			// harsh 10-2-2023
			'comparestartdate': "From date should be smallar than To date",
			'compareenddate': "To date should be greater than From date",
			'comparestartenddate': "End date should be greater than Start date.",
			'remoteworktypeerror': "Please Select Remote Work Type",
			'comparestartdateerror': "Start date should be less than end date.",
			'invaliddaterange': "Invalid Date Range.",
			// harsh 16-3-2023
			'invalidfile': "Invalid File Type",
			'timeestimation': "Estimation time should be less than available task time",
			'zeroestimation': 'Please enter valid estimation',
			'dropotherstask': "Can't Drop Other's Task",
			'dropotherslead': "Can't Drop Other's Lead",
			'droptimeron': "Can't Drop Timer is On",
			'timernotstarted': "Timer not started yet",
			'subtaskshouldbecomplete': "Subtask should be completed",
			'copied': "Link Copied Successfully",
			'othercopied': "Copied Successfully",
			'weekoff': 'Selected Date is Week Off',
			'docuploaderr': "Something Went Wrong, Please Try Again",
			'docuploaded': "Document Uploaded",
			'mediastorage': 'The media storage capacity has been exceeded, leaving no available space.',
			'copiedtoclipboard': 'Copied to clipboard',
			'invalidvariable': 'Invalid Environment Variable',
			'remarkaddedsuccess': 'Remark Added Successfully',
			'descaddedsuccess': 'Description Added Successfully',
			'assetauditedsuccess': 'Asset Audited Successfully',
			'multipleassetauditedsuccess': 'Asset(s) Audited Successfully',
			'cantdeleterule': "Can't delete leave rule",
			'monthvalidation': 'To Month should be greater than From Month',
			'datealredyadded': 'This date is already added.',
			'timealreadyadded': 'This time is already added.', //  | Om Z  🌝🌝🌝 ~ 2024-11-30 ~ 12:35 PM
			'datealreadyadded': 'This Date already added.',
			'daterange': 'Enter date between 1 to 31.',
			'hourlimit': "Can't add hours more then",
			'emailaddress': 'Email address',
			'salarysliplimit': 'You can do upto 6 month(s) salary slip request',
			'addrequireddata': 'Add Required Data',
			'minuteslimit': "Minutes should be less than 60",
			'fillrequireddata': 'Fill all required data',
			'validcalculationexpression': 'Valid Calculation Expression is mandatory',	//  | Deep Dungarani  ~ 2025-09-12 ~ 11:37 AM
			'recollectmorethanamount': 'Recollect amount should not be greater than Advance',
			'amountnotgreaterthanbalance': "Expense amount can't be greater than Available Balance",
			'cannotremoveplatform': "can't remove this platform",
			'cannotremoveunassignednode': "Can't Remove Unassigned Node",
			'taskpresent': 'Some tasks are present',
			'cannotconnecttounassigned': "Can't Connect To Unassigned",
			'ticketspreset': 'Some tickets are present',
			'assigneeremovalnotallowed': "You can't remove assignee because assignee is selected in Reminder",
			'docuploadedsuccess': 'Document Uploaded Successfully',
			'selectedtime': 'Selected time is already',
			'selecteddurationoccupied': 'Selected duration is already Occupied',
			'scheduledtimeoccupied': 'Scheduled time is already Occupied',
			'seatallocated': 'Seat Allocated for',
			'reamrknotempty': 'Remark cannot be empty',
			'selectdatatodelete': 'Select data to delete.',
			'selectdatatomove': 'Select data to move.',
			'selectdatatotrash': 'Select project(s) to trash.', // aman - 31/7/2025 - project trash notification
			'selectdatatoarchive': 'Select project(s) to archive.', // aman - 31/7/2025 - project archive notification
			'selectdatatoedit': 'Select data to edit.',
			'selectdatatoapprove': 'Select data to approve.', // Renish Salakhana 06-01-2026 - it's when kra/kpi bulk approval
			'selectdatatoreject': 'Select data to reject.', // Renish Salakhana 07-01-2026 - it's when kra/kpi bulk approval
			'selectatleastonetemplate': 'Please Select At-least One Template',
			'invalidsourcenode': 'Invalid Source Node',
			'leadpresentinstage': 'Some Leads Are Present In This Stage',
			'datauseatcrmlead': 'The data you want to delete is currently in use at CRM Lead.',
			'titlecopied': 'Title Copied Successfully',
			'idcopied': 'ID Copied Successfully',
			'jsoninserted': 'JSON Inserted',
			'insertvalidjson': 'Insert Valid JSON',
			'reasoncopied': 'Reason Copied Successfully',
			'selectdatatotransfer': 'Select data to transfer.',
			'encashvaluelimit': 'Encash Value Can Not be Greater Than Available Balance',
			'wronglink': 'Wrong Link',
			'starttimmer': 'Started Timer Initially',
			'duplicatedata': 'Duplicate Data',
			'invalidcompanyyear': 'Invalid Company year',
			'timeperioduniquedata': 'Time Period Should be Same ',
			'advanceamountcomparison': "Advance Amount should be less than Salary",
			'invalidbodyres': 'Invalid Body Request',
			'pngjpgaccepted': 'Inavlid File, Only PNG and JPG file Accepted',
			'pngjpgjpegpdfaccepted': 'Inavlid File, Only PNG , JPG , JPEG and PDF file Accepted',
			'filesizelimit': 'File Size Should be Less Than 5 MB',
			'filesizelimit1mb': 'File Size Should be Less Than 1 MB',
			'pdfaccepted': 'Invalid File, Only PDF file Accepted',
			'validdate': 'This date range already exists in a salary record',
			'markcomparison': 'Marks Must Be Less Then Question Weightage',
			'invalidschedule': 'Invalid Schedule Of Stage',
			'fillstagedata': 'Fill All Stage Data',
			'fillrescheduledstagedata': 'Fill All Stage Data (rescheduled)',
			'fillcanclereason': 'Fill Interview Cancel Reason',
			'fillskipstagereason': 'Fill Skip Interview Stage Reason',
			'selectlatereason': "Please Select Your Late Reason", //  | to notify late log Reason Kailas Patil ~ 2025-11-29 ~ 09:19 AM09
			'fillinterviewconductperson': 'Fill Interview Conduct Person',
			'similardatanotallow': 'Similar Data Not Allowed',
			'invalidremidertime': 'Invalid Reminder Time',
			'completinterviewprocees': 'Complete Interview Procees Of Candidate',
			'entervalidtime': 'Please enter valid time',
			'timecomparison': 'End Time Is Must be Greater than Start Time',
			'fromdatecomparison': 'From date should be smaller than To date',
			'applyleavelimit': "Can't Apply Leave for More than 4 Hours",
			'leavehourcannotzero': "Leave hours can't be 0",
			'selectedtimecomparison': 'Selected Time Is Not Your Shift Time',
			'leavealreadyadded': 'leave is Already Added For This Date And Time',
			'startenddatecomparison': 'Ending date must be greater than starting date!',
			'leaveadjustdatanotsame': 'Leave Date and Adjust Date are Must not be Same',
			'weekoffbetweenleave': 'There is a weekoff Between Your leaves',
			'holidaybetweenleave': 'There is a holiday Between Your leaves',
			'leaveexist': 'Leave Already Exist',
			'addvalidreason': 'Add valid Reason',
			'selectatleastonedoc': 'Select At least One Document',
			'selectdoccopy': 'Select Document Copy',
			'fillatleastonedata': 'Fill Atleast One Data',
			'trainingalreadyexist': 'Training is already existing on same day',
			'mincomparison': 'Minutes To Must Be greater Than Minutes From',
			'rangalreadydeclared': 'This Range Is Already Declared',
			'minimumonepolicyrequired': 'Minimum 1 Policy Is Required',
			'fillassignseatno': 'Fill Assignee Or Seat No.',
			'writeclearpolicys': "Write 'CLEAR' to clear policys",
			'shiftstartmonthreqired': 'Shift Start Month is Required',
			'shiftendmonthreqired': 'Shift End Month is Required',
			'shiftdetailsreqired': 'Shift Details is Required',
			'attendancepolicystartmonthreqired': 'Attendance Policy Start Month is Required',
			'attendancepolicyendmonthreqired': 'Attendance Policy End Month is Required',
			'attendancepolicydetailsreqired': 'Attendance Policy Details is Required',
			'personnamerequired': 'Person Name is Required',
			'shiftmonthcomparison': 'Shift End Month Should be greater than Start Month',
			'workinghourreqired': 'Working Hour is Required',
			'policymonthcomparison': 'Policy End Month Should be greater than Start Month',
			'invalidstartenddateexp': 'Invalid Start or End date Experience',
			'invalidstartenddatecertificate': 'Invalid Start or End date Certification',
			'weightagecomparison': 'Total Weightage Must be Less Then 100',
			'duplicatedaterang': 'Duplicate date range found. Please enter a different date range',
			'hourmincannotzero': 'Hours or Minutes not should be 0',
			'fillrequiredfields': 'Fill Required Fields.',
			'selfconnectnotallow': 'Self Connect Not Allowded',
			'fillhourmin': 'Please Enter Hour(s) or Minute(s).',
			'numbercomparison': 'Start Number must be less than end Number',
			'dataexists': 'Data already exists',
			'quotationrequired': 'Quotation is required to move the lead to Closed Won',
			'followpasswordinstruction': 'Please follow Password Instructions',
			'passwordvalidation': 'Password and Confirm Password must be same',
			'dinnoalreadyadded': "Can't change because DIN No. is already added in table",
			'selectuserroleperson': 'Select User role Or Person',
			'enteremail': 'Enter Email Id',
			'leavingdatecomparison': 'Leaving Date must be Greater',
			'shiftalreadyadded': 'Shift is already added for this month',
			'policyalreadyadded': 'Policy is already added for this month',
			'assigntraining': 'Please assign atleast one training',
			'totalreferralvalidation': 'Total Referral Must be Less Then 100% ',
			'referralamountvalidation': 'Referral(₹) should be between Minimum and Maximum Amount',
			'monthrangeexists': 'Month range already exists',
			'contributionvalidation': 'Add Minimum one Contribution',
			'nodesconnected': 'Nodes are already connected',
			'cannotconnect': 'Can not Connect',
			'completeflow': 'Complete Flow',
			'emptyflownotallow': 'Empty Flow Not Allowded',
			'sourcesvalidation': 'Can Not have more than one sources',
			'circularflowerr': 'Can Not have Circular Flow',
			'selectformdocaccounts': 'Select Survey Form , Documents and Accounts',
			'selectformdocs': 'Select Survey Form and Documents',
			'selectformaccounts': 'Select Survey Form and Accounts',
			'selectdocsaccounts': 'Select Documents and Accounts',
			'selectsurveyform': 'Select Survey Form',
			'selectdocs': 'Select Documents',
			'selectaccounts': 'Select Accounts',
			'selectexperienceletter': 'Select Experience Letter',
			'selectterminationletter': 'Select Termination Letter',
			'selectrelievingletter': 'Select Relieving Letter',
			'notifytimerdurationvalidation': 'Notify Timer Off Duration can not be less than 5',
			'dataactivated': 'Already one Data is Activeted',
			'valuepercentagevalidation': 'value Percentage must not be greater than 100%',
			'incrementdatevalidation': 'Increment Date Must be Higher than Last increment Date',
			'applicabledatevalidation': 'Applicable Date Must be Higher than Increment Date',
			'invalidnoofques': 'Invalid No. Of Questions',
			'reqsentsuccess': 'Request Successfully Sent!!',
			'subcategoryvalidation': 'Please Select SubCategory For Series Of Asset',
			'targetvalidation': 'More Than 2 Target(s) Are Not Allowded',
			'actionnotallow': 'Action Not Allowded',
			'nodealreadyadded': 'Node Already Added',
			'notallow': 'Not Allowded',
			'multipleflownotallow': 'Multiple Flow Not Allowed.',
			'completeflowvalidation': 'Please Complete Flow',
			'twosourcesvalidataion': 'Can Not Have More Than Two Sources',
			'monthlyxaxlessthanpaid': 'Max In Month Should be Less than Max Paid in Month',
			'monthlylessthantotal': 'Max In Month/Quater Should be Less than Total Leaves In A Year',
			'monthlypaidlessthantotal': 'Max Paid In Month/Quater Should be Less than Max Total Leaves In A Year',
			'branchvalidation': 'Add Every Branch For Credit/debit',
			'deletelogreasonrequired': 'Add Reason For Delete log',
			'selectperson': 'Select Person',
			'selectdate': 'Select Date',
			'selectshift': 'Select Shift',
			'starttimedaterequired': 'Please Fill StartTime Date',
			'attendeesrequired': 'Minimum 1 Attendee Required',
			'meetingagendarequired': 'Meeting Agenda Is required',
			'attendeefieldnotempty': 'attendee Field Should not be empty',
			'ownerattendeedifferent': 'At least one additional attendee apart from the owner',		//  | Deep Dungarani  ~ 2025-05-26 ~ 01:24 PM
			'ownercannotonlyattendee': 'Owner Should Not be only Attendee',
			'resignationapplied': 'Resignation Applied',
			'reqaddedsuccess': 'Request Added Successfully',
			'rentalhousedetailsrequired': 'Fill Rented House Details',
			'rentalincomedetailsrequired': 'Fill Rental Income Details',
			'experiancerangvalidation': 'Experience Range Can not be empty',
			'incorrectexperiencerang': 'In Correct Experience Rang',
			'salaryrangvalidation': 'Salary Range Can not be empty',
			'incorrectsalaryrang': 'In Correct Salary Range',
			'taskassignvalidation': "Can't Assigne Task To Deactive Person",
			'subtasksvalidation': "Can't drop task with subtasks",
			'taskdropvalidation': "Can't Drop Once Timer is Started",
			'alreadyuploaded': 'already uploded',
			'futurelogvalidation': "Future Log can't be created",
			'starttimevalidation': "Start time can't be greater than end time",
			'startendtimecannotsame': "Start time and end time can't be same",
			'testtimevalidation': 'Enter Valid Test Time',
			'targetvalidatonforstage': 'Add Target For Mininum 1 stage',
			'datavalidation': 'Data already added for this range',
			'targetvalidatonforperson': 'Add Target For Minimum one person',
			'tovaluevalidation': 'To Value must be greater than From Value',
			'fromtovaluealreadyadded': 'From To value range already added',
			'slabvaluevalidation': 'Applicable Slab value must be less than 100',
			'projecttaskflowvalidation': 'Project Task Flow not Completed',
			'firstnodevalidation': "First node can't be Review required or Complete",
			'atleastonenodeswitchon': 'Atleast One node should have Complete switch on',
			'reviewcompletevalidation': "Review required and Complete can't be in One node",
			'duplicateseriesnumber': 'Duplicate Series Number',
			'maxassetsselectionvalidation': 'You can select a maximum number of assets equal to the return quantity',
			'returnquantityvalidation': 'Return quantity must be less than quantity',
			'passingpointvalidation': 'Passing points should be less than total point(s)',
			'addcomment': 'Add Comment',
			'checkboxrequirementforencashment': 'Select Atleast One CheckBox For Leave Encashment',
			'selectdepartmentdesignationperson': 'Please select Departments or Designations or Persons',
			'requireddatainclockintab': 'Fill all required data in Clock-In-Out Tab',
			'requireddatainleavestab': 'Fill all required data in Leave(s) Tab',
			'requireddatainlifeeventtab': 'Fill all required data in Life-Event(s) Tab',
			'requireddatainawardcertificatetab': '"Fill all required data in Award and Certificate(s) Tab',
			'requireddataintaskbasetab': 'Fill all required data in Task(s) Base Tab',
			'requireddatainpraiseknocktab': 'Fill all required data in Praise & Knock Tab',
			'requireddatainbadgetab': 'Fill all required data in Badge(s) Tab',
			'requireddatainmanagerreviewtab': 'Fill all required data in Manager Review Tab',
			'requireddatainmoodstab': 'Fill all required data in Mood(s) Tab',
			'commentcantblank': "Comment Can't be Blank",
			'fillatleastonetable': 'Fill atleast one table',
			'quantityvalidation': 'Quantity must be less than total asset',
			'maxassetsequaltuquantity': 'You can select a maximum number of assets equal to the quantity',
			'selectprefixserialnumber': 'Select Prefix Series Number',
			'projectprefixadded': 'Project Prefix must be added in Series',
			'branchprefixadded': 'Branch Prefix must be added in Series',			// Deep Dungarani
			'invalidemail': 'Invalid Email',
			'dndtaskpermission': "You Don't Have Enough Permission to Drag and Drop Task",
			'estimationvalidation': 'Please Enter Estimation',
			'emptymessagevalidation': "Can't send Empty Message",
			'backtrackingoff': 'Back Tracking is Off',
			'cannotdropticket': "You Can't drop Ticket",
			'resolvetimevalidation': "Resolve time must be greater than Accept time",
			'atleastonenodetimerswitchon': 'Atleast One node should have Timer Tracking switch on',
			'flownotcompleted': 'Flow is not Completed',
			'emailsentsuccess': 'Email Sent Successfully',
			'addminonequestion': 'Add Minimum 1 Question',
			'suggestionstatuscannotchange': "Suggestion's status can't be changed",
			'taskmoverights': "You don't have enough permission to move task",
			'dropfromreviewstagerights': "You don't have enough permission to drop from Review required stage",
			'startbeforetimenotadded': 'Start Before Time is not Added',
			'durationnotadded': "Duration is not Added",
			'dayvalidation': 'Day should be greater than 0',
			'selectdepartmentdesignation': 'Select Departments or Designations',
			'noofdaysvalidation': 'No of Day(s) should be greater than 0',
			'selectonedayofweek': 'Select atleast any one day of week',
			'startdatevalidation': 'Start date should be greater than end date',
			'writeclearuserrights': "Write 'CLEAR' to clear User Rights",
			'fillassignroomseatno': 'Fill Assignee Or Room Or Seat No.',
			'tagalreadyadded': 'Whoops! This tag has already been added',
			'changemoduleinputvalidation': 'Wrong Input, Type CHANGE for Change Module',
			'changetemplateinputvalidation': 'Wrong Input, Type CHANGE for Change Template',
			'typedelete': "Type 'DELETE' to Delete the Document",
			'urlcopied': 'URL Copied',
			'fillmobilenumberemail': 'Please enter Mobile Number or Email.',
			'percentagevaluevalidation': 'Percentage Value Should Be Less Than 100%',
			'tomonthvalidation': 'To Month Must be Greater Than Start Month',
			'toyearvalidation': 'To Year Must be Greater Than From Year',
			'salaryalreadyadded': 'Salary Is Already Added For This Month',
			'typedeletetoremoveuser': 'Type "DELETE" to Remove User',
			'enddatevalidationforprojectdate': 'End Date Should be less then project endDate',
			'typetrashtotrashproject': 'Type "TRASH" to Trash the Project',
			'typeactivetoactiveproject': 'type "ACTIVE" to ACTIVE the Project',
			'typearchivetoremoveproject': 'Type "ARCHIVE" to Remove Project from ARCHIVE',
			'typearchivetomoveproject': 'Type "ARCHIVE" to Move Project to ARCHIVE',
			'estimationcannotchange': "Estimation can't be changed once timer started",
			'timevalidation': 'Time is greater than parent task remaining estimation time',
			'startdatebetweenfromtodate': 'Start date sould be between Sprint fromdate to todate',
			'selectsprint': 'Select a Sprint',
			'selectatleastonetask': 'Select atleast one task',
			'selectatleastonefield': 'Select atleast one field',
			'selectatleastonedocumentfield': 'At least one document field must be selected',
			'selectatleastonepolicy': 'Please Select At Least One policy',
			'selectatleastoneemailtemplate': 'Please Select At Least One Email Template',
			'selectagreement': 'Please Select Agreement',
			'emailidapplicationidwrong': 'Email id or Application id Is Wrong',
			'timerstopsuccess': 'Timer Stopped Successfully',
			'timerpausedsuccess': 'Timer Paused Successfully',
			'timerstartsuccess': 'Timer Started Successfully',
			'estimationcannotzero': "Estimation can't be 0",
			'minfieldvalidation': "Can't add more than 59 minutes in the minute field",
			'filltitle': 'Fill Title field',
			'trainingcompleted': 'Training is completed already',
			'invalidbirthdate': 'Date Of Birth is invalid. Please enter a valid date in the format YYYY-MM-DD and Ensure it is within a valid range.',
			'invalidjoinigdate': 'Joining Date is invalid. Please enter a valid date in the format YYYY-MM-DD and Ensure it is within a valid range.',
			"stagecannotremove": "this stage cannot be removed",
			'departmentempty': 'No Department Specified',
			'designationempty': 'No Designation Specified',
			'branchempty': 'No Branch Specified',
			'districtempty': 'No District Specified',
			'cityempty': 'No City Specified',
			'stateempty': 'No State Specified',
			'notaskfoundinsprint': 'No task data available in this sprint for your search or filter.',
			'addetailserror': 'Facebook Manager Account and Adset id is required',
			'locationpermissionerror': 'Location permission is denied. Please enable it to proceed',
			'locationinformationerror': 'Location information is unavailable. Please try again',
			'locationtimeouterror': 'Location request timed out. Please try again',
			'locationothererror': 'An unknown error occurred while fetching location',
			'goodgoingtimer': `Good going! You're getting closer!`,
			'timerunningout': `Time’s running out! Let’s finish strong!`,
			'minimunsalaryerror': `Minnimun Salary is Must Be Less Then Maximun Salary`,
			'maximumsalaryerror': `Maximum Salary is Must Be Greater Then Minimun Salary`,
			'uploadoptionimage': `Please Upload Image For Question Options`,
			'nosalarydata': `No Salary Data Available`,
			'passingmarkserror': `Passing Marks Must be Less Then or Equal To Total Mark(s)`,
			'sectioncutofferror': `Section Cutoff Must be Less Then or Equal To Total Mark(s)`, //rohit-10/06/25
			'leaveapplicabledays': 'You can’t apply for leave on this day.',
			'leavegendererror': 'This leave type is not applicable for your gender',
			'passwordcriteriaerror': `Please Ensure The Password Meets All The Required Criteria`,
			'candidatedetailsexist': "Candidate Details Already Exist",  // JATIN 31/12/24
			'resumedatafecth': "Resume Details Fetch Successfully",  // JATIN 31/12/24
			'errorresumedatafecth': "There is Error In Resume Details Fetch", // JATIN 31/12/24,
			'otnotmatchleavetime': 'OT hours do not match the leave duration',
			'seriesnotavailable': "Company's series data is unavailable",
			'nopdfgenerated': "No Pdf Generated",
			'otalreadyselected': 'The required OT hours have already been selected for this leave',
			'morethanleaveduration': 'If you select all OT, it will exceed the leave duration',
			'compofflimit': `You’ve reached your maximum Compensatory Leave limit`,
			'futurecompoffvalidation': `You can't apply for a Compensatory Leave on the chosen date`,
			'alreadycompoffdateselected': 'This date is already used for a compensatory leave',
			'questionalreadyexist': `All Selected Question(s) Have Already Been Added From Another Question Set.`,
			'traveliternaryerrormsg': `Please Add at least one Travel Iternary `, // 11/1/2025 3:54 PM,
			'loginerror': `Please Enter Correct Email Address or Mobile Number or Employee Code.`,
			'fromtoleavecounterror': `Leave Count From Must be Less Then or Equal To Leave Count To.`,
			'targetrequired': `At least one target is required.`,
			'targetonrequired': `Please select at least one Category, Subcategory, or Item.`,
			'duplicateflowordererror': `Duplicate flow order number! Please use a different number.`,
			'flowordererror': `Flow Number can't be greater than total number of node.`,
			'zeroflowordererror': `Flow Number can't be zero(0).`,
			'emphistorydaterangeerror': 'Selected date range overlaps with history records.',
			'notinrewardleaderboard': "Keep going! You're not on the leaderboard yet.",
			'otapprovemincomparerror': `OT Approve Minute should be less then OT Minutes(s)`,
			'approveexpenseamounterror': `Approve Expense Amount should be less than Expense Amount`,         // Pravin ~ 16-05-2025 ~ 1:00 PM
			'approveexpenseamountzeroerror': `Expense Amount can't be 0.`,        // Pravin ~ 16-05-2025 ~ 1:00 PM
			'otapproveminzeroerror': `OT Approve Minute can't be 0.`,
			'titlemax150': "Title maximum Length is 150",
			'selectseries': "Please Select Series",
			'selectcompany': "Please Select Company",
			'empcodenotfound': "Employee Code is Not Found !",
			'userlogincancelnotauthorize': "User cancelled login or did not fully authorize.",
			'max10fileupload': "You can only upload upto 10 files at a time.",
			'cantremoveunassignednode': "Can't Remove Unassigned Node.",
			'selectedseatalreadyselected': "Selected seat is already occupied for the selected time.",
			'noimgtodwnld': "No images to download.",
			'dwnldcanceled': "Download cancelled.",
			'selectasset': "Select Asset for Add Assignee.",
			'selectassetforqr' : 'Select Asset For Generate QR(s).', //  Aniket Bhesaniya 🛠️  ~ 2025-08-06 ~ 014:39 PM
			'fillrequesteddata': 'Fill at least one: Department(s), Designation(s), or Assignee(s)',
			'selectemailtemplateCust': 'Select Email Template for Customer(s)',
			'selectemailtemplateEmp': 'Select Email Template for Employee(s)',
			'sendmailtocustoremp': 'Send mail to either the Customer or the Employee',
			'linkedinAdded': 'LinkedIn Data Added Successfully.',
			'percentlessthan100': 'Percentage should be less than 100.',
			'loanpauseerror': `Loan Is Already Pause For This Month`,
			'wrongdateerror': 'Wrong Date',
			'selectpersonerror': `Please Select Persons`,
			'invalidemailerror': 'Invalid email address.',
			'invalidnumbererror': 'Invalid number.',
			'invalidcontacterror': 'Invalid contact number.',
			'invalidstringerror': 'Invalid string.',
			'invalidenumberstringerror': 'Invalid number-string.',
			'cannotaddtimelogerror': `Can't Add Time Log (Timer Should be paused)`,
			'invalidtimeerror': 'Please enter a valid time',
			'invalidshifterror': 'There is selecte shift duration present in previous selected shifts',
			'Invalidcardnumbererror': 'Invalid card number.',
			'weekoffpresent': 'There is Already Week off Shift Duration Present',
			'shiftoverlaps': "Shift time overlaps with another shift. Please select a different shift.",
			'revertshiftoverlaps': "Shift time overlaps with another shift. Please revert a different shift.",
			'conflictsalarydetails': "Conflict Salary Detail(s)",
			'conflictbonusdetails': "Conflict Bonus Detail(s)",
			'bonusnameempty': "Please Select Bonus Name.",
			'employeecodeempty': "Please Enter Correct Employee Code.",
			'frommonthempty': "Please Enter From Month.",
			'tomonthempty': "Please Enter To Month.",
			'amountempty': "Please Enter Amount.",
			'openingbonusamountempty': 'Please Enter Opening Bonus Amount.',
			'salaryempty': "Please Enter Salary Amount.",
			'branchserienotavailable': "Branch Series Not Available.",
			'payrollbranchwrong': 'The Selected Payroll Branch is Incorrect. Please Select Correct Payroll Branch.',
			'payrollbranchempty': 'Please Select Payroll Branch.',
			'branchwiseseriesempty': 'Please Select Branch Series.',
			'wrongbranchwiseseries': 'The Selected Branch Series is Incorrect. Please Select Correct Branch Series.',
			'emergencycontactempty': 'Please Enter Emergency Contact Number.',
			'relationwithempty': 'Please Select Relation With Field.',
			'maritalstatuswrong': 'The Selected Marital Status is Incorrect. Please Select Correct Marital Status.',
			'spousenameempty': 'Please Enter Spouse Name.',
			'spousecontactempty': 'Please Enter Spouse Contact No',
			'customemployeecodeempty': 'Employee Code is already in use.',
			'subdepartmentwrong': 'Sub-department does not belong to the selected Department.',
			'subdesignationwrong': 'Sub-designation does not belong to the selected Designation.',
			'salaryaccountwrong': 'Salary Account does not belong to the selected Branch.',
			'messagevalidation': "You can't send a message because it's been more than 24 hour(s) since the last received message.",
			'sameemployeecodeerror': 'Employee Code is already exist.',
			'efpupperlimiterror': 'Please add valid EPF Upper Limit.',
			'payforerror': 'Please add valid Pay for.',
			'esicdateerror': 'Please add valid Esic Date.',
			'epfdateerror': 'Please add valid EPF Date.',
			'devicealreadyexisterror': 'Device alredy exist.', // smit
			'personnotexisterror': 'Person does not exist.', // smit
			'empcodenotexisterror': 'Employee Code does not exist.', // smit
			'devicealreadynotexisterror': 'Device not Found.', // smit
			'punchcodealreadyexisterror': 'Punch Code Already Exist.', // smit
			'incorrectpayrolltype': 'Incorrect Payroll Type.', // smit
			'incorrecttdstype': 'Incorrect TDS Type.', // smit
			'tdsnotfound': 'TDS Not Found.', // smit
			'companynotfound': 'Company Year Not Found.', // smit
			'incorrectcompanyyeartype': 'Incorrect Company Year Type.', // smit
			'leadassignmentpolicyerror': "Please Select Lead Assignment Policy.",
			'candidateassignmentpolicyerror': "Please Select Candidate Assignment Policy.",//kailas
			'filecopied': "File Copied Successfully.",
			'nourlfound': "Upload failed - No URL returned",
			'samefolderdroperr': "Can't Upload in same Folder",
			"bonusdatevalidate": "Bonus dates must be within the salary date range",
			"meetinglinknotavailable": "Meeting link is not available",
			'notauthorized': "You are not authorized to share this file",
			'deletefoldermsg': 'Do you also want to delete the files in this folder?',
			'entertagvalue': "Please Enter a tag value for create tag.",
			'noletterfound': "No letter found",
			'emptyfolder': 'Selected folder is empty',
			'cantcopymoveitself': 'Cannot move/copy a folder to itself or its subfolder',
			'correctlogindetails': 'Please Enter Correct Email or Password.',
			'bonuspercentage': 'Bonus percentage cannot be greater than 100.', //  smit surani  ~ 2025-05-21 ~ 018:19 PM
			'fileuploadsuccess': 'Files Uploaded Successfully',
			'downloadfailed': 'Download Failed',
			'downloadcompleted': 'Download Completed',
			'criteriadeleted': 'Criteria deleted successfully',
			'criteriadeletederror': 'Error deleting criteria',
			'invaliddragdrop': 'Invalid drag and drop operation',
			'invalidnodeidentifiers': 'Invalid node identifiers',
			'cantdragdropitselforchild': 'Cannot move a node to its own child node',
			'hierarchydatanotfound': 'Hierarchy data not found',
			'hierarchydeleted': 'Hierarchy Deleted Successfully',
			'parentnodenotfound': 'Parent Node Not Found',
			'targetnodenotfound': 'Target Node Not Found',
			'draggednodenotfound': 'Dragged Node Not Found',
			'criterianotfound': 'Criteria not found',
			'selectatleaseoneincriteria': 'Please select at least one criteria field (Company, Branch, Department or Designation)',
			'criteriaorderupdate': 'Criteria Order Updated Successfully',
			'criteriaorderupdateerror': 'Error Updating Criteria Order',
			'noitemselected': 'No Item Selected',
			'nodenotfound': 'Node not Found',
			'searchfailed': 'Search failed. Please try again',
			'addcriteria': 'Add Criteria to get started',
			'selectatleastonelicenses': 'Select atleast one data',
			'docsavesuccess': 'Document Saved Successfully',
			'nextdocprocesserror': 'Error Processing Next Document',
			'uploadfailderror': 'Upload Failed - No Data Returned',
			'docdatasaveerror': 'Error Saving Document Data',
			'declarationdatesvalidations': 'Declaration window must be within the company(s) year range.', //  smit surani  ~ 2025-06-19 ~ 013:02 PM
			'firsthalfsecondhalferror': "First Half and Second Half Months can't be same", // aman
			'signaturepadempty': 'Please Draw a Signature Before Saving',
			'completetimererror': 'Please complete the timer before moving to the next stage.',
			'nopermissiondownload': "You don't have enough permissions to download",
			'nofilestodownload': "No files to download",
			'nofilestodwnldcurrentfolder': 'No files to download in current folder',
			'failedtodownload': 'Failed to download files. Please try again.',
			'failedtodownloadfolder': 'Failed to download folder.',
			'failedtodownloaddocument': 'Failed to Download Document',
			'failedtodownloaddocuments': 'Failed to Download Document(s)',
			'documentdownloadsuccessfully': 'Document Download Successfully',
			'documentsdownloadsuccessfully': 'Document(s) Download Successfully',
			'nofilesaddedtozip': 'No files could be added to ZIP. Please check file permissions and try again.',
			'nofilesorpermission': "No downloadable files selected or you don't have permission.",
			'plsselectfilestodwnld': "Please select files to download.",
			'deletefailed': "Failed to delete items.",
			'passwordrequired': "Password is required",
			'nosalaryslipselected': "No Salary Slip Data Selected",
			'salaryrecalculated': "Salary Recalculated Successfully",
			'meetinglinkcopied': "Meeting link copied",
			'wfhpolicystartmonthreqired': 'Remote Work Policy Start Month is Required',
			'wfhpolicyendmonthreqired': 'Remote Work Policy End Month is Required',
			'wfhpolicydetailsreqired': 'Remote Work Policy Details is Required',

			// Cheating Detection | Deep Dungarani  ~ 2025-07-24
			'tabswitchdetected': "Violation Detected: Tab switching is not allowed.",
			'tabminimized': "Violation Detected: Minimizing the window is prohibited.",
			'rightclickdetected': "Violation Detected: Right-clicking is disabled during the test.",
			'devtoolopen': "Violation Detected: Developer tools access is restricted.",
			'copydetected': "Violation Detected: Copying content is not permitted.",
			'pastedetected': "Violation Detected: Pasting content is not permitted.",
			'exceedingviolationlimit': "Violation Limit Exceeded: You have surpassed the maximum number of allowed violations.",
			'viewonlymode': "At least one node has viewonly.", // smit
			// Handover | Deep Dungarani  ~ 2025-09-05 ~ 03:08 PM
			'handoverpendingfromassignee': 'You Have a Pending Handover. Assignee Must Accept/Reject Before You Can Create Another.',
			'handoverpendingfromhod': 'You Have a Pending Handover Approval. HOD Must Accept/Reject Before You Can Create Another.',

			// Approvals | Deep Dungarani  ~ 2025-11-06
			'noselectionforapproval': 'Select At Least One Item Before Approving.',
			'noselectionforrejection': 'Select At Least One Item Before Rejecting.',
			'selectatleastonerecord': 'Please Select At Least One Item Before Performing This Action.',

			// kra-kpi err message | Nirzar Gabani 💀 ~  2025-09-22 ~ 05:48 PM
			'tovaluegreaterthanmsg': 'To value must be greater than From value for Increase type.',
			'tovaluelessthanmsg': 'To value must be less than to From value for Decrease type.',
			'fromvaluelessthanmsg': 'From value must be less than to To value for Increase type.',
			'fromvaluegreaterthanmsg': 'From value must be greater than to To value Decrease type.',
			'customtaginuse':`This tag in use , Can't remove`,  //Renish Salakhana 13-12-2025 
			'policypreference':'Please choose any one policy preference', // use for choose any one policy preference for travel policy | Renish Salkhana 17-12-2025
			'travelpolicyapplicablemonthreqired': 'Travel Policy Applicable Month is Required', // Use in bulk travel policy tab for filter validation messsage | Renish Salakhana 18-12-2025
			'travelpolicyendmonthreqired': 'Travel Policy End Month is Required', // Use in bulk travel policy tab for filter validation messsage | Renish Salakhana 18-12-2025
			'travelpolicydetailsreqired': 'Travel Policy Details is Required', // Use in bulk travel policy tab for filter validation messsage | Renish Salakhana 18-12-2025

			// Timer Configuration error message | Renish Salakhana 08-12-2025
			'timerconfselectdeptdesignation' : 'Please select at least one : Department or Designation',

			// performance Review | Deep Dungarani  ~ 2025-12-24 ~ 05:10 PM
			'performancereviewerrequired' : 'Please select at least one reviewer (Manager or Employee).',
			'adjustscorereviewerrequired' : 'Please select at least one score adjuster (Manager or Employee).',
			'reviewerandadjusterrequired' : 'Please select at least one Manager or Employee for Reviewers and Score Adjustment.',
			'selectatleastonereviewer' : 'Please Select At Least One Reviewer',
			'selectatleastonedata' : 'Please Select At Least One Data',
			'selectatleastonepublish' : 'Please Select At Least One Publish Data.',
			'selectatreviewform' : 'Please Add Review Form or Select Response Type to all Reviewer Person',
			'selectreviewreleaseperson': 'Please select at least one Person for Release the Review',
			'addbandconfiguration' : 'Please Complete Band Configuration',
			'addsalaryrevisionconfiguration' : 'Please Complete Salary Revision Configuration',
			'addfrequencymonths' : 'Please Select Frequency Month',
			'pleaseaddatleastonebandconfiguration' : 'Please Add At Least One Band Configuration',
			'totalpercentageofallbandsmustbe': 'The Total Percentage Of All Bands Must Be 100%',
			'bandrangeoverlap': 'This rating range overlaps with another band. Please enter a different range.',
			'failedtodownloadcsv' : 'Failed to download CSV',
			'KRAKPIDefaultReviewerRemoval':'To delete this reviewer, please select another reviewer as default.',// use in kra kpi default reviewer removal  | Kailas Patil ~ 2026-01-03 ~ 14:00 AM4PM
		}

		// screening questions label | Nirzar Gabani 💀 ~  2024-12-17 ~ 01:02 PM
		this.screeningQue = {
			"reasonforjobchange": "Reason For Job Change",
			"noticeperiod": "Notice Period In Day(s)",
			"currentlastcompanyname": "Current/Last Company Name",
			"currentprevioussalary": "Current/Previous Salary (Annual)",
			"experience": "Experience",
			"currentlastexperience": "Current/Last Company Experience",
			"salaryexpectation": "Salary Expectation (Annual)"
		}

		// Integration Page | Deep Dungarani
		this.integrationplatformtype = {
			'microsoft365': 'microsoft365',
			'google': 'google',
			'whatsapp': 'whatsapp',
			'meta': 'meta',
			'googlemeet': 'googlemeet',
			'microsoftteam': 'microsoftteam',
			'zoom': 'zoom',
			'googlecalendar': 'googlecalendar',
			'microsoftcalendar': 'microsoftcalendar',
			'emailsmtp': 'emailsmtp',
			'calendarmeet': 'calendarmeet', // Rohit -14/6/25 */
		}

		// badge labels | Shubham ~  2025-04-18
		this.badgelabels = {
			'embeddedform': 'Embedded Form',
			'manualentry': 'Manual Entry',
			'allow': 'Allow',
			'notallow': 'Not Allow',     //  | Pravin ~  18-04-2025 ~ 06:45 PM
		}

		// keys which is need to approval when change the data from myprofile | Nirzar Gabani 💀 ~  2025-04-18 ~ 01:26 PM
		this.myprofileapprovalkeys = {
			'personname': "Display Name",
			'personemail': "Person Email",
			'contact': "Contact No.",
			'dateofbirth': "Date Of Birth",
			'middlename': "Middle Name",
			'currentaddress': "Current Address",
			'country': "Country",
			'state': "State",
			'district': "District",
			'city': "City",
			'area': "Area",
			'pincode': "PinCode",
			'permanentaddresss': "Permanent Addresss",
			'permanentaddresscountry': "Permanent Address Country",
			'permanentaddressstate': "Permanent Address State",
			'permanentaddressdistrict': "Permanent Address District",
			'permanentaddresscity': "Permanent Address City",
			'permanentaddressarea': "Permanent Address Area",
			'permanentaddresspincode': "Permanent Address PinCode",
			'adharnumber': "Aadhaar Number",
			'adharfrontimage': "Aadhaar Front Image",
			'adharbackimage': "Aadhaar Back Image",
			'pannumber': "Pan Number",
			'panimage': "Pan Image",
			'degreecertificate': "Degree Certificate",
			'contractfile': "Contract File",
			'ifsccode': "IFSC code",
			'bankname': "Bank Name",
			'bankbranch': "Bank Branch",
			'accounttype': "Account Type",
			'accountholdername': "Account Holder Name",
			'accontnumber': "Account Number",
			'firstname': "First Name",
			'homephonenumber': "Home Phone Number",
			'profilepic': "Profile Pic"
		}

		// Greeting Messages used In Dashboard
		this.greetingmessages = [
			'Welcome, ', 'Howdy, ', 'Hello, ', 'Hey there! ', 'Greetings and welcome! '
		]

		//  | Om Z  🌝🌝🌝 ~ 2024-11-07 ~ 04:05 PM
		this.tooltip = {
			'filter': 'Filter',
			'add': 'Add',
			'update': 'Update',
			'edit': 'Edit',
			'delete': 'Delete',
			'remove': 'Remove',
			'close': 'Close',
			'info': 'Info.',
			'placement': 'top',
			'logout': 'Log Out',
			'backtoconfiguration': 'Back To Configuration'
		}

		// Combine Calendar color codes | Om Z  🌝🌝🌝 ~ 2024-12-26 ~ 01:11 PM
		this.combinecalendarcolorslighttheme = {
			'weekoffbg': "#c3c2f926",
			'holidaybg': "#fdebcd",
			'meetingbg': "#ddf2e3",
			'eventbg': "#9b99ae26",
			'trainingbg': "#e0efef",
			'placementdrivebg': "#fff8d7",
			'todobg': "#e4e4f8",
			'interviewschedulebg': "#f1fafc",
			'interviewreschedulebg': "#ffdaec",
			'followupbg': "#fbe5d9",
			'agreementbg': "#dceae1",
			'cancelledbg': "#fde4e4",
			'bookingbg': "#e4e4f8",
			'weekoffborder': "#5956E3",
			'holidayborder': "#ffa101",
			'meetingborder': "#1DAB45",
			'eventborder': "#4e4c72",
			'trainingborder': "#2f9191",
			'placementdriveborder': "#ffa600",
			'todoborder': "#4A49D1",
			'interviewscheduleborder': "#0092C2",
			'interviewrescheduleborder': "#ff0a7d",
			'followupborder': "#e65100",
			'agreementborder': "#17903C",
			'cancelledborder': "#D30808",
			'bookingborder': "#9999aa",		// Deep Dungarani  ~ 2025-02-24 ~ 07:09 PM
		}

		this.combinecalendarcolorsdarktheme = {
			'weekoffbg': "#c3c2f926",
			'holidaybg': "#4c3a1c",
			'meetingbg': "#2b4e35",
			'eventbg': "#9b99ae40",
			'trainingbg': "#274545",
			'placementdrivebg': "#575131",
			'todobg': "#28283c",
			'interviewschedulebg': "#273e43",
			'interviewreschedulebg': "#543142",
			'followupbg': "#50382b",
			'agreementbg': "#213c2a",
			'cancelledbg': "#422626",
			'bookingbg': "#28283c",
			'weekoffborder': "#8A8EF0",
			'holidayborder': "#ffa101",
			'meetingborder': "#1DAB45",
			'eventborder': "#b3b2c2",
			'trainingborder': "#2f9191",
			'placementdriveborder': "#ffa600",
			'todoborder': "#4A49D1",
			'interviewscheduleborder': "#0092C2",
			'interviewrescheduleborder': "#ff0a7d",
			'followupborder': "#e65100",
			'agreementborder': "#17903C",
			'cancelledborder': "#D30808",
			'bookingborder': "#9999aa",			// Deep Dungarani  ~ 2025-02-24 ~ 07:09 PM
		}


		// Regex for Validations
		this.regex = {
			'phone': /^(\+\d{1,3}[-\s]?)?(?:\(\d{1,4}\)[- \s]?)?(?:\d{1,4}[-\s]?)?(?:\d{1,4}[-\s]?)?(?:\d{1,4}[-\s]?)?(?:\d{1,4}[-\s]?)?$|^.{7,15}$/,
			// 'email': '[a-z0-9]+@[a-z]+\.[a-z]{2,3}',
			// 'email': /^\w+([-.]\w+)*@\w+([-.]\w+)*\.\w{2,4}$/,
			'email': /^(?!.*[A-Z])\w+([-.]\w+)*@\w+([-.]\w+)*\.\w{2,}$/, //  smit surani  ~ 2025-06-19 ~ 10:17 AM
			'password': /^(?=[a-zA-Z0-9!@#$%^&*_]{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W).*$/,
			'gstno': '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$',
			'pincode': '^[1-9][0-9]{5}$',
			'aadharno': '^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$',
			'panno': '^[A-Z]{5}[0-9]{4}[A-Z]{1}$',
			'ifsccode': '^[A-Z]{4}0[A-Z0-9]{6}$',
			'tinno': '^[A-Z]{5}[0-9]{4}[A-Z]{1}$', //temp
			// 'tinno' : '^(9\d{2})([ \-]?)([7]\d|8[0-8])([ \-]?)(\d{4})$', //ori
			'name': '^[a-zA-Z\\s]*$',
			'contactno': /^(?:[0-9] ?){6,14}[0-9]$/,
			'accountno': '^([0-9]{11})|([0-9]{2}-[0-9]{3}-[0-9]{6})$',
			'exportbondno': '^(\d{2})-?([a-zA-Z]{3})-?(\d{6})-?(\d{2})-?(\d{1,4})$/',
			'numberwithdecimal': '[0-9+_.-]$',
			// 'subdomain': /^([a-z0-9]){1,25}$/,
			'subdomain': /^([a-zA-Z0-9]){1,25}$/,
			'positivenumeric': /^\d+$/, // for only number input not alloewd . -
			'standarddateformat': /^(\d{4}-\d{2}-\d{2}|\d{4}\/\d{2}\/\d{2})$/, // only for YYYY-MM-DD or YYYY/MM/DD fromat used in import CSV (not include timezone)
			'nospace': /^\S+$/,
			'color': /^rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*([\d\.]+)?\)$/i,
			
			// Document-specific regexes | Deep Dungarani
			'passport': /^[A-Z]{1,2}[0-9]{7}$/, // A1234567 or AA1234567
			'voterid': /^[A-Z]{3}[0-9]{7}$/, // ABC1234567
			'drivinglicense': /^[A-Z]{2}\d{2}[- ]?\d{11}$/, // MH12-12345678901
			'birthcertificate': /^[A-Za-z0-9]{8,12}$/, // General 8–12 alphanumeric
			'degree': /^[A-Za-z0-9]{8,12}$/, // Generic
			'healthcard': /^[A-Za-z0-9]{10,14}$/, // Generic
			'marksheet': /^[A-Za-z0-9]{6,12}$/, // Generic
			'urlRegex': /https?:\/\/(?:[-\w.])+(?:\.[a-zA-Z]{2,})+(?:\/[^\s]*)?(?:\?[^\s]*)?(?:#[^\s]*)*/g , // Utsav ~ For extracting url from text


			//support ticket notes regex - aman - 1/8
			'imageOnlyParagraphRegex' : /^<p>\s*<img\s[^>]*>\s*<\/p>$/i,
			'videoOnlyParagraphRegex' : /^<p>\s*<video\b[^>]*>.*<\/video>\s*<\/p>$/i,
			'iframeOnlyRegex' : /<iframe\b[^>]*><\/iframe>/i,
		}

		// HTML Controlles 
		this.htmlcontorls = {

			'switch': 'switch',
			'text': 'text',
			'icon': 'icon',
			'input-text': 'input-text',
			'password': 'password',
			'input-textarea': 'input-textarea',
			'custom-textarea': 'custom-textarea',
			'input-textarea-array': 'input-textarea-array',
			'checkbox': 'checkbox',
			'dropdown': 'dropdown',
			'radio': 'radio',
			'multipleselectdropdown': 'multipleselectdropdown',
			'lookup': 'lookup',
			'combobox': 'combobox',
			'number-input': 'number-input',
			'float-number-input': 'float-number-input',
			'input': 'input',
			'datepicker': 'datepicker',
			'datetimepicker': 'datetimepicker',
			'daterangepicker': 'daterangepicker',
			'monthrangepicker': 'monthrangepicker',
			'timerangepicker': 'timerangepicker',
			'timepicker': 'timepicker',
			'monthpicker': 'monthpicker',
			'rangepicker': 'rangepicker',
			'colorpicker': 'colorpicker',
			'image': 'image',
			'email': 'email',
			'phone': 'phone',
			'html-editor': 'html-editor',
			'text-array': 'text-array',
			'modal-eye': 'modal-eye',
			'modal-text': 'modal-text',
			'file': 'file',
			'uploadfile': 'uploadfile',
			'table': 'table',
			'table-add-button': 'table-add-button',
			'colorpickerpreview': 'colorpickerpreview',
			'drag-container': 'drag-container',
			'combinefield': 'combinefield',
			'number-input-message': 'number-input-message',
			'tag-input': 'tag-input',
			'tag-picker': 'tag-picker',
			'multiplefilepicker': 'multiplefilepicker',
			'checkpicker': 'checkpicker',
			'virtualizedcheckpicker': 'virtualizedcheckpicker',
			'personimg': "personimg",
			'icons': 'icons',
			'map': 'map',
			'latitude': 'latitude',
			'longitude': 'longitude',
			'star-rating': 'star-rating',
			'suneditor': 'suneditor-html',
			'intltelinput': 'intltelinput',
			'contact-number': 'contact-number', // for contact number input 
			'single-tag-picker': 'single-tag-picker',
			'section': 'section',
			'camera': 'camera',
			'signature': 'signature',
			'field-selector': 'field-selector',
			'drag-drop-container': 'drag-drop-container',
			'warning-message': 'warning-message',		// Use For Show Warning Message in RightSidebar | Deep Dungarani  ~ 2025-06-02 ~ 09:31 AM
			'drag-container-table': 'drag-container-table',  	// Drag and Drop Container for table | Deep Dungarani  ~ 2025-06-02 ~ 09:31 AM
			'rowinput': 'rowinput', // row input with text | Nirzar Gabani 💀 ~  2025-06-03 ~ 04:48 PM
			'rating': 'rating', // rating type to show rating in star | Nirzar Gabani 💀 ~  2025-06-04 ~ 10:37 AM
			'number-input-with-unit': 'number-input-with-unit', // number input with unit | Deep Dungarani  ~ 2025-08-25 ~ 09:31 AM
			'link-button': 'link-button', // link button | Deep Dungarani  ~ 2025-08-25 ~ 09:31 AM
			'label': 'label', // label | Deep Dungarani  ~ 2025-08-27 ~ 04:18 PM
			'candidate-add-button': 'candidate-add-button',	//  | Deep Dungarani  ~ 2025-09-29
			'modal-file': 'modal-file'	//  | Deep Dungarani  ~ 2025-09-29
		}

		// Email Types 
		this.emailtypes = {
			'1': 'Schedule Interview',
			'2': 'Reschedule Interview',
			'3': 'Cancelled Interview',
			'4': 'Schedule Interview Candidate',
			'5': 'Reschedule Interview Candidate',
			'6': 'Cancle Interview Candidate',
			'7': 'Appointment Letter',
			'8': 'Offer Letter',
			'9': 'Agreement',
			'10': 'Policy',
			'11': 'Schedule Time Blocks',
			'12': 'Employee Generate',
			'13': 'Trainer Assigned To Trainee',
			'14': 'Rejected By Candidate',
			'15': 'Rejected By Company',
			'16': 'Online Test',
			'17': 'Introduction',
			'18': 'Letter Acknowledgement',
			'19': 'Document(s) Upload',
			'20': 'Rejected Document(s)'
		}

		// Modal Size Classes 
		this.modalsizeclasses = {
			'xs': 'xs',
			'sm': 'sm',
			'md': 'md',
			'lg': 'lg',
			'xl': 'xl',
			'full': 'full'
		}

		this.gridclasses = {

			'w-100': 'w-100',

			'col': 'col',
			'col-auto': 'col-auto',
			'col-1': 'col-1',
			'col-2': 'col-2',
			'col-3': 'col-3',
			'col-4': 'col-4',
			'col-5': 'col-5',
			'col-6': 'col-6',
			'col-7': 'col-7',
			'col-8': 'col-8',
			'col-9': 'col-9',
			'col-10': 'col-10',
			'col-11': 'col-11',
			'col-12': 'col-12',

			'col-xs': 'col-xs',
			'col-xs-auto': 'col-xs-auto',
			'col-xs-1': 'col-xs-1',
			'col-xs-2': 'col-xs-2',
			'col-xs-3': 'col-xs-3',
			'col-xs-4': 'col-xs-4',
			'col-xs-5': 'col-xs-5',
			'col-xs-6': 'col-xs-6',
			'col-xs-7': 'col-xs-7',
			'col-xs-8': 'col-xs-8',
			'col-xs-9': 'col-xs-9',
			'col-xs-10': 'col-xs-10',
			'col-xs-11': 'col-xs-11',
			'col-xs-12': 'col-xs-12',

			'col-sm': 'col-sm',
			'col-sm-auto': 'col-sm-auto',
			'col-sm-1': 'col-sm-1',
			'col-sm-2': 'col-sm-2',
			'col-sm-3': 'col-sm-3',
			'col-sm-4': 'col-sm-4',
			'col-sm-5': 'col-sm-5',
			'col-sm-6': 'col-sm-6',
			'col-sm-7': 'col-sm-7',
			'col-sm-8': 'col-sm-8',
			'col-sm-9': 'col-sm-9',
			'col-sm-10': 'col-sm-10',
			'col-sm-11': 'col-sm-11',
			'col-sm-12': 'col-sm-12',

			'col-md': 'col-md',
			'col-md-auto': 'col-md-auto',
			'col-md-1': 'col-md-1',
			'col-md-2': 'col-md-2',
			'col-md-3': 'col-md-3',
			'col-md-4': 'col-md-4',
			'col-md-5': 'col-md-5',
			'col-md-6': 'col-md-6',
			'col-md-7': 'col-md-7',
			'col-md-8': 'col-md-8',
			'col-md-9': 'col-md-9',
			'col-md-10': 'col-md-10',
			'col-md-11': 'col-md-11',
			'col-md-12': 'col-md-12',

			'col-lg': 'col-lg',
			'col-lg-auto': 'col-lg-auto',
			'col-lg-1': 'col-lg-1',
			'col-lg-2': 'col-lg-2',
			'col-lg-3': 'col-lg-3',
			'col-lg-4': 'col-lg-4',
			'col-lg-5': 'col-lg-5',
			'col-lg-6': 'col-lg-6',
			'col-lg-7': 'col-lg-7',
			'col-lg-8': 'col-lg-8',
			'col-lg-9': 'col-lg-9',
			'col-lg-10': 'col-lg-10',
			'col-lg-11': 'col-lg-11',
			'col-lg-12': 'col-lg-12',

			'col-xl': 'col-xl',
			'col-xl-auto': 'col-xl-auto',
			'col-xl-1': 'col-xl-1',
			'col-xl-2': 'col-xl-2',
			'col-xl-3': 'col-xl-3',
			'col-xl-4': 'col-xl-4',
			'col-xl-5': 'col-xl-5',
			'col-xl-6': 'col-xl-6',
			'col-xl-7': 'col-xl-7',
			'col-xl-8': 'col-xl-8',
			'col-xl-9': 'col-xl-9',
			'col-xl-10': 'col-xl-10',
			'col-xl-11': 'col-xl-11',
			'col-xl-12': 'col-xl-12',

			'col-exl': 'col-exl',
			'col-exl-auto': 'col-exl-auto',
			'col-exl-1': 'col-exl-1',
			'col-exl-2': 'col-exl-2',
			'col-exl-3': 'col-exl-3',
			'col-exl-4': 'col-exl-4',
			'col-exl-5': 'col-exl-5',
			'col-exl-6': 'col-exl-6',
			'col-exl-7': 'col-exl-7',
			'col-exl-8': 'col-exl-8',
			'col-exl-9': 'col-exl-9',
			'col-exl-10': 'col-exl-10',
			'col-exl-11': 'col-exl-11',
			'col-exl-12': 'col-exl-12',

			'p-0': 'p-0'
		}


		this.aliasname = {
			'projecttaskstatusalias': 'projecttaskstatusmaster',
			'projectcategoryalias': 'projectcategory',
			'defaultprojectusersalias': 'defaultprojectusers',
			'defaultmodulemasteralias': 'defaultmodulemaster',
			'meetingmasteralias': 'meetingmaster',
			'otherprojectalias': 'otherproject',
			'projectsalias': 'projects',
			'modulealias': 'module',
			'testcasemasteralias': 'testcasemaster',
			'testcasegroupmasteralias': 'testcasegroupmaster',
			'clientmasteralias': 'clientmaster',
			'renewalsalias': 'renewals',
			'filemasteralias': 'filemaster',
			'notificationsettingalias': 'notificationsetting', // Notification Setting Master | Om Z  🌝🌝🌝 ~ 2024-11-14 ~ 02:18 PM
			'overtimechartalias': 'overtimechart', // Overtime Approve Vs Reject | Om Z  🌝🌝🌝 ~ 2024-11-25 ~ 03:54 PM
			'projectstatusmasteralias': 'projectstatusmaster',
			'projecttaskflowalias': 'projecttaskflow',
			'platformmasteralias': 'platformmaster',
			'functionalitymasteralias': 'functionalitymaster',
			'tagalias': 'tag',
			'employeemasteralias': 'employeemaster',
			'exitapplicationalias': 'exitapplication',
			'approvalsalias': 'approvals' ,
			'travelapprovalsalias': 'travelapprovals', // Travel Desk alias | Om Z  🌝🌝🌝 ~ 2025-01-08 ~ 03:50 PM
			'warningalias': 'warning',
			'warningreasonalias': 'warningreason',
			'declaration':'declaration',
			// JATIN 3/1/25 Comment 
			// 'travelmasteralias': 'travelmaster',
			'travelalias': 'travel',
			'annualcalendaralias': 'annualcalendar',
			'customeralias': 'customer',
			'salespartneralias': 'salespartner', // | Pravin Sharma  ~ 2025-04-11 ~ 10:51 AM 
			'paygradealias': 'paygrade',  // Smit Surani | 2025-14-04 ~ 4:00 PM
			'bankalias': 'bank',  // Smit Surani | 2025-13-08 ~ 4:00 PM
			'costcenteralias': 'costcenter', // Smit Surani | 2025-14-04 ~ 4:50 PM
			'employeeganttchartalias': 'employeeganttchart',//  smit surani  ~ 2025-04-23 ~ 013:12 PM
			'clientdashboardalias': 'clientdashboard',
			'notabugreasonalias': 'notabugreason',
			'personrunningtimeralias': 'personrunningtimer',
			'reviewtimelogrequestalias': 'reviewtimelogrequest',
			'remoteworkalias': 'remoteworkpolicy',
			'stickerprintsettingsalias' : 'stickerprintsettings', //  Aniket Bhesaniya 🛠️  ~ 2025-07-31 ~ 09:13 AM

			'sprintalias': 'sprint',
			'projectreleasealias': 'projectrelease',
			'userrolemasteralias': 'userrolemaster',
			'employeeprofilealias': 'employee360',
			'overviewtabalias': 'overview',
			'branchmasteralias': 'branchmaster',
			'locationmasteralias': 'location', // smit
			'companymasteralias': 'companymaster',
			'customercompanymasteralias': 'customercompany', //Rohit-05/05/25
			'pmrstargetalias': 'pmrstarget',
			'iconextensionmasteralias': 'iconextensionmaster',
			'departmentmasteralias': 'departmentmaster',
			'designationmasteralias': 'designationmaster',
			'allowedipmasteralias': 'allowedipmaster',
			'taskreasonalias': 'taskreason',
			'latereasonalias': 'latereason',
			'resignreason': 'resignreason',
			'subdepartment': 'subdepartment', // Sub Department | rohit ~ 2024-11-14 ~
			'subdesignation': 'subdesignation', // Sub Designation | rohit ~ 2024-11-14 ~
			'greetingmessagealias': 'greetingmessage',
			'manualtimelogreasonalias': 'manualtimelogreason',
			'appreleasealias': 'apprelease',
			'mypackagealias': 'mypackage',
			'surveyalias': 'survey',
			'formbuilderalias': 'formbuilder',
			'submitsurveyalias': 'submitsurvey',
			'packagemasteralias': 'packagemaster',
			'policymasteralias': 'policymaster',
			'agreementmasteralias': 'agreementmaster',
			'appointmentlettermasteralias': 'appointmentlettermaster',
			'exitletteralias': 'exitletter',
			'offerlettermasteralias': 'offerlettermaster',
			'userrightsalias': 'userrights',
			'productivityalias': 'productivity',
			'citymasteralias': 'citymaster',
			'countrymasteralias': 'countrymaster',
			'statemasteralias': 'statemaster',
			'districtmasteralias': 'districtmaster',
			'sourcemasteralias': 'sourcemaster',
			'criteriaalias' : 'criteria', // added by renish 26-08-2025 for metric in people module
			'timeframealias' : 'timeframe', // added by renish 26-08-2025 for time frame in people module

			'userrolehierarchyalias': 'userrolehierarchy',
			'seriesalias': 'series',
			'relationmasteralias': 'relationmaster',
			//manual 
			'manualalias': 'manual',
			'manualtreealias': 'home', //for front use only
			'manuallistalias': 'list',//for front use only
			'manualshelfsalias': 'shelf',
			'manualbooksalias': 'books',

			'emailsmtpmasteralias': 'emailsmtpmaster',
			'emailtemplatemasteralias': 'emailtemplatemaster',
			'qualificationmasteralias': 'qualificationmaster',
			'analyticsemailmasteralias': 'analyticsemailmaster',
			'dashboarduserrightsalias': 'dashboarduserrights',
			'thirdpartyagencymasteralias': 'thirdpartyagencymaster',
			'employmentmasteralias': 'employmentmaster',
			'interviewstagealias': 'interviewstage',
			'interviewprocessalias': 'interviewprocess',
			'joiningprocedurealias': 'joiningprocedure',

			'documentmasteralias': 'documents', // document linkage changes - shubham - do not stage
			'assigneddocumentmasteralias': 'assigneddocumentmaster',
			'joiningstagemasteralias': 'joiningstagemaster',
			'technicalskillmasteralias': 'technicalskillmaster',
			'candidatelistalias': 'candidatelist',
			'employeereferralalias': 'employeereferral',
			'openingmasteralias': 'openingmaster',
			'recruitmentdashboardalias': 'recruitmentdashboard',
			'questionanswermasteralias': 'questionanswermaster',
			'questionsetalias': 'questionset',
			'candidaterejectreasonalias': 'candidaterejectreason',
			'openingstatusmasteralias': 'openingstatusmaster',
			'candidatestatusmasteralias': 'candidatestatusmaster',
			'candidatesourcemasteralias': 'candidate/secondarysource',
			'candidateprimarysourcemasteralias': 'candidate/primarysource',
			'placementdrivemasteralias': 'placementdrivemaster',
			'employeereferralprogrammasteralias': 'employeereferralprogrammaster',
			'candidatesourcealias': 'candidatesource',
			'agreementletter': 'agreementletter', // agreementletter | rohit ~ 17-4-2024 ~
			'appointmentletter': 'appointmentletter', // appointmentletter | rohit ~ 17-4-2024 ~
			'offerletter': 'offerletter', // offerletter | rohit ~ 17-4-2024 ~
			'otherletter': 'otherletter', // otherletter | rohit ~ 17-4-2024 ~
			'experienceletter': 'experienceletter', // experienceletter | rohit ~ 17-4-2024 ~
			'terminationletter': 'terminationletter', // terminationletter | rohit ~ 17-4-2024 ~
			'relievingletter': 'relievingletter', // relievingletter | rohit ~ 17-4-2024 ~
			'recruitmentlettersalias': 'recruitmentletters', // recruitmentletters | rohit ~ 17-4-2024 ~
			'exitletter': 'exitletter', // exitletter | rohit ~ 17-4-2024 ~
			'appintegrationmasteralias': 'appintegrationmaster',
			'bulkpolicyalias': 'bulkpolicy',
			'shiftmasteralias': 'shiftmaster',
			'annualbonusalias': 'annualbonus',
			'leavetypemasteralias': 'leavetypemaster',
			'leaverulemasteralias': 'leaverulemaster',
			'payrollheaderalias': 'payrollheader',
			'esicmasteralias': 'esicmaster',
			'epfmasteralias': 'epfmaster',
			'tdsalias': 'tds',
			'investmenttypealias': 'investmenttype',
			'payrollprocessalias': 'payrollprocess',
			'investmentalias': 'investment',
			'professionalalias': 'professional',
			'salaryheadermasteralias': 'salaryheadermaster',
			'biometricmasteralias': 'biometricmaster',
			'incrementrulealias': 'incrementrule',
			'attendancepolicymasteralias': 'attendancepolicymaster',
			'wagesmasteralias': 'wagesmaster',
			'loantypemasteralias': 'loantypemaster',
			'bonusalias': 'bonus',
			'payrollexporttemplatealias': 'payrollexporttemplate',//utsav 
			'lwfalias': 'labourwelfarefund',//aman
			'candidateassignmentpolicyalias':'candidateassignmentpolicy',//renish - candidate assignment policy [ 01-09-2025 ]

			'religionmasteralias': 'religionmaster',
			'holidaymasteralias': 'holidaymaster',
			'loanmasteralias': 'loan/loanmaster',
			'loanrequestalias': 'loan/loanrequest',
			'loanapprovalalias': 'loan/loanapproval',
			'ledgermasteralias': 'ledgermaster',
			'accountgroupmasteralias': 'accountgroupmaster',
			'logmanagealias': 'logmanage',
			'leaveapprovalmasteralias': 'leaveapprovalmaster',
			'latearrivalapprovalalias': 'latearrivalapproval',
			'applyleavealias': 'applyleave',
			'applyremoteworkalias': 'remoteworkapplication', // aman - wfh application
			'partialdayapplicationalias': 'partialdayapplication', // aman - wfh application
			'partialdayapprovalsalias': 'partialdayapprovals', //smit
			'salarymasteralias': 'salarymaster',
			'logregularizationsalias': 'logregularizations',
			'bulkreviewlogregularizationsalias': 'bulkreviewlogregularizations',	//  | Deep Dungarani  ~ 2025-11-04
			'bulklogaddalias': 'bulklogadd', // JATIN 28/11/2024 new added 12:39 PM 
			'reviewlogregularizationsalias': 'reviewlogregularizations',
			'leavebalancesalias': 'leavebalances',
			'leavecalendaralias': 'leavecalendar',
			'specialshiftcalendaralias': 'specialshiftcalendar',
			'leaveopeningbalancealias': 'leaveopeningbalance',
			'loprulealias': 'loprule',
			'dldrulealias': 'dldrule',
			'salarysliprequestsalias': 'salarysliprequests',
			'modulemasteralias': 'modulemaster',
			'iconmasteralias': 'iconmaster',
			'movetasksalias':'movetasks',

			'menumasteralias': 'menumaster',
			'menuassignalias': 'menuassign',
			'menudesignalias': 'menudesign',
			'orgchartalias': 'orgchart',
			'apimanageralias': 'apimanager',
			'announcementalias': 'announcement',
			'eventalias': 'event',
			'calendaralias': 'calendar',
			'myprofilealias': 'myprofile',
			'jsonformatteralias': 'jsonformatter',
			'homedashboardalias': 'homedashboard',
			'companyyeartypealias': 'companyyeartype',
			'salaryreportalias': 'salaryreport',
			'reportsalias': 'reports',
			'projectreportsalias': 'projectreports',
			'taskreportsalias': 'taskreports',
			'issuereportsalias': 'issuereports',
			'efficiencycalculatoralias': 'efficiencycalculator',
			'projectbudgetreportalias': 'projectbudgetreport',
			'overtimereportalias': 'overtimereport',
			'leavereportalias': 'leavereport',
			'latereasonreportalias': 'latereasonreport',
			'dailybucketreportalias': 'dailybucketreport',
			'latecountreportalias': 'latecountreport',
			'todoreportalias': 'todoreports',
			'logregularizationreportalias': 'logregularizationreport',
			'logregularizationcountreportalias': 'logregularizationcountreport',
			'salaryledgerreportalias': 'salaryledgerreport',
			'payrollattendancereportalias': 'payrollattendancereport',
			'tododatewisereportalias': 'tododatewisereports',
			'leavebalancereportalias': 'leavebalancereport',	// Deep Dungarani
			'analyticsalias': 'analytics',
			'praiseknockcategoryalias': 'praiseknockcategory',
			'praiseknocksubcategoryalias': 'praiseknocksubcategory',
			'esireportalias': 'esireport', //  smit surani  ~ 2025-06-25 ~ 09:52 AM
			'monthlycomponentbreakupalias': 'monthlycomponentbreakupreport', //  smit surani  ~ 2025-06-25 ~ 09:52 AM
			'lwfreportalias': 'listlwfreport', //  smit surani  ~ 2025-06-25 ~ 09:52 AM
			'tdsreportalias': 'tdsreport', //  smit surani  ~ 2025-06-25 ~ 09:52 AM
			'loanreportalias': 'loanreport', //  Aniket Bhesaniya 🛠️  ~ 2025-11-18 ~ 016:34 PM
			'loanemireportalias': 'loanemireport', //  Renish Salakhana ~ 2025-11-19 ~ 015:16 PM 
			'loanoutstandingreportalias': 'loanoutstandingreport', //  Renish Salakhana ~ 2025-11-19 ~ 015:16 PM

			'rewardconfigurationalias': 'rewardconfiguration',
			'rewardreportinsightalias': 'rewardreportinsight',
			'rewardandrecognitionalias': 'rewardandrecognition',
			'badgesalias': 'badges',
			'awardsalias': 'awards',
			'certificatesalias': 'certificates',
			'framesalias': 'frames',
			'moodsalias': 'moods',
			'chatuserstatusalias': 'chatuserstatus',
			'activitytrackeralias': 'activitytracker',
			'workreportalias': 'workreport',
			'payrollreportalias': 'payrollreport',
			'itemcategoryalias': 'itemcategory',
			'subcategoryalias': 'subcategory',
			'itembrandalias': 'itembrand',
			'itemmodelalias': 'itemmodel',
			'taxalias': 'tax',
			'vendoralias': 'vendor',
			'seatalias': 'seat',
			'beginningassetstockalias': 'beginningassetstock',
			'roomalias': 'room',
			'conditionalias': 'condition',
			'itemsalias': 'items',
			'assetsalias': 'assets', // JATIN 3/04/2025
			'assetborrowrequestalias': 'assetborrowrequest', // Asset Borrow Request

			'purchasealias': 'purchase',
			'salealias': 'sale',
			'purchasereturnalias': 'purchasereturn',
			'salereturnalias': 'salereturn',
			'assetsauditalias': 'assetsaudit',
			'vacantseatalias': 'vacantseat',
			'todocategoryalias': 'todocategory',
			'todostagealias': 'todostage',
			'todoflowalias': 'todoflow',
			'todopriorityalias': 'todopriority',
			'reviewtodotimelogrequestalias': 'reviewtodotimelogrequest',
			'levelofinterestalias': 'levelofinterest',
			'termsandconditionalias': 'termsandcondition',
			'leadsourcealias': 'crm/secondarysource',
			'leadprimarysourcealias': 'crm/primarysource',
			'supportcategoryalias': 'supportcategory',
			'supportticketflowalias': 'supportticketflow',
			'supportticketalias': 'supportticket',
			'supportticketstagealias': 'supportticketstage',
			'supportticketstageflowalias': 'supportticketstageflow',
			'placementalias': 'placement',
			'terminatereasonalias': 'exitreasonmaster',
			'exitstagealias': 'exitstage',
			'exitprocessalias': 'exitprocess',
			'trainingalias': 'training',
			'personassigntrainingalias': 'personassigntraining',
			'platformaccesspolicyalias': 'platformaccesspolicy',
			'managerreviewdetailsalias': 'managerreviewdetails',
			'performancereviewalias': 'performancereview',
			'performancereviewresponsealias': 'performancereviewresponse',
			'lettersalias': 'letters', //Changed pageAlias-rohit-2024-4-17-
			'probationmanagementalias': 'probationmanagement',
			'projectalerttemplatealias': 'projectalerttemplate',
			'projectmodetemplatealias': 'projectmodetemplate',//smit
			'misreportsalias': 'misreports',
			'letteralias': 'letter',
			'documentalias': 'doc',
			'filealias': 'file',
			'managerreviewsalias': 'managerreviews',
			'performancereviewsalias': "performancereviews",
			'reviewperformacesalias': "reviewperformance",
			'officephonealias': 'officephone',
			'officecalllogalias': 'officecalllog',
			'virtualnumberalias': 'virtualnumber',
			'messagetagalias': 'messagetag',
			'messagetemplatealias': 'messagetemplate',
			'chatflowalias': 'chatflow',
			'taxgroupalias': 'taxgroup',
			'customerdocumentsalias': 'customerdocuments',
			'phonenumberalias': 'phonenumber',
			'assetflooralias': 'floor',

			// whatsapp chat alias | Nirzar Gabani 💀 ~  2025-05-17 ~ 01:33 PM
			'whatsappchatalias': 'whatsappchat',
			'whatsappmessagealias': 'whatsappmessage',
			'whatsappuserconnectionalias': 'whatsappuserconnection',

			'issuealias': 'issue',
			'projectissuesalias': 'projectissues',

			'logrequestalias': 'logrequest',
			'reviewovertimealias': 'reviewovertime',
			'employeeupdateapprovalsalias': 'employeeupdateapprovals',
			'reviewtimelogapprovalsalias': 'reviewtimelogapprovals',
			'declarationapprovalsalias': 'declarationapprovals',
			'reviewwfhapplicationalias':'reviewwfhapplication', //  smit surani  ~ 2025-07-29 ~ 12:04 PM
			'reviewpartialdayapplicationalias':'reviewpartialdayapplication', //  | Aman - （︶^︶） ~  2025-08-06 ~ 02:54 PM 
			'reviewgroupadminrequestapprovalalias':'reviewgroupadminrequest',
			'reviewholdsalaryapprovalsalias':'holdsalaryapprovals',
			'remoteworkapprovalsalias':'remoteworkapprovals', //  priyanshi
			'partialdayapplicationapprovalsalias':'partialdayapplicationapprovals', 
			
			'reviewotalias': 'reviewot',
			'applicationalias': 'application',
			'chatalias': 'chat',
			'orgconfigurationalias': 'organizationconfiguration',
			'generalsettingsalias': 'generalsettings',
			'bizconfigurationalias': 'config',

			'declarationalias': 'declaration',
			'resignationalias': 'resignation',
			'dashboardalias': 'dashboard',
			'trainingdashboardalias': 'trainingdashboard',
			'payrollanalyticsalias': 'payrollanalytics',
			'crmanalyticsalias': 'crmanalytics',
			'leaderboardalias': 'leaderboard',
			'streamalias': 'stream',
			'walloffamealias': 'walloffame',
			'recognitionwallalias': 'recognitionwall',
			'employeeperformancereviewalias': 'employeeperformancereview',
			'candidateinquiryalias': 'candidateinquiry',
			'organconfigurationalias': 'orgconfiguration', //  | Om Z  🌝🌝🌝 ~ 2024-08-30 ~ 10:04 AM

			'meetingalias': 'meeting',

			//todo
			'todoalias': 'todo',
			'todokanbanalias': 'todokanban',
			'todoplainviewalias': 'todoplainview',

			//crm
			'crmalias': 'crm',
			'crmleadplainviewalias': 'lead',
			'crmleadkanbanviewwalias': 'leadkanban',
			'crmleadclassicviewwalias': 'leadclassicview',
			'leadalias': 'lead',
			'crmquotationstatusalias': 'crm/quotationstatus',
			'crmcontactalias': 'crm/contact',
			'organizationalias': 'organization', //crmaccount
			'followupalias': 'leadfollowup',
			'leadfollowupalias': 'crm/leadfollowup',
			'leadfollowupkanbanalias': 'leadfollowupkanban',
			'leadfollowupplainviewalias': 'leadfollowupplainview',
			'leadfollowupstatuskanbanalias': 'leadfollowupstatuskanban',
			'crmquotationalias': 'crm/quotation',
			'crmleadstatusalias': 'crm/leadstatus',
			'crmitemsalias': 'crm/items',
			'crmleadstagealias': 'crm/leadstage',
			'crmflowalias': 'crm/flow',
			'crmleadjsonalias': 'crm/lead',
			'leadembedformalias': 'leadembedform',
			'crmleadseriesalias': 'crm/lead/series',
			'metaintegrationalias': 'crm/metaintegration',
			'campaignstatusalias': 'crm/campaignstatus',
			'crmcloselostreasonalias': 'crm/reasons',
			'crmtargetalias': 'crm/target',
			'crmclienttypealias': 'crm/clienttype', // smit
			'leadsource': 'leadsource',
			'leadprimarysource': 'leadprimarysource',

			'adextensionmasteralias': 'crm/adextensions',
			'affinitymasteralias': 'crm/affinity',
			'bidstrategymasteralias': 'crm/bidstrategydelivery',
			'colormasteralias': 'crm/color',
			'similaraudiencealias': 'crm/similaraudience',

			// starts | Om Z  🌝🌝🌝 ~ 2024-10-12 ~ 01:09 PM
			"specialeventmasteralias": 'crm/specialevent',
			"keywordmasteralias": 'crm/keyword',
			"householdmasteralias": 'crm/householdincome',
			"devicemasteralias": 'crm/device',
			"channelmasteralias": 'crm/channel',
			"mediummasteralias": 'crm/medium',
			"campaignalias": 'crm/campaign',
			"campaigngroupalias": 'crm/campaigngroup',
			"campaigntracketattributeaudiencealias": "crm/campaigntrackerattributeandaudience",
			// ends | Om Z  🌝🌝🌝 ~ 2024-10-12 ~ 01:10 PM
			"campaigntrackeralias": 'crm/campaigntracker',
			"crmsourcemappingalias": 'crm/sourcemapping',
			"fbformlistalias": 'crm/fbformlist',
			"fbdbformlistalias": 'crm/metaintegration/page/dbformlist',
			"fetchprevleadalias": 'crm/metaintegration/fetchprevlead',
			"adsetalias": 'crm/metaintegration/listads',
			"metaintegrationleadsalias": 'crm/rawlead',
			"leadassignmentpolicyalias": 'crm/leadassignmentpolicy',
			"setupfacebookconversionalias": 'crm/facebookconversion',
			"facebookconversionlogalias": 'crm/facebookconversion/log',
			'fberrorlogalias': 'crm/fberrorlog',
			'campaignspendalias': 'crm/campaignspend',

			//crm chart alias
			'crmchannelbasedleadcount': 'crm/analytics/channel',
			'crmleadstatuscount': 'crm/analytics/leadstatus',
			'crmcampaigngroupperformance': 'crm/analytics/campaigngroup',
			'crmmediumandsourcewiseleadcount': 'crm/analytics/mediumandsourceperformance',
			'crmcampaignwiseleadcount': 'crm/analytics/campaignwiseleadcount',
			'crmdailyleadcountwithheatmap': 'crm/analytics/leadactivityanalytics',
			'crmcampaignwiseroiperformance': 'crm/analytics/campaignwiseroi',
			'crmcampaignandtrackerperformance': 'crm/analytics/campaign',
			'crmcampaignandtrackerroi': 'crm/analytics/campaignwisetrackerroi',
			'crmtargetvsachieved': 'crm/analytics/targetachievegraph',
			'crmtargetvsachievedmonthwise': 'crm/analytics/monthwisetargetachievebarchart',
			'crmassignvsachieved': 'crm/analytics/callmeetingtargetvsacheived',
			'crmstagewisetargetachieved': 'crm/analytics/stagewisetargetachievebarchart',
			'crmemployeewisetargetachieved': 'crm/analytics/employeewisetargetvsachievebarchart',
			'stagewisedistribution': 'crm/analytics/stagewisedistribution',

			//tasks
			'tasksalias': 'tasks',
			'personviewwalias': 'unassignedtask',
			'taskskanbanalias': 'kanban',
			'tasksplainviewalias': 'plainview',
			'tasksclassicviewalias': 'classicview',
			'taskstimerviewalias': 'timerview',
			'tasktimertrackingdetailsalias': 'tasktimertrackingdetails', //  | Om Z  🌝🌝🌝 ~ 2024-09-05 ~ 11:21 AM

			//home dashboard alias
			'homealias': 'home',

			'project360widgetsalias': 'project360/analytics',
			'project360documentsalias': 'project360/documents',
			'project360reportsalias': 'project360/reports',
			'project360detailsalias': 'project360/details',
			'project360overviewsalias': 'project360/overview',
			'project360projectreports': 'project360/reports/projectreports',
			'project360taskreports': 'project360/reports/taskreports',
			'project360issuereports': 'project360/reports/issuereports',
			'project360efficiencycalculator': 'project360/reports/efficiencycalculator',
			'project360overtimereport': 'project360/reports/overtimereport',
			'project360projectbudgetreport': 'project360/reports/projectbudgetreport',
			'project360dailybucketreport': 'project360/reports/dailybucketreport',
			'project360tododatereport': 'project360/reports/tododatewisereports',
			'project360todoreport': 'project360/reports/todoreports',
			'project360costreport': 'project360/reports/cost',
			// projectreports
			// taskreports
			// issuereports
			// efficiencycalculator
			// overtimereport
			// projectbudgetreport
			// dailybucketreport
			// 'detailsalias': 'project360/details',
			// 'activitystreamalias': 'project360/activitystream',
			// 'activitytimelinealias': 'project360/activitytimeline',
			// 'projectanalyticsalias': 'projectanalytics',
			// 'project360alias': 'project360',
			// 'projecoverview': 'project360/overview',
			'widgetsalias': 'analytics',
			'detailsalias': 'details',
			'dashboardalias': 'details',
			'activitystreamalias': 'project360/activitystreams',
			'activitytimelinealias': 'activitytimeline',
			'projectanalyticsalias': 'projectanalytics',
			'project360alias': 'project360',
			'allmeetingalias': 'allmeeting',
			'upcomingmeetingalias': 'upcomingmeeting',
			'completemeetingalias': 'completemeeting',
			'overduemeetingalias': 'overduemeeting',
			'projectmodulealias': 'projectmodule',
			'projectdocumentsalias': 'projectdocuments', // document linkage changes - shubham - do not stage
			'costalias': 'cost',
			'useralias': 'user',
			'activityalias': 'activitystreams',

			//alias for bulk policy
			'bulkpolicyattendancepolicyrulealias': 'bulkpolicy-attendancepolicyrule',
			'bulkpolicyleaverulepolicyalias': 'bulkpolicy-leaverulepolicy',
			// dld policy change aman
			'bulkpolicyloppolicyrulealias': 'bulkpolicy-dldpolicyrule',
			'bulkpolicybulkshiftassignalias': 'bulkpolicy-bulkshiftassign',
			'bulkpolicyplatformaccesspolicyrulealias': 'bulkpolicy-platformaccesspolicyrule',
			'bulkpolicybulkprojectassigneerulealias': 'bulkpolicy-projectassign',
			'bulkattendanceallowediprulealias': 'bulkpolicy-bulkallowedipassign', // smit
			'bulktdsslabrulealias': 'bulkpolicy-tdsslabassign', // smit 23-07-2025
			'bulkremotepolicyrulealias': 'bulkpolicy-remoteworkpolicyassign', // smit 23-07-2025
			'bulknoticeperiodpolicyalias': 'bulkpolicy-noticeperiodpolicy', // Deep Dungarani  ~ 2025-08-25 ~ 09:31 AM

			//alias for employee profile tab
			'employeeprofiledeclarationalias': 'employeeprofiledeclaration',
			'employeeprofileresignationalias': 'employee360/resignation',
			'employeeprofileassetsalias': 'employee360/assets',
			'employeeprofilewarningalias': 'employeeprofilewarning',
			'employeeprofileperformancealias': 'employee360/performance',
			'employeeprofiletrainingassignedalias': 'employee360/trainingassigned',
			'employeeprofiledocumentalias': 'employee360/document',
			'employeeprofileonboardingalias': 'employee360/onboarding',
			'employeeprofileoverviewalias': 'employee360/overview',
			'employeeprofilepayrollalias': 'employee360/payroll',
			'employeeprofilesignedindevicealias': 'employee360/signedindevice', //  smit surani  ~ 2025-05-31 ~ 017:20 PM
			'taxanddeclarationalias': 'employee360/taxanddeclaration',
			'attendancealias': 'employee360/attendance',



			'reviewsupporttickettimelogrequestalias': 'reviewsupporttickettimelogrequest',
			'reviewtrainingtimelogrequestalias': 'reviewtrainingtimelogrequest',
			'reviewbizcompasssupporttickettimelogrequestalias': 'reviewbizcompasssupporttickettimelogrequest',		//  | Deep Dungarani ~ 2025-04-14 ~ 01:00 PM

			'myprofileoverviewalias': 'overview',
			'myprofileassetsalias': 'assets',
			'myprofilesalaryslipalias': 'salarysliprequest',
			'myprofilewarningalias': 'warning',
			'myprofiletrainingalias': 'trainingassigned',
			'myprofiledocumentalias': 'userdocument',
			'myprofileperformancealias': 'performance',
			'myprofilesignedindevicealias': 'signedindevice',//smit surani
			'myprofiletdsslabalias': 'fetchtdscaculation',//smit surani
			'myprofiletdsslabrights': 'taxanddeclaration',//smit surani

			'employeereviewalias': 'employeereview',
			'onlineapptitudetestalias': 'onlineapptitudetest',
			//Activity Tracker
			'activitylist': 'list',
			'activityanalytics': 'analytics',
			'activitygallery': 'activitygallery',
			'activitytrackeranalytics': 'activitytracker/analytics',

			'whatsappintegrationalias': 'whatsappintegration',

			// Travel Expense and Reimbursement
			'traveladvancealias': 'traveladvance',
			'expensecategoryalias': 'expensecategory',
			'expensealias': 'expense',
			'reimbursementalias': 'reimbursement', // Reimbursement alias | Om Z  🌝🌝🌝 ~ 2025-01-08 ~ 03:50 PM

			'bizcompasssupportticketalias': 'bizcompasssupportticket',
			'bizsupportticketstageflowalias': 'bizsupportticketstageflow',  	//  | Deep Dungarani ~ 2025-04-14 ~ 01:00 PM

			//Booking	Deep Dungarani 03-02-2025
			'consultationalias': 'consultation',
			'workspacealias': 'workspace',
			'bookingalias': 'booking',
			'appointmentsbookingalias': 'appointmentsbooking',
			'consultationslotsalias': 'consultation/slots',

			// integration 		Deep Dungarani
			'integrationalias': 'integration',

			// googleCalendar | Deep Dungarani ~ 2025-04-29 ~ 02:46 PM
			'refreshintegrationaccountstokensalias': 'refreshintegrationaccountstokens',

			//Sync Calendar events
			'synccalendarevents': 'synccalendarevents',

			// Resource Request | Deep Dungarani ~ 2025-05-06 ~ 12:41 PM
			'resourcerequestalias': 'resourcerequest',
			'careersalias': 'careers',
			//payroll configuration
			'payrollconfigurationalias': 'payrollconfiguration',
			//Employee Device Mapping
			'employeedevicemappingalias': 'employeedevicemapping',

			'logregreasonalias': 'logregreason',

			'averagesalaryreportalias': 'averagesalaryreports',
			'overtimetaskreportalias': 'overtimetaskreports',
			'piireportalias': 'piireports',
			'crosscompanycostalias': 'crosscompanycost',
			'companywisecostalias': 'companywisecostreport',
			'costreportalias': 'cost',
			'locationreportalias': 'locationwiselogsreport',
			'geoattendancereportalias': 'geoattendancereport',
			'remoteworkreportalias': 'remoteworkreport', // smit
			'partialdayapplicationreportalias': 'partialdayapplicationreport', // smit
			'employeeattendencereportalias': 'daywiseattendancereport', // smit
			'listlogreportalias': 'listfirstlastlogreport', // smit
			'shiftreportalias': 'assignshiftreport', // Pranav'
			'interviewperformancereportalias': 'interviewperformancereport', // | Nirzar Gabani 💀 ~  2025-12-10 ~ 11:45 AM

			// CRM Reports
			'leadstagereportalias': 'leadstagereport',
			'tagwisereportalias': 'tagwisereport',
			'saleswisereportalias': 'saleswisereport',
			'sourcewisereportalias': 'sourcewisereport',
			'categorywisereportalias': 'categorywisereport',
			'personwisereportalias': 'personwisereport',
			'targetvsachievedreportalias': 'targetvsachievedreport',
			'callsummaryreportalias': 'callsummaryreport',
			'callmeetingtargetvsacheivedalias': 'callmeetingtargetvsacheived',
			'stagewisetargetachievereportalias': 'stagewisetargetachievereport',
			'geolocationactivityreportalias': 'locationtrackingreport', // Added for location tracking report Aniket Bhesaniya 🛠️  ~ 2025-07-07 ~ 10:15 AM

			//  Configuration -> approvals hierarchy
			'approvalshierarchyalias': 'approvalshierarchy',

			// upload document alias | Nirzar Gabani 💀 ~  2025-06-03 ~ 05:37 PM
			'uploaddocumentsalias': 'uploaddocument',
			'authenticatedocumentuploadalias': 'authenticatedocumentupload',
			'publicdocumentuploadalias': 'publicdocumentupload',

			// letter acknowledgement | Nirzar Gabani 💀 ~  2025-06-03 ~ 05:37 PM
			'letteracknowledgementalias': 'letteracknowledgement',
			'authenticateacknowledgementsignalias': 'authenticateacknowledgementsign',
			'updatesignaturealias': 'updatesignature',
			'sendacknowledgementmailalias': 'sendacknowledgementmail',

			// employee letter acknowledgement | Nirzar Gabani 💀 ~  2025-07-08 ~ 04:26 PM
			'employeeletteracknowledgementalias': 'employeeletteracknowledgement',
			'persondocumentsalias': 'persondocuments',

			// | Nirzar Gabani 💀 ~  2025-06-03 ~ 05:38 PM
			'applicationlistviewalias': 'applicationlist',

			//  | Deep Dungarani  ~ 2025-10-28
			'resourcerequestlistviewalias': 'resourcerequestlist',

			'verifyrecaptchatokenalias': 'verifyrecaptchatoken',
			'page404alias': 'page404',
			'paysliptemplatemaster': 'sliptemplate',

			// cp storage validations
			'InsufficientDBStorage': 'Due to insufficient database storage of less than 10 MB, you are unable to create a form',
			'InsufficientStorage': 'Insufficient storage (<10 MB) for dynamic forms or CSV import.',

			'retreivedocumentdetailsalias': 'retreivedocumentdetails',	//  | Deep Dungarani  ~ 2025-06-10 ~ 03:31 PM

			'letterapprovalsalias': 'letterapprovals',	//  | Deep Dungarani  ~ 2025-06-12 ~ 11:46 AM

			'pfreportalias': 'pfreport', // Utsav ~ 2025-06-23 
			'grossytdreportalias': 'gorssytdreport', // Utsav ~ 2025-06-23 
			'headcountreportalias': 'headcountreport', // Utsav ~ 2025-06-23 
			'ptreportalias': 'ptreport', // aman - 24/6/2025

			// Letter Series Master
			'allletterslogalias': 'allletterslog',
			'alllettersalias': 'allletters',

			// Notice Period Policy | Deep Dungarani  ~ 2025-08-25
			'noticeperiodpolicyalias': 'noticeperiodpolicy',
			'noticeperiodrecoveryalias': 'noticeperiodrecovery',
			'exitchecklistalias': 'exitchecklist',

			// Handover Approval | Deep Dungarani  ~ 2025-09-03 ~ 07:19 PM
			'handoverapprovalsalias': 'handoverapprovals',
			// Group Admin Request Approval | smit surani  ~ 2025-11-11 ~ 07:19 PM
			'groupadminrequestapprovalsalias': 'groupadminrequestapprovals',
			'holdsalaryapprovalsalias': 'holdsalaryapprovals',

			// kra kpi alias | Nirzar Gabani 💀 ~  2025-09-05 ~ 10:20 AM
			'kramasteralias': 'krakpiconfiguration/kra',
			'kpimasteralias': 'krakpiconfiguration/kpi',
			'krakpitemplatealias': 'krakpiconfiguration/templates', 
			'allkraviewalias': 'assignkrakpi',
			'employeewisekraviewalias': 'employeewise',
			'departmentwisekraviewalias': 'departmentwise',
			'companywisekraviewalias': 'companywise',
			'krakpireviewalias': 'krakpireview', // used in performance tab from employee360 | Renish Salakhana ~ 2025-09-10 ~ 017:45 PM
			'krakpistatusalias' : 'krakpistatus',

			// Recruitment Reports | Deep Dungarani  ~ 2025-10-11
			'recruitmentreportalias': 'recruitmentreport',
			'candidateofferreportsalias': 'candidateofferreports',
			'customfields' :'customfields',

			// Performance Managemene Utils | Renish Salakhana 19-12-2000 
			'performancemanagealias':'performancemaster',

			//  | Deep Dungarani  ~ 2025-12-25
			'reviewperformancealias': 'reviewperformance',
			'reviewperformancereviewalias':'review',
			'reviewperformanceanalysisalias':'analysis',
			'reviewperformancesummeryalias':'summery',
			'reviewperformancepramotionalias':'promotion',
			'assignperformancealias':'assignperformance',
		}

		// field for employee master data | Nirzar Gabani 💀 ~  2025-04-11 ~ 12:00 PM
		this.employeedata = 'employee'
		this.hierachyemployee = 'hierachyemployee'

		this.companyworkdaytypeids = ['6239acb4e7307acecd7048e8', '6239ac88e7307acecd7048e7', '6239ace0e7307acecd7048e9', '62f089f4c9f356daa597b366', '62f08a01c9f356daa597b367']
		// widget alias name | Nirzar Gabani 💀 ~  2025-04-11 ~ 12:00 PM
		this.widgetaliasname = {
			'otapprovalalias': 'otapproval',
			'employeeleavealias': 'employeeleaves',
			'leavebalancealias': 'leavebalance',
			'leaveapprovalalias': 'leaveapproval',
			'pendingsurveyalias': 'pendingsurvey',
			'wfhbalancealias': 'remoteworkbalance',
		}

		this.crmEmbedFormText = {
			'crmembedformheadingttle': 'Your Leads, Your Way !',
			'crmembedformsubtext': 'Effortless lead capture, tailored for your success.',
			'responsesubmitted': 'Your response was submitted.',
			'resubmitresponse': 'Submit Another Response.',
		}

		this.csvdemofilename = {
			[this.aliasname.crmalias]: 'Bizcompass_Demo_Lead',
			[this.aliasname.itemsalias]: 'Bizcompass_Demo_Asset',
			[this.aliasname.beginningassetstockalias]: 'Bizcompass_Demo_Asset',
			[this.aliasname.projectsalias]: 'Bizcompass_Demo_Project',
			[this.aliasname.testcasemasteralias]: 'Bizcompass_Demo_testCase',
			[this.aliasname.questionanswermasteralias]: 'Bizcompass_Demo_Question',
			['task']: 'Bizcompass_Demo_Task',
			[this.aliasname.employeemasteralias]: 'Bizcompass_Demo_Employee',
			[this.aliasname.candidateinquiryalias]: 'Bizcompass_Demo_Candidate',
			[this.aliasname.bonusalias]: 'Bizcompass_Demo_Bonus',
			[this.aliasname.salarymasteralias]: 'Bizcompass_Demo_Salary',
			[this.aliasname.overtimechartalias]: 'Overtime_Approve_Vs_Reject',
			[this.aliasname.payrollconfigurationalias]: 'Payroll_Configuration_Demo',
			[this.aliasname.employeedevicemappingalias]: 'Employee_Device_Mapping_Demo', // smit
			[this.aliasname.openingmasteralias]: 'Bizcompass_Demo_Opening',          // Pravin ~ 14-05-2025 ~ 2:40 PM
			[this.aliasname.resourcerequestalias]: 'Bizcompass_Demo_Resource_Request',  //  Aniket Bhesaniya 🛠️  ~ 2025-06-30 ~ 10:35 AM
			[this.aliasname.logmanagealias]: 'Bizcompass_Demo_logs',
			[this.aliasname.crmcontactalias]: 'Bizcompass_Demo_Contact',          // Pravin ~ 05-06-2025 ~ 1:01 PM
			[this.aliasname.organizationalias]: 'Bizcompass_Demo_Organization',          // Pravin ~ 05-06-2025 ~ 1:01 PM
			[this.aliasname.kpimasteralias] : 'Bizcompass_Demo_KPI', // used for sample demo import csv file name for kpi csv import |  Renish Salakhana ~ 2025-09-10 ~ 015:16 PM
			[this.aliasname.kramasteralias] : 'Bizcompass_Demo_KRA', // used for sample demo import csv file name for kra csv import |  Renish Salakhana ~ 2025-09-10 ~ 015:17 PM
			[this.aliasname.declarationalias] : 'Person_Investment', // used for sample demo import csv file name for kra csv import |  Renish Salakhana ~ 2025-09-10 ~ 015:17 PM
		}

		this.tablenames = {
			[this.aliasname.channelmasteralias]: 'tblchannelmaster',
			[this.aliasname.mediummasteralias]: 'tblmediummaster',
			[this.aliasname.campaigngroupalias]: 'tblcampaigngroupmaster',
			[this.aliasname.campaigntracketattributeaudiencealias]: 'tblcampaigntrackerattributeaudiencemaster',
			[this.aliasname.crmsourcemappingalias]: 'tblsourcemapping',
			[this.aliasname.campaignstatusalias]: 'tblcampaignstatusmaster',
			[this.aliasname.leadassignmentpolicyalias]: 'tblleadassignmentpolicy',
			[this.aliasname.campaigntrackeralias]: 'tblcampaigntrackermaster',
			[this.aliasname.metaintegrationalias]: 'tblfacebooklogin',
			[this.aliasname.metaintegrationleadsalias]: 'tblrawlead',
			[this.aliasname.campaignspendalias]: 'tblcampaignspendmaster',
			[this.aliasname.campaignalias]: 'tblcampaignmaster',
			[this.aliasname.levelofinterestalias]: 'tbllevelofinterest',
			[this.aliasname.leadassignmentpolicyalias]: 'tblleadassignmentpolicy',
			[this.aliasname.crmleadstagealias]: 'tblleadstage',
			[this.aliasname.campaignalias]: 'tblcampaignmaster',
			[this.aliasname.crmclienttypealias]: 'tblclienttype', // smit surani  ~ 2025-07-15 ~ 10:14 AM
			[this.aliasname.lwfalias]: 'tbllwfmaster', // smit surani  ~ 2025-07-18 ~ 09:20 AM
			[this.aliasname.krakpireviewalias]: 'tblkrakpiemp360', //  Renish Salakhana ~ 2025-09-17 ~ 10:24 AM
			[this.aliasname.salarysliprequestsalias]: 'tblsalarysliprequest', //  Pranav Rangunwala ~ 2025-10-17 ~ 03:24 PM
			[this.aliasname.phonenumberalias]: 'tblphonenumbers', //  Pranav Rangunwala ~ 2025-10-27 ~ 03:58 PM
			[this.aliasname.logregreasonalias]: 'tbllogregularizationreason', //  Pranav Rangunwala ~ 2025-10-27 ~ 03:58 PM
			[this.aliasname.fbformlistalias]: 'tblfacebookforms', //  Pranav Rangunwala ~ 2025-10-27 ~ 06:21 PM
			[this.aliasname.fberrorlogalias]: 'tblfacebookpageerror', //  Pranav Rangunwala ~ 2025-10-28 ~ 09:40 AM
			[this.aliasname.adsetalias]: 'tblfacebookads', //  Pranav Rangunwala ~ 2025-10-28 ~ 10:07 AM
			[this.aliasname.remoteworkalias]: 'tblwfhrule', //  Pranav Rangunwala ~ 2025-10-28 ~ 05:04 PM
		}

		this.viewnames = {
			'listView': 'listView',
			'folderView': 'folderView'
		}

		//No data found 
		this.nodatafoundbutton = {
			[this.aliasname.greetingmessagealias]: 'Add Message',
			[this.aliasname.crmleadstatusalias]: 'Add Lead Status',
			[this.aliasname.citymasteralias]: 'Add City',
		}

		//Booking Page Configuration - Deep Dungarani
		this.bookingpagenames = {
			'workspace': 'workspace',
			'consultant': 'consultant',
			'consultation': 'consultation'
		}
		// Do not remove this || Aniket Bhesaniya ~ 13/06/2025
		// centralized redirection url production | Aniket ~ 2024-01-05 
		this.redirectionurl = "integration.bizcompass.app"
		this.googleredirectionurl = "https://integration.bizcompass.app/auth/callback"
		this.microsoftredirectionurl = "https://integration.bizcompass.app/auth/callback"
		this.metaredirectionalurl = 'https://integration.bizcompass.app/auth/callback'

		// Do not remove this || Aniket Bhesaniya ~ 13/06/2025
		// centralized redirection url local | Aniket ~ 2024-01-05 
		// this.redirectionurl = "integration.bizcompass.app"
		// this.googleredirectionurl = "http://localhost:3000/integration/auth/callback"
		// this.microsoftredirectionurl = "http://localhost:3000/integration/auth/callback"
		// this.metaredirectionalurl = 'http://localhost:3000/integration/auth/callback'

		this.conflictbuttonname = 'Check Availability'
		//  Aniket Bhesaniya 🛠️  ~ 2025-08-01 ~ 018:40 PM
		this.papersize = {
			A3: {
				width: 297,
				height: 420
			},
			A4: {
				width: 210,
				height: 297
			},
			A5: {
				width: 148,
				height: 210
			},
			Legal: {
				width: 216,
				height: 356
			},
			Letter: {
				width: 216,
				height: 279
			},
		}

		this.QR_DENSITY_LEVELS = [ // QR density level options for different error correction level
			{ value: 'L', label: 'L - Low (7% Recovery, High Density)' },
			{ value: 'M', label: 'M - Medium (15% Recovery)' },
			{ value: 'Q', label: 'Q - Quality (25% Recovery)' },
			{ value: 'H', label: 'H - High (30% Recovery, Most Reliable)' }
		];
		this.GenerateQrbuttonname = 'Generate & Print QR'
		this.pagenamelist = {
			'projecttaskstatus': 'projecttaskstatus',
			'projectcategory': 'projectcategory',
			'defaultprojectusers': 'defaultprojectusers',
			'defaultmodule': 'defaultmodule',
			'meeting': 'meeting',
			'project': 'project',
			'projectmodule': 'projectmodule',
			'testcase': 'testcase',
			'testcasegroup': 'testcasegroup',
			'client': 'client',
			'renewals': 'renewals',
			'file': 'file',
			'notificationsetting': 'notificationsetting', // Notification Setting | Om Z  🌝🌝🌝 ~ 2024-11-14 ~ 02:20 PM
			'stickerprintsettings' : 'stickerprintsettings',//  Aniket Bhesaniya 🛠️  ~ 2025-07-31 ~ 09:14 AM
			'projectstatus': 'projectstatus',
			'projecttaskflow': 'projecttaskflow',
			'platform': 'platform',
			'functionality': 'functionality',
			'tag': 'tag',
			'employee': 'employee',
			'resignations': 'resignations',
			'subdepartment': 'subdepartment', // Sub Department | rohit ~ 2024-11-14 ~
			'subdesignation': 'subdesignation', // Sub Designation | rohit ~ 2024-11-14 ~
			'approvals': 'approvals',
			'travelapprovals': 'travelapprovals', // Travel Desk Pagename | Om Z  🌝🌝🌝 ~ 2025-01-08 ~ 03:51 PM
			'warning': 'warning',
			'warningreason': 'warningreason',
			'declaration':'declaration',
			// JATIN 3/1/25 old comment and New added 
			'travel': 'travel',
			'annualcalendar': 'annualcalendar',
			'customer': 'customer',
			'salespartner': 'salespartner',
			'clientdashboard': 'clientdashboard',
			'notabugreason': 'notabugreason',
			'personrunningtimer': 'personrunningtimer',
			'reviewtimelogrequest': 'reviewtimelogrequest',
			'orgconfiguration': 'orgconfiguration', //  | Om Z  🌝🌝🌝 ~ 2024-08-30 ~ 10:05 AM
			'bizconfiguration': 'bizconfiguration',
			'paysliptemplatemaster':'sliptemplate',

			'sprint': 'sprint',
			'projectrelease': 'projectrelease',
			'userrole': 'userrole',
			'branch': 'branch',
			'location': 'location', // smit
			'company': 'company',
			'customercompany': 'customercompany', //Rohit-05/05/25
			'pmrstarget': 'pmrstarget',
			'iconextension': 'iconextension',
			'department': 'department',
			'designation': 'designation',
			'allowedip': 'allowedip',
			'taskreason': 'taskreason',
			'latereason': 'latereason',
			'resignreason': 'resignreason',
			'greetingmessage': 'greetingmessage',
			'manualtimelogreason': 'manualtimelogreason',
			'apprelease': 'apprelease',

			'survey': 'survey',
			'surveyform': 'surveyform',
			'submitsurvey': 'submitsurvey',
			'package': 'package',
			'policy': 'policy',
			'agreement': 'agreement',
			'appointmentletter': 'appointmentletter',
			'exitletter': 'exitletter',
			'offerletter': 'offerletter',
			'userrights': 'userrights',
			'productivity': 'productivity',
			'city': 'city',
			'country': 'country',
			'state': 'state',
			'district': 'district',
			'source': 'source',

			'userrolehierarchy': 'userrolehierarchy',
			'series': 'series',
			'relation': 'relation',
			'manual': 'manual',
			'emailsmtp': 'emailsmtp',
			'emailtemplate': 'emailtemplate',
			'qualification': 'qualification',
			'analyticsemail': 'analyticsemail',
			'dashboardrights': 'dashboardrights',
			'thirdparty': 'thirdparty',
			'employment': 'employment',
			'interviewstage': 'interviewstage',
			'interviewprocess': 'interviewprocess',
			'joiningprocedure': 'joiningprocedure',
			'paygrade': 'paygrade', // Smit Surani | 2025-14-04 ~ 4:00 PM
			'bank': 'bank', // Smit Surani | 2025-13-08 ~ 4:00 PM
			'costcenter': 'costcenter', // Smit Surani | 2025-14-04 ~ 4:30 PM
			'employeeganttchart': 'employeeganttchart',
			'remotework': 'remoteworkpolicy',

			'document': 'document',
			'assigneddocument': 'assigneddocument',
			'joiningstage': 'joiningstage',
			'technicalskill': 'technicalskill',
			'candidate': 'candidate',
			'employeereferral': 'employeereferral',
			'opening': 'opening',
			'recruitmentdashboard': 'recruitmentdashboard',
			'questionanswer': 'questionanswer',
			'questionset': 'questionset',
			'candidaterejectreason': 'candidaterejectreason',
			'openingstatus': 'openingstatus',
			'candidatestatus': 'candidatestatus',
			'candidatesource': 'candidatesource',
			'candidateprimarysource': 'primarycandidatesource',
			'placementdrive': 'placementdrive',
			'employeereferralprogram': 'employeereferralprogram',

			'appintegration': 'appintegration',
			'bulkpolicy': 'bulkpolicy',
			'shift': 'shift',
			'annualbonus': 'annualbonus',
			'leavetype': 'leavetype',
			'leaverule': 'leaverule',
			'payrollheader': 'payrollheader',
			'esic': 'esic',
			'epf': 'epf',
			'tds': 'tds',
			'investmenttype': 'investmenttype',
			'payrollprocess': 'payrollprocess',
			'payrollexporttemplate': 'payrollexporttemplate', //Utsav
			'lwfpagename': 'labourwelfarefund',//Aman
			'investment': 'investment',
			'professional': 'professional',
			'salaryheader': 'salaryheader',
			'biometric': 'biometric',
			'incrementrule': 'incrementrule',
			'attendancepolicy': 'attendancepolicy',
			'wages': 'wages',
			'loantype': 'loantype',
			'bonus': 'bonus',
			'candidateassignmentpolicy':'candidateassignmentpolicy', //renish 01-09-2025

			'religion': 'religion',
			'holiday': 'holiday',
			'loan': 'loan',
			'loanrequest': 'loanrequest',
			'loanapproval': 'loanapproval',
			'ledger': 'ledger',
			'accountgroup': 'accountgroup',
			'logmanage': 'logmanage',
			'leaveapproval': 'leaveapproval',
			'reviewremoteworkapplication': 'reviewremoteworkapplication',
			'reviewpartialdayapplication': 'reviewpartialdayapplication',
			'reviewgroupadminrequest': 'reviewgroupadminrequest',
			'reviewholdsalary': 'holdsalaryapprovals',
			'wfhapprovals': 'wfhapprovals',
			'partialdayapplicationapprovals': 'partialdayapplicationapprovals',
			'partialdayapprovals':'partialdayapprovals',
			'latearrivalapproval': 'latearrivalapproval',
			'applyleave': 'applyleave',
			'applyremotework': 'remoteworkapplication',
			'partialdayapplication': 'partialdayapplication',
			'salary': 'salary',
			'logregularizations': 'logregularizations',
			'bulklogadd': 'bulklogadd', // JATIN 28/11/2024 12:46 PM
			'reviewlogregularizations': 'reviewlogregularizations',
			'leavebalances': 'leavebalances',
			'leavecalendar': 'leavecalendar',
			'specialshiftcalendar': 'specialshiftcalendar',
			'leaveopeningbalance': 'leaveopeningbalance',
			'loprule': 'loprule',
			'dldrule': 'dldrule',
			'salarysliprequests': 'salarysliprequests',
			'module': 'module',
			'icon': 'icon',

			'menu': 'menu',
			'menuassign': 'menuassign',
			'menudesign': 'menudesign',
			'orgchart': 'orgchart',
			'apimanager': 'apimanager',
			'announcement': 'announcement',
			'event': 'event',
			'calendar': 'calendar',
			'myprofile': 'myprofile',
			'jsonformatter': 'jsonformatter',
			'companyyeartype': 'companyyeartype',
			'reports': 'reports',
			'cost': 'cost',
			'praiseknockcategory': 'praiseknockcategory',
			'praiseknocksubcategory': 'praiseknocksubcategory',

			'rewardconfiguration': 'rewardconfiguration',
			'rewardreportinsight': 'rewardreportinsight',
			'rewardandrecognition': 'rewardandrecognition',
			'badges': 'badges',
			'awards': 'awards',
			'certificates': 'certificates',
			'frames': 'frames',
			'moods': 'moods',
			'chatuserstatusmaster': 'chatuserstatusmaster',
			'activitytracker': 'activitytracker',
			'workreport': 'reports/workreport',
			'payrollreport': 'payrollreport',
			'itemcategory': 'itemcategory',
			'subcategory': 'subcategory',
			'itembrand': 'itembrand',
			'itemmodel': 'itemmodel',
			'tax': 'tax',
			'vendor': 'vendor',
			'seat': 'seat',
			'beginningassetstock': 'beginningassetstock',
			'room': 'room',
			'condition': 'condition',
			'items': 'items',
			'assetborrowrequest': 'assetborrowrequest',

			'purchase': 'purchase',
			'sale': 'sale',
			'purchasereturn': 'purchasereturn',
			'salereturn': 'salereturn',
			'assetsaudit': 'assetsaudit',
			'vacantseat': 'vacantseat',
			'todocategory': 'todocategory',
			'todostage': 'todostage',
			'todoflow': 'todoflow',
			'todopriority': 'todopriority',
			'reviewtodotimelogrequest': 'reviewtodotimelogrequest',
			'levelofinterest': 'levelofinterest',
			'termsandcondition': 'termsandcondition',
			'leadsource': 'leadsource',
			'leadprimarysource': 'leadprimarysource',
			'primarysource': 'primarysource',
			'supportcategory': 'supportcategory',
			'supportticketflow': 'supportticketflow',
			'supportticket': 'supportticket',
			'supportticketstage': 'supportticketstage',
			'supportticketstageflow': 'supportticketstageflow',
			'placement': 'placement',
			'terminatereason': 'terminatereason',
			'exitstage': 'exitstage',
			'exitprocess': 'exitprocess',
			'training': 'training',
			'personassigntraining': 'personassigntraining',
			'platformaccesspolicy': 'platformaccesspolicy',
			'managerreviewdetails': 'managerreviewdetails',
			'performancereview': 'performancereview',
			'performancereviewresponse': 'performancereviewresponse',
			'letters': 'letters', //Changed pageName-rohit-2024-4-17-
			'probationmanagement': 'probationmanagement',
			'projectalerttemplate': 'projectalerttemplate',
			'projectmodetemplate': 'projectmodetemplate',//Smit
			'misreports': 'reports/misreports',
			'officephone': 'officephone',
			'officecalllogs': 'officecalllogs',
			'virtualnumber': 'virtualnumber',
			'messagetag': 'messagetag',
			'messagetemplate': 'messagetemplate',
			'chatflow': 'chatflow',
			'phonenumber': 'phonenumber',
			'whatsappchat': 'whatsappchat',
			'customerdocuments': 'customerdocuments',
			'floor': 'floor', // added for asset management module renish salakhana ~ 03:49 PM 26-08-2025

			'task': 'task',
			'todo': 'todo',
			'todotask': 'todotask',			//  | Deep Dungarani ~ 2025-05-22 ~ 015:23 PM
			'tasktag': 'tasktag',     //  | Deep Dungarani ~ 2025-05-22 ~ 015:47 PM
			'criteria': 'criteria',     //  | Renish Salakhana ~ 2025-08-26 ~ 10:32 AM
			'timeframe': 'timeframe',     //  | Renish Salakhana ~ 2025-08-26 ~ 02:20 PM

			//crm
			'lead': 'crm/lead',
			'leadembedform': 'leadembedform',
			'quotationstatus': 'crm/quotationstatus',
			'crmcontact': 'crm/contact',
			'crmaccount': 'crm/account',
			'crmleadfollowup': 'crm/leadfollowup',
			'crmquotation': 'crm/quotation',
			'crmleadstatus': 'crm/leadstatus',
			'crmitems': 'crm/items',
			'crmleadstage': 'crm/leadstage',
			'crmflow': 'crm/flow',
			'metaintegration': 'crm/metaintegration',
			'adextensionmaster': 'crm/adextension',
			'affinitymaster': 'crm/affinity',
			'bidstrategymaster': 'crm/bidstrategy',
			'colormaster': 'crm/color',
			'similaraudience': 'crm/similaraudience',
			'crmcloselostreason': 'crm/reasons',
			'crmtarget': 'crm/target',
			'crmclienttype': 'crm/clienttype', // smit surani  ~ 2025-07-15 ~ 10:14 AM


			// starts | Om Z  🌝🌝🌝 ~ 2024-10-12 ~ 01:09 PM
			"specialeventmaster": 'crm/specialevent',
			"keywordmaster": 'crm/keyword',
			"householdmaster": 'crm/household',
			"devicemaster": 'crm/device',
			"channelmaster": 'crm/channel',
			"mediummaster": 'crm/medium',
			"campaign": 'crm/campaign',
			"campaigngroup": 'crm/campaigngroup',
			"campaigntracketattributeaudience": 'crm/campaigntrackerattributeandaudience',
			// ends | Om Z  🌝🌝🌝 ~ 2024-10-12 ~ 01:10 PM
			"campaigntracker": 'crm/campaigntracker',
			"metaintegrationpage": 'crm/metaintegration/page',
			"crmsourcemapping": 'crm/sourcemapping',
			'campaignstatus': 'crm/campaignstatus',
			'campaignspend': 'crm/campaignspend',
			"fbformlist": 'crm/fbformlist',
			"fbdbformlist": 'crm/metaintegration/page/dbformlist',
			"fetchprevlead": 'crm/metaintegration/fetchprevlead',
			"adset": 'crm/metaintegration/listads',
			"metaintegrationleads": 'crm/rawlead',
			"leadassignmentpolicy": 'crm/leadassignmentpolicy',
			"setupfacebookconversion": 'crm/facebookconversion',
			"facebookconversionlog": 'crm/facebookconversion/log',
			'candidateinquiry': 'candidateinquiry',
			'fberrorlog': 'crm/fberrorlog',

			'employeereview': 'employeereview',
			'taxgroup': 'taxgroup',

			'bizcompasssupportticket': 'bizcompasssupportticket',

			// Travel Expense and Reimbursement
			"traveladvance": "traveladvance",
			"expensecategory": "expensecategory",
			'expense': 'expense',
			'reimbursement': 'reimbursement', // Reimbursement | Om Z  🌝🌝🌝 ~ 2025-01-08 ~ 03:50 PM
			'projectreportspagename': 'reports/projectreports',
			'taskreportspagename': 'reports/taskreports',
			'issuereportspagename': 'reports/issuereports',
			'esisummaryreportpagename': 'reports/esireport', //  smit surani  ~ 2025-06-24 ~ 09:40 AM
			'lwfreportpagename': 'reports/listlwfreport', //  smit surani  ~ 2025-06-24 ~ 09:40 AM
			'loanreportpagename': 'reports/loanreport', //  smit surani  ~ 2025-06-24 ~ 09:40 AM
			'loanemireportpagename': 'reports/loanemireport', // Renish Salakhana ~ 2025-11-19 ~ 015:19 PM
			'loanoutstandingreportpagename': 'reports/loanoutstandingreport', //  Renish Salakhana ~ 2025-11-19 ~ 015:19 PM
			'monthcomponentbreakupreportpagename': 'reports/monthlycomponentbreakupreport', //  smit surani  ~ 2025-06-24 ~ 09:40 AM
			'efficiencycalculatorpagename': 'reports/efficiencycalculator',
			'overtimereportpagename': 'reports/overtimereport',
			'projectbudgetreportpagename': 'reports/projectaverage',
			'leavereportpagename': 'reports/leavereport',
			'latereasonreportpagename': 'reports/latereasonreport',
			'dailybucketreportpagename': 'reports/dailybucketreport',
			'latecountreportpagename': 'reports/latecountreport',
			'tododatewisereportspagename': 'reports/tododatewisereports',
			'todoreportspagename': 'reports/todoreports',
			'logregularizationreportpagename': 'reports/logregularizationreport',
			'salaryledgerreportpagename': 'reports/salaryledgerreport',
			'payrollattendancereportpagename': 'reports/payrollattendancereport',
			'pfreportpagename': 'reports/pfreport',
			'headcountreportpagename': 'reports/headcountreport',
			'gorssytdreportpagename': 'reports/gorssytdreport',
			'leavebalancepagename': 'reports/leavebalancereport',
			'remoteworkreportpagename': 'reports/remoteworkreport', // smit
			'partialdayapplicationreportpagename': 'reports/partialdayapplicationreport', // smit
			'employeeattendencereportpagename': 'reports/daywiseattendancereport', // smit
			'listlogreportpagename': 'reports/listfirstlastlogreport', // smit
			'shiftreposrpagename': 'reports/assignshiftreport', // Pranav
			'interviewperformancereportspagename': 'reports/interviewperformancereport', // Pranav

			'whatsappintegration': 'whatsappintegration',
			'logregreasonname': 'logregreason',

			//Booking	Deep Dungarani 03-02-2025
			'consultationpagename': 'consultation',
			'workspacepagename': 'workspace',
			'bookingpagename': 'booking',
			'appointmentsbookingpagename': 'appointmentsbooking',

			// integration  | Deep Dungarani  ~ 2025-04-09 ~ 02:46 PM
			'integrationpagename': 'integration',

			// Resource Request | Deep Dungarani ~ 2025-05-06 ~ 12:44 PM
			'resourcerequestpagename': 'resourcerequest',
			'requestresourceupdatefield': 'requestresource',

			'averagesalaryreportpagename': 'reports/averagesalaryreports',
			'overtimetaskreportpagename': 'reports/overtimetaskreports',
			'piireportpagename': 'reports/piireports',
			'crosscompanycostpagename': 'reports/crosscompanycost',
			'companywisecostpagename': 'reports/companywisecostreport',
			'costreportpagename': 'reports/cost',
			'locationreportpagename': 'reports/locationwiselogsreport',
			'geoattendancereportpagename': 'reports/geoattendancereport',

			// CRM Reports
			'leadstagereportpagename': 'reports/leadstagereport',
			'tagwisereportpagename': 'reports/tagwisereport',
			'saleswisereportpagename': 'reports/saleswisereport',
			'sourcewisereportpagename': 'reports/sourcewisereport',
			'categorywisereportpagename': 'reports/categorywisereport',
			'personwisereportpagename': 'reports/personwisereport',
			'targetvsachievedreportpagename': 'reports/targetvsachievedreport',
			'callsummaryreportpagename': 'reports/callsummaryreport',
			'callmeetingtargetvsacheivedpagename': 'reports/callmeetingtargetvsacheived',
			'stagewisetargetachievereportpagename': 'reports/stagewisetargetachievereport',
			'sessiontimeout': 'sessiontimeout',
			'crmreport': 'crmreport',
			'crmmapreport': 'reports/locationtrackingreport', // Added for crm map tracking report Aniket Bhesaniya 🛠️  ~ 2025-07-07 ~ 10:08 AM

			// Integration | Deep Dungarani  ~ 2025-04-19 ~ 02:46 PM
			'ssoconfigurationpagename': 'ssoconfiguration',
			'integrationaccountspagename': 'integrationaccounts',
			'checkcalendareventsconflict': 'checkcalendareventsconflict',

			'documentfolder': 'documentfolder',
			'documenttree': 'documentfolder/documenttree',
			'documenttreelist': 'documenttree',
			'shareroute': 'share',
			'employeewisedocument': 'employeewisedocument',

			//  Configuration -> approvals hierarchy
			'approvalshierarchy': 'approvalshierarchy',
			'approvalshierarchyconfig': 'approvalshierarchyconfig',

			'ptreportpagename': 'reports/ptreport', // aman - 24/6/2025

			// Letter Series Master
			'allletterslogpagename': 'allletterslog',

			// Notice Period Policy | Deep Dungarani  ~ 2025-08-25
			'noticeperiodpolicypagename': 'noticeperiodpolicy',
			'noticeperiodrecoverypagename': 'noticeperiodrecovery',
			'exitchecklistpagename': 'exitchecklist',

			// Handover Approval | Deep Dungarani  ~ 2025-09-03 ~ 07:19 PM
			'handoverapprovalspagename': 'handoverapprovals',
			'groupadminrequestapprovalspagename': 'groupadminrequestapprovals',
			'holdsalaryapprovalspagename': 'holdsalaryapprovals',
			'reviewhandoveracknowledgementroute': 'reviewhandoveracknowledgement',
			'reviewhandoverroute': 'reviewhandover',
			'handoverroute': 'handover',


			// kra kpi pagename | Nirzar Gabani 💀 ~  2025-09-05 ~ 10:44 AM
			'kramaster': 'kra',
			'kpimaster': 'kpi',
			'krakpitemplates': 'krakpitemplates',
			'allkraview': 'assignkrakpi',
			'krakpistatus' : 'krakpistatus',

			// Candidate Offer Report | Deep Dungarani  ~ 2025-10-13
			'candidateofferreportpagename': 'reports/candidateofferreports',
			//Performance Manage Page Details Utils | Renish Salakhana 19-12-2025
			'performancemanage':'performance',

			//kailas
			'reviewperformance':'reviewperformance',

			// Review PerFormance | Deep Dungarani  ~ 2025-12-26
			'sendreminderpagename': 'assignperformance/sendreminder',
			'bellcurvegraphdetailspagename': 'assignperformance/bellcurvegraphdetails',
			'bellcurvegraphpagename': 'assignperformance/bellcurvegraph',
			'performancesalaryrevisionspagename': 'assignperformance/salaryrevisions',
			'performanceaddmonthconfigpagename': 'performance/addmonthconfig'
		}

		// to show custom title in header tab | Nirzar Gabani 💀 ~  2025-05-28 ~ 03:32 PM
		this.custompagenamelist = {
			'uploaddocumentpagename': 'Upload Document',
			'whatsappchatpagename': 'Whatsapp Chat',
			'letteracknowledgementpagename': 'Letter Acknowledgement',
			'applicationlistviewpagename': 'Application List View'
		}


		this.sidebarsizeclasses = {
			'sm-sidebar': 'sm-sidebar',
			'md-sidebar': 'md-sidebar',
			'lg-sidebar': 'lg-sidebar',
			'xl-sidebar': 'xl-sidebar'
		}

		// margin classes
		this.marginclasses = {
			'm-auto': 'm-auto',
			'm-0': 'm-0',
			'm-2': 'm-2',
			'm-4': 'm-4',
			'm-6': 'm-6',
			'm-8': 'm-8',
			'm-10': 'm-10',
			'm-12': 'm-12',
			'm-16': 'm-16',
			'm-18': 'm-18',
			'm-20': 'm-20',
			'm-22': 'm-22',
			'm-24': 'm-24',
			'm-26': 'm-26',
			'm-28': 'm-28',
			'm-30': 'm-30',

			'mt-auto': 'mt-auto',
			'mt-0': 'mt-0',
			'mt-2': 'mt-2',
			'mt-4': 'mt-4',
			'mt-6': 'mt-6',
			'mt-8': 'mt-8',
			'mt-10': 'mt-10',
			'mt-12': 'mt-12',
			'mt-16': 'mt-16',
			'mt-18': 'mt-18',
			'mt-20': 'mt-20',
			'mt-22': 'mt-22',
			'mt-24': 'mt-24',
			'mt-26': 'mt-26',
			'mt-28': 'mt-28',
			'mt-30': 'mt-30',

			'mb-auto': 'mb-auto',
			'mb-0': 'mb-0',
			'mb-2': 'mb-2',
			'mb-4': 'mb-4',
			'mb-6': 'mb-6',
			'mb-8': 'mb-8',
			'mb-10': 'mb-10',
			'mb-12': 'mb-12',
			'mt-18': 'mt-18',
			'mt-20': 'mt-20',
			'mt-22': 'mt-22',
			'mt-24': 'mt-24',
			'mt-26': 'mt-26',
			'mt-28': 'mt-28',
			'mt-30': 'mt-30',

			'mr-auto': 'mr-auto',
			'mr-0': 'mr-0',
			'mr-2': 'mr-2',
			'mr-4': 'mr-4',
			'mr-6': 'mr-6',
			'mr-8': 'mr-8',
			'mr-10': 'mr-10',
			'mr-12': 'mr-12',
			'mr-16': 'mr-16',
			'mr-18': 'mr-18',
			'mr-20': 'mr-20',
			'mr-22': 'mr-22',
			'mr-24': 'mr-24',
			'mr-26': 'mr-26',
			'mr-28': 'mr-28',
			'mr-30': 'mr-30',

			'ml-auto': 'ml-auto',
			'ml-0': 'ml-0',
			'ml-2': 'ml-2',
			'ml-4': 'ml-4',
			'ml-6': 'ml-6',
			'ml-8': 'ml-8',
			'ml-10': 'ml-10',
			'ml-12': 'ml-12',
			'ml-16': 'ml-16',
			'ml-18': 'ml-18',
			'ml-20': 'ml-20',
			'ml-22': 'ml-22',
			'ml-24': 'ml-24',
			'ml-26': 'ml-26',
			'ml-28': 'ml-28',
			'ml-30': 'ml-30',

			'my-auto': 'my-auto',
			'my-0': 'my-0',
			'my-2': 'my-2',
			'my-4': 'my-4',
			'my-6': 'my-6',
			'my-8': 'my-8',
			'my-10': 'my-10',
			'my-12': 'my-12',
			'my-16': 'my-16',
			'my-18': 'my-18',
			'my-20': 'my-20',
			'my-22': 'my-22',
			'my-24': 'my-24',
			'my-26': 'my-26',
			'my-28': 'my-28',
			'my-30': 'my-30',

			'mx-auto': 'mx-auto',
			'mx-0': 'mx-0',
			'mx-2': 'mx-2',
			'mx-4': 'mx-4',
			'mx-6': 'mx-6',
			'mx-8': 'mx-8',
			'mx-10': 'mx-10',
			'mx-12': 'mx-12',
			'mx-16': 'mx-16',
			'mx-18': 'mx-18',
			'mx-20': 'mx-20',
			'mx-22': 'mx-22',
			'mx-24': 'mx-24',
			'mx-26': 'mx-26',
			'mx-28': 'mx-28',
			'mx-30': 'mx-30',
		}

		// padding classes 
		this.paddingclasses = {
			'p-auto': 'p-auto',
			'p-0': 'p-0',
			'p-2': 'p-2',
			'p-4': 'p-4',
			'p-6': 'p-6',
			'p-8': 'p-8',
			'p-10': 'p-10',
			'p-12': 'p-12',
			'p-16': 'p-16',
			'p-18': 'p-18',
			'p-20': 'p-20',
			'p-22': 'p-22',
			'p-24': 'p-24',
			'p-26': 'p-26',
			'p-28': 'p-28',
			'p-30': 'p-30',

			'pt-auto': 'pt-auto',
			'pt-0': 'pt-0',
			'pt-2': 'pt-2',
			'pt-4': 'pt-4',
			'pt-6': 'pt-6',
			'pt-8': 'pt-8',
			'pt-10': 'pt-10',
			'pt-12': 'pt-12',
			'pt-16': 'pt-16',
			'pt-18': 'pt-18',
			'pt-20': 'pt-20',
			'pt-22': 'pt-22',
			'pt-24': 'pt-24',
			'pt-26': 'pt-26',
			'pt-28': 'pt-28',
			'pt-30': 'pt-30',

			'pb-auto': 'pb-auto',
			'pb-0': 'pb-0',
			'pb-2': 'pb-2',
			'pb-4': 'pb-4',
			'pb-6': 'pb-6',
			'pb-8': 'pb-8',
			'pb-10': 'pb-10',
			'pb-12': 'pb-12',
			'pb-16': 'pb-16',
			'pb-18': 'pb-18',
			'pb-20': 'pb-20',
			'pb-22': 'pb-22',
			'pb-24': 'pb-24',
			'pb-26': 'pb-26',
			'pb-28': 'pb-28',
			'pb-30': 'pb-30',

			'pr-auto': 'pr-auto',
			'pr-0': 'pr-0',
			'pr-2': 'pr-2',
			'pr-4': 'pr-4',
			'pr-6': 'pr-6',
			'pr-8': 'pr-8',
			'pr-10': 'pr-10',
			'pr-12': 'pr-12',
			'pr-16': 'pr-16',
			'pr-18': 'pr-18',
			'pr-20': 'pr-20',
			'pr-22': 'pr-22',
			'pr-24': 'pr-24',
			'pr-26': 'pr-26',
			'pr-28': 'pr-28',
			'pr-30': 'pr-30',
			
			'pl-auto': 'pl-auto',
			'pl-0': 'pl-0',
			'pl-2': 'pl-2',
			'pl-4': 'pl-4',
			'pl-6': 'pl-6',
			'pl-8': 'pl-8',
			'pl-10': 'pl-10',
			'pl-12': 'pl-12',
			'pl-16': 'pl-16',
			'pl-18': 'pl-18',
			'pl-20': 'pl-20',
			'pl-22': 'pl-22',
			'pl-24': 'pl-24',
			'pl-26': 'pl-26',
			'pl-28': 'pl-28',
			'pl-30': 'pl-30',

			'py-auto': 'py-auto',
			'py-0': 'py-0',
			'py-2': 'py-2',
			'py-4': 'py-4',
			'py-6': 'py-6',
			'py-8': 'py-8',
			'py-10': 'py-10',
			'py-12': 'py-12',
			'py-16': 'py-16',
			'py-18': 'py-18',
			'py-20': 'py-20',
			'py-22': 'py-22',
			'py-24': 'py-24',
			'py-26': 'py-26',
			'py-28': 'py-28',
			'py-30': 'py-30',

			'px-auto': 'px-auto',
			'px-0': 'px-0',
			'px-2': 'px-2',
			'px-4': 'px-4',
			'px-6': 'px-6',
			'px-8': 'px-8',
			'px-10': 'px-10',
			'px-12': 'px-12',
			'px-16': 'px-16',
			'px-18': 'px-18',
			'px-20': 'px-20',
			'px-22': 'px-22',
			'px-24': 'px-24',
			'px-26': 'px-26',
			'px-28': 'px-28',
			'px-30': 'px-30',

		}

		this.priorityseverityclasses = {
			'High': 'high',
			'Medium': 'medium',
			'Low': 'low',
			'None': 'none'
		}

		this.severityTypeclasses = {
			'Conceptual': 'severitytype-conceptual',
			'Functional': 'severitytype-functional',
			'Designing': 'severitytype-designing',
		}

		//payroll
		this.payrollTypeIds = {
			'MonthyFixed': "6239a9f6e7307acecd7048e2",
			'MonthlyDeductable': "6239aa3ce7307acecd7048e4",
			'Daily': "6239aa1ee7307acecd7048e3"
		}

		// record info modal classes 
		this.recordinfomodalsize = this.getModalsizeclasses()['xs']

		this.meetingDuration = [
			{ 'label': '15 Minutes', 'value': 15 },
			{ 'label': '30 Minutes', 'value': 30 },
			{ 'label': '1 hour', 'value': 60 },
			{ 'label': '2 Hour', 'value': 120 },
			{ 'label': '3 Hour', 'value': 180 },
			{ 'label': '4 Hour', 'value': 240 },
			{ 'label': 'All Day', 'value': 1440 },
		]

		//mis action report priority
		this.actionReportPriority = [
			{ 'label': 'High', 'value': 'High' },
			{ 'label': 'Medium', 'value': 'Medium' },
			{ 'label': 'Low', 'value': 'Low' },
		]

		//  | Deep Dungarani  ~ 2025-04-21 ~ 12:24 PM
		this.meetingmedium = [
			{ label: "Microsoft Team", value: 8 },
			// { label: "Zoom", value: 9 },
			// { label: "BIZCOMPASS Chat", value: 13 },
			{ label: "Google Meet", value: 7 },
			// { label: "Skype", value: 14 }
		]

		// Integration Platfrom Array | Deep Dungarani ~ 2025-05-12 ~ 12:31 PM
		this.platformtype = [
			{ 'label': 'Web', 'value': 1 },
			{ 'label': 'Android', 'value': 2 },
			{ 'label': 'iOS', 'value': 3 },
			{ 'label': 'Windows', 'value': 4 },
			{ 'label': 'MacOs', 'value': 5 },
			{ 'label': 'Chat Web', 'value': 6 },
		]

		// Use For Modified Document Data Show in Empoyee360 and myprofile | Deep Dungarani  ~ 2025-07-01 ~ 12:17 PM
		this.requesteddocumentfieldData = ["requesteddata", "requestedname", "requestedaddress", "requesteddocumentnumber", "requesteddateofbirth", "requestedfathername", "requestedmothername", "requestedinstitutionname", "requestedcoursedegreeprogram", "requestedyearofpassing", "requestedsemesteryear", "requestedgradepercentagecgpa", "requestedissuedate", "requestedexpirydate", "requestedregistrationnumber", "requestedexammonthandyear", "requestedremarks", "requesteddocumenttitle", "requesteddescription", "requestedissuingauthority", "requestedsupportingnotes", "requestednationality", "requestedgender", "requestedplaceofissue", "requestedgovernmentdepartment", "requestedsignature"]
	}

	/********************************************************************** Getter && Setter Methods ***********************************************************************/
	getHtmlcontorls() {
		return this.htmlcontorls
	}
	getModalsizeclasses() {
		return this.modalsizeclasses
	}
	getGridclasses() {
		return this.gridclasses
	}
	getSidebarsizeclasses() {
		return this.sidebarsizeclasses
	}
	getMarginclasses() {
		return this.marginclasses
	}
	getPaddingclasses() {
		return this.paddingclasses
	}
	getPrioritySeverityclasses() {
		return this.priorityseverityclasses
	}

	getSeverityTypeclasses() {
		return this.severityTypeclasses
	}

	getErrmsg() {
		return this.errmsg
	}

	getScreeningQue() {
		return this.screeningQue
	}

	getEmailTypes() {
		return this.emailtypes
	}

	getRecordinfomodalsize() {
		return this.recordinfomodalsize
	}

	getRegex() {
		return this.regex
	}

	getMssqldefval() {
		return this.weburl
	}

	getMysqldefval() {
		return this.weburl
	}

	getWeburl() {
		return this.weburl
	}

	setWeburl(weburl) {
		this.weburl = weburl
	}

	getEndpointverson() {
		return this.endpointverson
	}

	setEndpointverson(endpointverson) {
		this.endpointverson = endpointverson
	}

	getEndpointurl() {
		return this.endpointurl
	}

	setEndpointurl(endpointurl) {
		this.endpointurl = endpointurl
	}

	getDocurl() {
		return this.docurl
	}

	setDocurl(docurl) {
		this.docurl = docurl
	}

	getRegdomain() {
		return this.regdomain
	}

	setRegdomain(regdomain) {
		this.regdomain = regdomain
	}

	getMailurl() {
		return this.mailurl
	}

	setMailurl(mailurl) {
		this.mailurl = mailurl
	}

	getProtocol() {
		return this.protocol
	}

	getGreetings() {
		return this.greetingmessages
	}
	getDefaulImageUploadUrl() {
		return this.defaultimageupload
	}
	getDefaultCandidateImageUploadUrl() {
		return this.defaultCanidateimgupload
	}
	getBizcompassUrl() {
		return this.bizcompassurl
	}
	getBizcompassPrivacyPolicyUrl() {                            // Pravin ~ 20-05-2025 ~ 11:34 AM
		return this.bizcompassprivacypolicyurl
	}
	getBizcompassTermsOfUseUrl() {
		return this.bizcompasstermsofuseusrl
	}
	setProtocol(protocol) {
		this.protocol = protocol
	}

	getDocpath() {
		return this.docpath
	}

	setDocpath(docpath) {
		this.docpath = docpath
	}

	getCdnurl() {
		return this.cdnurl
	}

	setCdnurl(cdnurl) {
		this.cdnurl = cdnurl
	}

	getServermode() {
		return this.servermode
	}

	setServermode(servermode) {
		this.servermode = servermode
	}

	getMainDirpath() {
		return this.maindirpath
	}

	setMainDirpath(maindirpath) {
		this.maindirpath = maindirpath
	}

	getDirpath() {
		return this.dirpath
	}

	setDirpath(dirpath) {
		this.dirpath = dirpath
	}

	getMainDB() {
		return this.MainDB
	}

	setMainDB(MainDB) {
		this.MainDB = MainDB
	}

	getDB() {
		return this.DB
	}

	setDB(DB) {
		this.DB = DB
	}

	getMainDBUser() {
		return this.MainDBUser
	}

	setMainDBUser(MainDBUser) {
		this.MainDBUser = MainDBUser
	}

	getDBUser() {
		return this.DBUser
	}

	setDBUser(DBUser) {
		this.DBUser = DBUser
	}

	getMainDBHost() {
		return this.MainDBHost
	}

	setMainDBHost(MainDBHost) {
		this.MainDBHost = MainDBHost
	}

	getDBHost() {
		return this.DBHost
	}

	setDBHost(DBHost) {
		this.DBHost = DBHost
	}

	getMainDBPass() {
		return this.MainDBPass
	}

	setMainDBPass(MainDBPass) {
		this.MainDBPass = MainDBPass
	}

	getDBPass() {
		return this.DBPass
	}

	setDBPass(DBPass) {
		this.DBPass = DBPass
	}

	getMainDBPort() {
		return this.MainDBPort
	}

	setMainDBPort(MainDBPort) {
		this.MainDBPort = MainDBPort
	}

	getDBPort() {
		return this.DBPort
	}

	setDBPort(DBPort) {
		this.DBPort = DBPort
	}

	getDBType() {
		return this.DBType
	}

	setDBType(DBType) {
		this.DBType = DBType
	}

	getSessionName() {
		return this.sessionname
	}

	getAdminutype() {
		return this.adminutype
	}

	getSaveSidebar() {
		return this.savesidebar
	}

	getSubmitbutton() {
		return this.submitbutton
	}

	getGeneratereport() {
		return this.generatereport
	}

	getApplyFilterSidebar() {
		return this.applyfiltersidebar
	}

	getUpdateSidebar() {
		return this.updatesidebar
	}

	getResetSidebar() {
		return this.resetsidebar
	}

	getCloseSidebar() {
		return this.closesidebar
	}

	getUpdateMyProfile() {
		return this.updatemyprofile
	}

	getChangePassword() {
		return this.changepassword
	}


	getSocketserver() {
		return this.socketserver
	}

	getAPISocketserver() {
		return this.apisocketserver
	}

	getFollowupEmailId() {
		return this.followupemail
	}

	getFollowupMessageId() {
		return this.followupmessage
	}

	getFollowupCallId() {
		return this.followupcall
	}

	getPercentageId() {
		return this.percentageid
	}

	getUnAssignedColumnId() {
		return this.unassignedcolumnid
	}

	getCRMCompletedColumnId() {
		return this.crmstatuskanbancompletecolumn
	}
	getCRMOpenColumnId() {
		return this.crmstatuskanbanopencolumn
	}

	// getTestcaseAlias(){
	// 	return this.testcasealias
	// }

	// getLeaveapprovalAlias(){
	// 	return this.leaveapprovalalias
	// }

	getReminderTypeWeekId() {
		return this.remindertypeweeklyid
	}

	//  | Om Z  🌝🌝🌝 ~ 2024-11-07 ~ 04:06 PM
	getTooltip() {
		return this.tooltip
	}

	getDaysName() {
		return this.daysName
	}

	getDaysMasterDataArray() {
		return this.daysMasterData
	}

	getBgColorsArray() {
		return this.bgColorsArray
	}

	getProjectStatusPriorityId() {
		return this.projectStatusPriorityid
	}

	getProjectStatusSeverityId() {
		return this.projectStatusSeverityid
	}

	getLeaveCalendarMessages() {
		return this.leavecalendarmessages
	}

	getMasterTitleName() {
		return this.masterTitleName
	}

	getPayrollTypeids() {
		return this.payrollTypeIds
	}

	getSurveyFormRightSideBarColorArray() {   //  | Utsav ~  2024-12-25 ~ 10:15 AM
		return this.surveyFormRightSideBarColorArray
	}
	getTargetAnalysisColors() {   //  | Utsav ~  2025-01-08 ~ 02:33 PM
		return this.targetAnalysisColors
	}

	getSurveyTypeConsultationId() {
		return this.surveytypeConsultationid
	}

	getEmployeetTypeData() {
		return this.employeetypedata
	}
}
